export const unitCodes: {
  value: string
  title: string
  secondary?: string
}[] = [
  {
    value: "10",
    title: "group",
    secondary: "A unit of count defining the number of groups (group: set of items classified together).",
  },
  {
    value: "11",
    title: "outfit",
    secondary:
      "A unit of count defining the number of outfits (outfit: a complete set of equipment / materials / objects used for a specific purpose).",
  },
  {
    value: "13",
    title: "ration",
    secondary: "A unit of count defining the number of rations (ration: a single portion of provisions).",
  },
  {
    value: "14",
    title: "shot",
    secondary: "A unit of liquid measure, especially related to spirits.",
  },
  {
    value: "15",
    title: "stick, military",
    secondary:
      "A unit of count defining the number of military sticks (military stick: bombs or paratroops released in rapid succession from an aircraft).",
  },
  {
    value: "20",
    title: "twenty foot container",
    secondary: "A unit of count defining the number of shipping containers that measure 20 foot in length.",
  },
  {
    value: "21",
    title: "forty foot container",
    secondary: "A unit of count defining the number of shipping containers that measure 40 foot in length.",
  },
  {
    value: "22",
    title: "decilitre per gram",
    secondary: "",
  },
  {
    value: "23",
    title: "gram per cubic centimetre",
    secondary: "",
  },
  {
    value: "24",
    title: "theoretical pound",
    secondary: "A unit of mass defining the expected mass of material expressed as the number of pounds.",
  },
  {
    value: "25",
    title: "gram per square centimetre",
    secondary: "",
  },
  {
    value: "27",
    title: "theoretical ton",
    secondary: "A unit of mass defining the expected mass of material, expressed as the number of tons.",
  },
  {
    value: "28",
    title: "kilogram per square metre",
    secondary: "",
  },
  {
    value: "33",
    title: "kilopascal square metre per gram",
    secondary: "",
  },
  {
    value: "34",
    title: "kilopascal per millimetre",
    secondary: "",
  },
  {
    value: "35",
    title: "millilitre per square centimetre second",
    secondary: "",
  },
  {
    value: "37",
    title: "ounce per square foot",
    secondary: "",
  },
  {
    value: "38",
    title: "ounce per square foot per 0,01inch",
    secondary: "",
  },
  {
    value: "40",
    title: "millilitre per second",
    secondary: "",
  },
  {
    value: "41",
    title: "millilitre per minute",
    secondary: "",
  },
  {
    value: "56",
    title: "sitas",
    secondary: "A unit of area for tin plate equal to a surface area of 100 square metres.",
  },
  {
    value: "57",
    title: "mesh",
    secondary:
      "A unit of count defining the number of strands per inch as a measure of the fineness of a woven product.",
  },
  {
    value: "58",
    title: "net kilogram",
    secondary: "A unit of mass defining the total number of kilograms after deductions.",
  },
  {
    value: "59",
    title: "part per million",
    secondary: "A unit of proportion equal to 10⁻⁶.",
  },
  {
    value: "60",
    title: "percent weight",
    secondary: "A unit of proportion equal to 10⁻².",
  },
  {
    value: "61",
    title: "part per billion (US)",
    secondary: "A unit of proportion equal to 10⁻⁹.",
  },
  {
    value: "74",
    title: "millipascal",
    secondary: "",
  },
  {
    value: "77",
    title: "milli-inch",
    secondary: "",
  },
  {
    value: "80",
    title: "pound per square inch absolute",
    secondary: "",
  },
  {
    value: "81",
    title: "henry",
    secondary: "",
  },
  {
    value: "85",
    title: "foot pound-force",
    secondary: "",
  },
  {
    value: "87",
    title: "pound per cubic foot",
    secondary: "",
  },
  {
    value: "89",
    title: "poise",
    secondary: "",
  },
  {
    value: "91",
    title: "stokes",
    secondary: "",
  },
  {
    value: "1I",
    title: "fixed rate",
    secondary: "A unit of quantity expressed as a predetermined or set rate for usage of a facility or service.",
  },
  {
    value: "2A",
    title: "radian per second",
    secondary: "Refer ISO/TC12 SI Guide",
  },
  {
    value: "2B",
    title: "radian per second squared",
    secondary: "Refer ISO/TC12 SI Guide",
  },
  {
    value: "2C",
    title: "roentgen",
    secondary: "",
  },
  {
    value: "2G",
    title: "volt AC",
    secondary: "A unit of electric potential in relation to alternating current (AC).",
  },
  {
    value: "2H",
    title: "volt DC",
    secondary: "A unit of electric potential in relation to direct current (DC).",
  },
  {
    value: "2I",
    title: "British thermal unit (international table) per hour",
    secondary: "",
  },
  {
    value: "2J",
    title: "cubic centimetre per second",
    secondary: "",
  },
  {
    value: "2K",
    title: "cubic foot per hour",
    secondary: "",
  },
  {
    value: "2L",
    title: "cubic foot per minute",
    secondary: "",
  },
  {
    value: "2M",
    title: "centimetre per second",
    secondary: "",
  },
  {
    value: "2N",
    title: "decibel",
    secondary: "",
  },
  {
    value: "2P",
    title: "kilobyte",
    secondary: "A unit of information equal to 10³ (1000) bytes.",
  },
  {
    value: "2Q",
    title: "kilobecquerel",
    secondary: "",
  },
  {
    value: "2R",
    title: "kilocurie",
    secondary: "",
  },
  {
    value: "2U",
    title: "megagram",
    secondary: "",
  },
  {
    value: "2X",
    title: "metre per minute",
    secondary: "",
  },
  {
    value: "2Y",
    title: "milliroentgen",
    secondary: "",
  },
  {
    value: "2Z",
    title: "millivolt",
    secondary: "",
  },
  {
    value: "3B",
    title: "megajoule",
    secondary: "",
  },
  {
    value: "3C",
    title: "manmonth",
    secondary: "A unit of count defining the number of months for a person or persons to perform an undertaking.",
  },
  {
    value: "4C",
    title: "centistokes",
    secondary: "",
  },
  {
    value: "4G",
    title: "microlitre",
    secondary: "",
  },
  {
    value: "4H",
    title: "micrometre (micron)",
    secondary: "",
  },
  {
    value: "4K",
    title: "milliampere",
    secondary: "",
  },
  {
    value: "4L",
    title: "megabyte",
    secondary: "A unit of information equal to 10⁶ (1000000) bytes.",
  },
  {
    value: "4M",
    title: "milligram per hour",
    secondary: "",
  },
  {
    value: "4N",
    title: "megabecquerel",
    secondary: "",
  },
  {
    value: "4O",
    title: "microfarad",
    secondary: "",
  },
  {
    value: "4P",
    title: "newton per metre",
    secondary: "",
  },
  {
    value: "4Q",
    title: "ounce inch",
    secondary: "",
  },
  {
    value: "4R",
    title: "ounce foot",
    secondary: "",
  },
  {
    value: "4T",
    title: "picofarad",
    secondary: "",
  },
  {
    value: "4U",
    title: "pound per hour",
    secondary: "",
  },
  {
    value: "4W",
    title: "ton (US) per hour",
    secondary: "",
  },
  {
    value: "4X",
    title: "kilolitre per hour",
    secondary: "",
  },
  {
    value: "5A",
    title: "barrel (US) per minute",
    secondary: "",
  },
  {
    value: "5B",
    title: "batch",
    secondary:
      "A unit of count defining the number of batches (batch: quantity of material produced in one operation or number of animals or persons coming at once).",
  },
  {
    value: "5E",
    title: "MMSCF/day",
    secondary: "A unit of volume equal to one million (1000000) cubic feet of gas per day.",
  },
  {
    value: "5J",
    title: "hydraulic horse power",
    secondary:
      "A unit of power defining the hydraulic horse power delivered by a fluid pump depending on the viscosity of the fluid.",
  },
  {
    value: "A10",
    title: "ampere square metre per joule second",
    secondary: "",
  },
  {
    value: "A11",
    title: "angstrom",
    secondary: "",
  },
  {
    value: "A12",
    title: "astronomical unit",
    secondary: "",
  },
  {
    value: "A13",
    title: "attojoule",
    secondary: "",
  },
  {
    value: "A14",
    title: "barn",
    secondary: "",
  },
  {
    value: "A15",
    title: "barn per electronvolt",
    secondary: "",
  },
  {
    value: "A16",
    title: "barn per steradian electronvolt",
    secondary: "",
  },
  {
    value: "A17",
    title: "barn per steradian",
    secondary: "",
  },
  {
    value: "A18",
    title: "becquerel per kilogram",
    secondary: "",
  },
  {
    value: "A19",
    title: "becquerel per cubic metre",
    secondary: "",
  },
  {
    value: "A2",
    title: "ampere per centimetre",
    secondary: "",
  },
  {
    value: "A20",
    title: "British thermal unit (international table) per second square foot degree Rankine",
    secondary: "",
  },
  {
    value: "A21",
    title: "British thermal unit (international table) per pound degree Rankine",
    secondary: "",
  },
  {
    value: "A22",
    title: "British thermal unit (international table) per second foot degree Rankine",
    secondary: "",
  },
  {
    value: "A23",
    title: "British thermal unit (international table) per hour square foot degree Rankine",
    secondary: "",
  },
  {
    value: "A24",
    title: "candela per square metre",
    secondary: "",
  },
  {
    value: "A26",
    title: "coulomb metre",
    secondary: "",
  },
  {
    value: "A27",
    title: "coulomb metre squared per volt",
    secondary: "",
  },
  {
    value: "A28",
    title: "coulomb per cubic centimetre",
    secondary: "",
  },
  {
    value: "A29",
    title: "coulomb per cubic metre",
    secondary: "",
  },
  {
    value: "A3",
    title: "ampere per millimetre",
    secondary: "",
  },
  {
    value: "A30",
    title: "coulomb per cubic millimetre",
    secondary: "",
  },
  {
    value: "A31",
    title: "coulomb per kilogram second",
    secondary: "",
  },
  {
    value: "A32",
    title: "coulomb per mole",
    secondary: "",
  },
  {
    value: "A33",
    title: "coulomb per square centimetre",
    secondary: "",
  },
  {
    value: "A34",
    title: "coulomb per square metre",
    secondary: "",
  },
  {
    value: "A35",
    title: "coulomb per square millimetre",
    secondary: "",
  },
  {
    value: "A36",
    title: "cubic centimetre per mole",
    secondary: "",
  },
  {
    value: "A37",
    title: "cubic decimetre per mole",
    secondary: "",
  },
  {
    value: "A38",
    title: "cubic metre per coulomb",
    secondary: "",
  },
  {
    value: "A39",
    title: "cubic metre per kilogram",
    secondary: "",
  },
  {
    value: "A4",
    title: "ampere per square centimetre",
    secondary: "",
  },
  {
    value: "A40",
    title: "cubic metre per mole",
    secondary: "",
  },
  {
    value: "A41",
    title: "ampere per square metre",
    secondary: "",
  },
  {
    value: "A42",
    title: "curie per kilogram",
    secondary: "",
  },
  {
    value: "A43",
    title: "deadweight tonnage",
    secondary:
      "A unit of mass defining the difference between the weight of a ship when completely empty and its weight when completely loaded, expressed as the number of tons.",
  },
  {
    value: "A44",
    title: "decalitre",
    secondary: "",
  },
  {
    value: "A45",
    title: "decametre",
    secondary: "",
  },
  {
    value: "A47",
    title: "decitex",
    secondary: "A unit of yarn density. One decitex equals a mass of 1 gram per 10 kilometres of length.",
  },
  {
    value: "A48",
    title: "degree Rankine",
    secondary: "Refer ISO 80000-5 (Quantities and units — Part 5: Thermodynamics)",
  },
  {
    value: "A49",
    title: "denier",
    secondary: "A unit of yarn density. One denier equals a mass of 1 gram per 9 kilometres of length.",
  },
  {
    value: "A5",
    title: "ampere square metre",
    secondary: "",
  },
  {
    value: "A53",
    title: "electronvolt",
    secondary: "",
  },
  {
    value: "A54",
    title: "electronvolt per metre",
    secondary: "",
  },
  {
    value: "A55",
    title: "electronvolt square metre",
    secondary: "",
  },
  {
    value: "A56",
    title: "electronvolt square metre per kilogram",
    secondary: "",
  },
  {
    value: "A59",
    title: "8-part cloud cover",
    secondary:
      "A unit of count defining the number of eighth-parts as a measure of the celestial dome cloud coverage. Synonym: OKTA , OCTA",
  },
  {
    value: "A6",
    title: "ampere per square metre kelvin squared",
    secondary: "",
  },
  {
    value: "A68",
    title: "exajoule",
    secondary: "",
  },
  {
    value: "A69",
    title: "farad per metre",
    secondary: "",
  },
  {
    value: "A7",
    title: "ampere per square millimetre",
    secondary: "",
  },
  {
    value: "A70",
    title: "femtojoule",
    secondary: "",
  },
  {
    value: "A71",
    title: "femtometre",
    secondary: "",
  },
  {
    value: "A73",
    title: "foot per second squared",
    secondary: "",
  },
  {
    value: "A74",
    title: "foot pound-force per second",
    secondary: "",
  },
  {
    value: "A75",
    title: "freight ton",
    secondary:
      "A unit of information typically used for billing purposes, defined as either the number of metric tons or the number of cubic metres, whichever is the larger.",
  },
  {
    value: "A76",
    title: "gal",
    secondary: "",
  },
  {
    value: "A8",
    title: "ampere second",
    secondary: "",
  },
  {
    value: "A84",
    title: "gigacoulomb per cubic metre",
    secondary: "",
  },
  {
    value: "A85",
    title: "gigaelectronvolt",
    secondary: "",
  },
  {
    value: "A86",
    title: "gigahertz",
    secondary: "",
  },
  {
    value: "A87",
    title: "gigaohm",
    secondary: "",
  },
  {
    value: "A88",
    title: "gigaohm metre",
    secondary: "",
  },
  {
    value: "A89",
    title: "gigapascal",
    secondary: "",
  },
  {
    value: "A9",
    title: "rate",
    secondary: "A unit of quantity expressed as a rate for usage of a facility or service.",
  },
  {
    value: "A90",
    title: "gigawatt",
    secondary: "",
  },
  {
    value: "A91",
    title: "gon",
    secondary: "Synonym: grade",
  },
  {
    value: "A93",
    title: "gram per cubic metre",
    secondary: "",
  },
  {
    value: "A94",
    title: "gram per mole",
    secondary: "",
  },
  {
    value: "A95",
    title: "gray",
    secondary: "",
  },
  {
    value: "A96",
    title: "gray per second",
    secondary: "",
  },
  {
    value: "A97",
    title: "hectopascal",
    secondary: "",
  },
  {
    value: "A98",
    title: "henry per metre",
    secondary: "",
  },
  {
    value: "A99",
    title: "bit",
    secondary: "A unit of information equal to one binary digit.",
  },
  {
    value: "AA",
    title: "ball",
    secondary: "A unit of count defining the number of balls (ball: object formed in the shape of sphere).",
  },
  {
    value: "AB",
    title: "bulk pack",
    secondary: "A unit of count defining the number of items per bulk pack.",
  },
  {
    value: "ACR",
    title: "acre",
    secondary: "",
  },
  {
    value: "ACT",
    title: "activity",
    secondary: "A unit of count defining the number of activities (activity: a unit of work or action).",
  },
  {
    value: "AD",
    title: "byte",
    secondary: "A unit of information equal to 8 bits.",
  },
  {
    value: "AE",
    title: "ampere per metre",
    secondary: "",
  },
  {
    value: "AH",
    title: "additional minute",
    secondary: "A unit of time defining the number of minutes in addition to the referenced minutes.",
  },
  {
    value: "AI",
    title: "average minute per call",
    secondary: "A unit of count defining the number of minutes for the average interval of a call.",
  },
  {
    value: "AK",
    title: "fathom",
    secondary: "",
  },
  {
    value: "AL",
    title: "access line",
    secondary: "A unit of count defining the number of telephone access lines.",
  },
  {
    value: "AMH",
    title: "ampere hour",
    secondary:
      "A unit of electric charge defining the amount of charge accumulated by a steady flow of one ampere for one hour.",
  },
  {
    value: "AMP",
    title: "ampere",
    secondary: "",
  },
  {
    value: "ANN",
    title: "year",
    secondary: "Unit of time equal to 365,25 days. Synonym: Julian year",
  },
  {
    value: "APZ",
    title: "troy ounce or apothecary ounce",
    secondary: "",
  },
  {
    value: "AQ",
    title: "anti-hemophilic factor (AHF) unit",
    secondary: "A unit of measure for blood potency (US).",
  },
  {
    value: "AS",
    title: "assortment",
    secondary:
      "A unit of count defining the number of assortments (assortment: set of items grouped in a mixed collection).",
  },
  {
    value: "ASM",
    title: "alcoholic strength by mass",
    secondary: "A unit of mass defining the alcoholic strength of a liquid.",
  },
  {
    value: "ASU",
    title: "alcoholic strength by volume",
    secondary:
      "A unit of volume defining the alcoholic strength of a liquid (e.g. spirit, wine, beer, etc), often at a specific temperature.",
  },
  {
    value: "ATM",
    title: "standard atmosphere",
    secondary: "",
  },
  {
    value: "AWG",
    title: "american wire gauge",
    secondary:
      "A unit of distance used for measuring the diameter of small tubes or wires such as the outer diameter of hypotermic or suture needles.",
  },
  {
    value: "AY",
    title: "assembly",
    secondary: "A unit of count defining the number of assemblies (assembly: items that consist of component parts).",
  },
  {
    value: "AZ",
    title: "British thermal unit (international table) per pound",
    secondary: "",
  },
  {
    value: "B1",
    title: "barrel (US) per day",
    secondary: "",
  },
  {
    value: "B10",
    title: "bit per second",
    secondary: "A unit of information equal to one binary digit per second.",
  },
  {
    value: "B11",
    title: "joule per kilogram kelvin",
    secondary: "",
  },
  {
    value: "B12",
    title: "joule per metre",
    secondary: "",
  },
  {
    value: "B13",
    title: "joule per square metre",
    secondary: "Synonym: joule per metre squared",
  },
  {
    value: "B14",
    title: "joule per metre to the fourth power",
    secondary: "",
  },
  {
    value: "B15",
    title: "joule per mole",
    secondary: "",
  },
  {
    value: "B16",
    title: "joule per mole kelvin",
    secondary: "",
  },
  {
    value: "B17",
    title: "credit",
    secondary: "A unit of count defining the number of entries made to the credit side of an account.",
  },
  {
    value: "B18",
    title: "joule second",
    secondary: "",
  },
  {
    value: "B19",
    title: "digit",
    secondary: "A unit of information defining the quantity of numerals used to form a number.",
  },
  {
    value: "B20",
    title: "joule square metre per kilogram",
    secondary: "",
  },
  {
    value: "B21",
    title: "kelvin per watt",
    secondary: "",
  },
  {
    value: "B22",
    title: "kiloampere",
    secondary: "",
  },
  {
    value: "B23",
    title: "kiloampere per square metre",
    secondary: "",
  },
  {
    value: "B24",
    title: "kiloampere per metre",
    secondary: "",
  },
  {
    value: "B25",
    title: "kilobecquerel per kilogram",
    secondary: "",
  },
  {
    value: "B26",
    title: "kilocoulomb",
    secondary: "",
  },
  {
    value: "B27",
    title: "kilocoulomb per cubic metre",
    secondary: "",
  },
  {
    value: "B28",
    title: "kilocoulomb per square metre",
    secondary: "",
  },
  {
    value: "B29",
    title: "kiloelectronvolt",
    secondary: "",
  },
  {
    value: "B3",
    title: "batting pound",
    secondary: "A unit of mass defining the number of pounds of wadded fibre.",
  },
  {
    value: "B30",
    title: "gibibit",
    secondary: "A unit of information equal to 2³⁰ bits (binary digits).",
  },
  {
    value: "B31",
    title: "kilogram metre per second",
    secondary: "",
  },
  {
    value: "B32",
    title: "kilogram metre squared",
    secondary: "",
  },
  {
    value: "B33",
    title: "kilogram metre squared per second",
    secondary: "",
  },
  {
    value: "B34",
    title: "kilogram per cubic decimetre",
    secondary: "",
  },
  {
    value: "B35",
    title: "kilogram per litre",
    secondary: "",
  },
  {
    value: "B4",
    title: "barrel, imperial",
    secondary: "A unit of volume used to measure beer. One beer barrel equals 36 imperial gallons.",
  },
  {
    value: "B41",
    title: "kilojoule per kelvin",
    secondary: "",
  },
  {
    value: "B42",
    title: "kilojoule per kilogram",
    secondary: "",
  },
  {
    value: "B43",
    title: "kilojoule per kilogram kelvin",
    secondary: "",
  },
  {
    value: "B44",
    title: "kilojoule per mole",
    secondary: "",
  },
  {
    value: "B45",
    title: "kilomole",
    secondary: "",
  },
  {
    value: "B46",
    title: "kilomole per cubic metre",
    secondary: "",
  },
  {
    value: "B47",
    title: "kilonewton",
    secondary: "",
  },
  {
    value: "B48",
    title: "kilonewton metre",
    secondary: "",
  },
  {
    value: "B49",
    title: "kiloohm",
    secondary: "",
  },
  {
    value: "B50",
    title: "kiloohm metre",
    secondary: "",
  },
  {
    value: "B52",
    title: "kilosecond",
    secondary: "",
  },
  {
    value: "B53",
    title: "kilosiemens",
    secondary: "",
  },
  {
    value: "B54",
    title: "kilosiemens per metre",
    secondary: "",
  },
  {
    value: "B55",
    title: "kilovolt per metre",
    secondary: "",
  },
  {
    value: "B56",
    title: "kiloweber per metre",
    secondary: "",
  },
  {
    value: "B57",
    title: "light year",
    secondary: "A unit of length defining the distance that light travels in a vacuum in one year.",
  },
  {
    value: "B58",
    title: "litre per mole",
    secondary: "",
  },
  {
    value: "B59",
    title: "lumen hour",
    secondary: "",
  },
  {
    value: "B60",
    title: "lumen per square metre",
    secondary: "",
  },
  {
    value: "B61",
    title: "lumen per watt",
    secondary: "",
  },
  {
    value: "B62",
    title: "lumen second",
    secondary: "",
  },
  {
    value: "B63",
    title: "lux hour",
    secondary: "",
  },
  {
    value: "B64",
    title: "lux second",
    secondary: "",
  },
  {
    value: "B66",
    title: "megaampere per square metre",
    secondary: "",
  },
  {
    value: "B67",
    title: "megabecquerel per kilogram",
    secondary: "",
  },
  {
    value: "B68",
    title: "gigabit",
    secondary: "A unit of information equal to 10⁹ bits (binary digits).",
  },
  {
    value: "B69",
    title: "megacoulomb per cubic metre",
    secondary: "",
  },
  {
    value: "B7",
    title: "cycle",
    secondary: "A unit of count defining the number of cycles (cycle: a recurrent period of definite duration).",
  },
  {
    value: "B70",
    title: "megacoulomb per square metre",
    secondary: "",
  },
  {
    value: "B71",
    title: "megaelectronvolt",
    secondary: "",
  },
  {
    value: "B72",
    title: "megagram per cubic metre",
    secondary: "",
  },
  {
    value: "B73",
    title: "meganewton",
    secondary: "",
  },
  {
    value: "B74",
    title: "meganewton metre",
    secondary: "",
  },
  {
    value: "B75",
    title: "megaohm",
    secondary: "",
  },
  {
    value: "B76",
    title: "megaohm metre",
    secondary: "",
  },
  {
    value: "B77",
    title: "megasiemens per metre",
    secondary: "",
  },
  {
    value: "B78",
    title: "megavolt",
    secondary: "",
  },
  {
    value: "B79",
    title: "megavolt per metre",
    secondary: "",
  },
  {
    value: "B8",
    title: "joule per cubic metre",
    secondary: "",
  },
  {
    value: "B80",
    title: "gigabit per second",
    secondary: "A unit of information equal to 10⁹ bits (binary digits) per second.",
  },
  {
    value: "B81",
    title: "reciprocal metre squared reciprocal second",
    secondary: "",
  },
  {
    value: "B82",
    title: "inch per linear foot",
    secondary: "A unit of length defining the number of inches per linear foot.",
  },
  {
    value: "B83",
    title: "metre to the fourth power",
    secondary: "",
  },
  {
    value: "B84",
    title: "microampere",
    secondary: "",
  },
  {
    value: "B85",
    title: "microbar",
    secondary: "",
  },
  {
    value: "B86",
    title: "microcoulomb",
    secondary: "",
  },
  {
    value: "B87",
    title: "microcoulomb per cubic metre",
    secondary: "",
  },
  {
    value: "B88",
    title: "microcoulomb per square metre",
    secondary: "",
  },
  {
    value: "B89",
    title: "microfarad per metre",
    secondary: "",
  },
  {
    value: "B90",
    title: "microhenry",
    secondary: "",
  },
  {
    value: "B91",
    title: "microhenry per metre",
    secondary: "",
  },
  {
    value: "B92",
    title: "micronewton",
    secondary: "",
  },
  {
    value: "B93",
    title: "micronewton metre",
    secondary: "",
  },
  {
    value: "B94",
    title: "microohm",
    secondary: "",
  },
  {
    value: "B95",
    title: "microohm metre",
    secondary: "",
  },
  {
    value: "B96",
    title: "micropascal",
    secondary: "",
  },
  {
    value: "B97",
    title: "microradian",
    secondary: "",
  },
  {
    value: "B98",
    title: "microsecond",
    secondary: "",
  },
  {
    value: "B99",
    title: "microsiemens",
    secondary: "",
  },
  {
    value: "BAR",
    title: "bar [unit of pressure]",
    secondary: "",
  },
  {
    value: "BB",
    title: "base box",
    secondary:
      "A unit of area of 112 sheets of tin mil products (tin plate, tin free steel or black plate) 14 by 20 inches, or 31,360 square inches.",
  },
  {
    value: "BFT",
    title: "board foot",
    secondary: "A unit of volume defining the number of cords (cord: a stack of firewood of 128 cubic feet).",
  },
  {
    value: "BHP",
    title: "brake horse power",
    secondary: "",
  },
  {
    value: "BIL",
    title: "billion (EUR)",
    secondary: "Synonym: trillion (US)",
  },
  {
    value: "BLD",
    title: "dry barrel (US)",
    secondary: "",
  },
  {
    value: "BLL",
    title: "barrel (US)",
    secondary: "",
  },
  {
    value: "BP",
    title: "hundred board foot",
    secondary: "A unit of volume equal to one hundred board foot.",
  },
  {
    value: "BPM",
    title: "beats per minute",
    secondary: "The number of beats per minute.",
  },
  {
    value: "BQL",
    title: "becquerel",
    secondary: "",
  },
  {
    value: "BTU",
    title: "British thermal unit (international table)",
    secondary: "",
  },
  {
    value: "BUA",
    title: "bushel (US)",
    secondary: "",
  },
  {
    value: "BUI",
    title: "bushel (UK)",
    secondary: "",
  },
  {
    value: "C0",
    title: "call",
    secondary: "A unit of count defining the number of calls (call: communication session or visitation).",
  },
  {
    value: "C10",
    title: "millifarad",
    secondary: "",
  },
  {
    value: "C11",
    title: "milligal",
    secondary: "",
  },
  {
    value: "C12",
    title: "milligram per metre",
    secondary: "",
  },
  {
    value: "C13",
    title: "milligray",
    secondary: "",
  },
  {
    value: "C14",
    title: "millihenry",
    secondary: "",
  },
  {
    value: "C15",
    title: "millijoule",
    secondary: "",
  },
  {
    value: "C16",
    title: "millimetre per second",
    secondary: "",
  },
  {
    value: "C17",
    title: "millimetre squared per second",
    secondary: "",
  },
  {
    value: "C18",
    title: "millimole",
    secondary: "",
  },
  {
    value: "C19",
    title: "mole per kilogram",
    secondary: "",
  },
  {
    value: "C20",
    title: "millinewton",
    secondary: "",
  },
  {
    value: "C21",
    title: "kibibit",
    secondary: "A unit of information equal to 2¹⁰ (1024) bits (binary digits).",
  },
  {
    value: "C22",
    title: "millinewton per metre",
    secondary: "",
  },
  {
    value: "C23",
    title: "milliohm metre",
    secondary: "",
  },
  {
    value: "C24",
    title: "millipascal second",
    secondary: "",
  },
  {
    value: "C25",
    title: "milliradian",
    secondary: "",
  },
  {
    value: "C26",
    title: "millisecond",
    secondary: "",
  },
  {
    value: "C27",
    title: "millisiemens",
    secondary: "",
  },
  {
    value: "C28",
    title: "millisievert",
    secondary: "",
  },
  {
    value: "C29",
    title: "millitesla",
    secondary: "",
  },
  {
    value: "C3",
    title: "microvolt per metre",
    secondary: "",
  },
  {
    value: "C30",
    title: "millivolt per metre",
    secondary: "",
  },
  {
    value: "C31",
    title: "milliwatt",
    secondary: "",
  },
  {
    value: "C32",
    title: "milliwatt per square metre",
    secondary: "",
  },
  {
    value: "C33",
    title: "milliweber",
    secondary: "",
  },
  {
    value: "C34",
    title: "mole",
    secondary: "",
  },
  {
    value: "C35",
    title: "mole per cubic decimetre",
    secondary: "",
  },
  {
    value: "C36",
    title: "mole per cubic metre",
    secondary: "",
  },
  {
    value: "C37",
    title: "kilobit",
    secondary: "A unit of information equal to 10³ (1000) bits (binary digits).",
  },
  {
    value: "C38",
    title: "mole per litre",
    secondary: "",
  },
  {
    value: "C39",
    title: "nanoampere",
    secondary: "",
  },
  {
    value: "C40",
    title: "nanocoulomb",
    secondary: "",
  },
  {
    value: "C41",
    title: "nanofarad",
    secondary: "",
  },
  {
    value: "C42",
    title: "nanofarad per metre",
    secondary: "",
  },
  {
    value: "C43",
    title: "nanohenry",
    secondary: "",
  },
  {
    value: "C44",
    title: "nanohenry per metre",
    secondary: "",
  },
  {
    value: "C45",
    title: "nanometre",
    secondary: "",
  },
  {
    value: "C46",
    title: "nanoohm metre",
    secondary: "",
  },
  {
    value: "C47",
    title: "nanosecond",
    secondary: "",
  },
  {
    value: "C48",
    title: "nanotesla",
    secondary: "",
  },
  {
    value: "C49",
    title: "nanowatt",
    secondary: "",
  },
  {
    value: "C50",
    title: "neper",
    secondary: "",
  },
  {
    value: "C51",
    title: "neper per second",
    secondary: "",
  },
  {
    value: "C52",
    title: "picometre",
    secondary: "",
  },
  {
    value: "C53",
    title: "newton metre second",
    secondary: "",
  },
  {
    value: "C54",
    title: "newton metre squared per kilogram squared",
    secondary: "",
  },
  {
    value: "C55",
    title: "newton per square metre",
    secondary: "",
  },
  {
    value: "C56",
    title: "newton per square millimetre",
    secondary: "",
  },
  {
    value: "C57",
    title: "newton second",
    secondary: "",
  },
  {
    value: "C58",
    title: "newton second per metre",
    secondary: "",
  },
  {
    value: "C59",
    title: "octave",
    secondary: "A unit used in music to describe the ratio in frequency between notes.",
  },
  {
    value: "C60",
    title: "ohm centimetre",
    secondary: "",
  },
  {
    value: "C61",
    title: "ohm metre",
    secondary: "",
  },
  {
    value: "C62",
    title: "one",
    secondary: "Synonym: unit",
  },
  {
    value: "C63",
    title: "parsec",
    secondary: "",
  },
  {
    value: "C64",
    title: "pascal per kelvin",
    secondary: "",
  },
  {
    value: "C65",
    title: "pascal second",
    secondary: "",
  },
  {
    value: "C66",
    title: "pascal second per cubic metre",
    secondary: "",
  },
  {
    value: "C67",
    title: "pascal second per metre",
    secondary: "",
  },
  {
    value: "C68",
    title: "petajoule",
    secondary: "",
  },
  {
    value: "C69",
    title: "phon",
    secondary:
      "A unit of subjective sound loudness. A sound has loudness p phons if it seems to the listener to be equal in loudness to the sound of a pure tone of frequency 1 kilohertz and strength p decibels.",
  },
  {
    value: "C7",
    title: "centipoise",
    secondary: "",
  },
  {
    value: "C70",
    title: "picoampere",
    secondary: "",
  },
  {
    value: "C71",
    title: "picocoulomb",
    secondary: "",
  },
  {
    value: "C72",
    title: "picofarad per metre",
    secondary: "",
  },
  {
    value: "C73",
    title: "picohenry",
    secondary: "",
  },
  {
    value: "C74",
    title: "kilobit per second",
    secondary: "A unit of information equal to 10³ (1000) bits (binary digits) per second.",
  },
  {
    value: "C75",
    title: "picowatt",
    secondary: "",
  },
  {
    value: "C76",
    title: "picowatt per square metre",
    secondary: "",
  },
  {
    value: "C78",
    title: "pound-force",
    secondary: "",
  },
  {
    value: "C79",
    title: "kilovolt ampere hour",
    secondary: "A unit of accumulated energy of 1000 volt amperes over a period of one hour.",
  },
  {
    value: "C8",
    title: "millicoulomb per kilogram",
    secondary: "",
  },
  {
    value: "C80",
    title: "rad",
    secondary: "",
  },
  {
    value: "C81",
    title: "radian",
    secondary: "",
  },
  {
    value: "C82",
    title: "radian square metre per mole",
    secondary: "",
  },
  {
    value: "C83",
    title: "radian square metre per kilogram",
    secondary: "",
  },
  {
    value: "C84",
    title: "radian per metre",
    secondary: "",
  },
  {
    value: "C85",
    title: "reciprocal angstrom",
    secondary: "",
  },
  {
    value: "C86",
    title: "reciprocal cubic metre",
    secondary: "",
  },
  {
    value: "C87",
    title: "reciprocal cubic metre per second",
    secondary: "Synonym: reciprocal second per cubic metre",
  },
  {
    value: "C88",
    title: "reciprocal electron volt per cubic metre",
    secondary: "",
  },
  {
    value: "C89",
    title: "reciprocal henry",
    secondary: "",
  },
  {
    value: "C9",
    title: "coil group",
    secondary:
      "A unit of count defining the number of coil groups (coil group: groups of items arranged by lengths of those items placed in a joined sequence of concentric circles).",
  },
  {
    value: "C90",
    title: "reciprocal joule per cubic metre",
    secondary: "",
  },
  {
    value: "C91",
    title: "reciprocal kelvin or kelvin to the power minus one",
    secondary: "",
  },
  {
    value: "C92",
    title: "reciprocal metre",
    secondary: "",
  },
  {
    value: "C93",
    title: "reciprocal square metre",
    secondary: "Synonym: reciprocal metre squared",
  },
  {
    value: "C94",
    title: "reciprocal minute",
    secondary: "",
  },
  {
    value: "C95",
    title: "reciprocal mole",
    secondary: "",
  },
  {
    value: "C96",
    title: "reciprocal pascal or pascal to the power minus one",
    secondary: "",
  },
  {
    value: "C97",
    title: "reciprocal second",
    secondary: "",
  },
  {
    value: "C99",
    title: "reciprocal second per metre squared",
    secondary: "",
  },
  {
    value: "CCT",
    title: "carrying capacity in metric ton",
    secondary: "A unit of mass defining the carrying capacity, expressed as the number of metric tons.",
  },
  {
    value: "CDL",
    title: "candela",
    secondary: "",
  },
  {
    value: "CEL",
    title: "degree Celsius",
    secondary: "Refer ISO 80000-5 (Quantities and units — Part 5: Thermodynamics)",
  },
  {
    value: "CEN",
    title: "hundred",
    secondary: "A unit of count defining the number of units in multiples of 100.",
  },
  {
    value: "CG",
    title: "card",
    secondary: "A unit of count defining the number of units of card (card: thick stiff paper or cardboard).",
  },
  {
    value: "CGM",
    title: "centigram",
    secondary: "",
  },
  {
    value: "CKG",
    title: "coulomb per kilogram",
    secondary: "",
  },
  {
    value: "CLF",
    title: "hundred leave",
    secondary: "A unit of count defining the number of leaves, expressed in units of one hundred leaves.",
  },
  {
    value: "CLT",
    title: "centilitre",
    secondary: "",
  },
  {
    value: "CMK",
    title: "square centimetre",
    secondary: "",
  },
  {
    value: "CMQ",
    title: "cubic centimetre",
    secondary: "",
  },
  {
    value: "CMT",
    title: "centimetre",
    secondary: "",
  },
  {
    value: "CNP",
    title: "hundred pack",
    secondary:
      "A unit of count defining the number of hundred-packs (hundred-pack: set of one hundred items packaged together).",
  },
  {
    value: "CNT",
    title: "cental (UK)",
    secondary: "A unit of mass equal to one hundred weight (US).",
  },
  {
    value: "COU",
    title: "coulomb",
    secondary: "",
  },
  {
    value: "CTG",
    title: "content gram",
    secondary: "A unit of mass defining the number of grams of a named item in a product.",
  },
  {
    value: "CTM",
    title: "metric carat",
    secondary: "",
  },
  {
    value: "CTN",
    title: "content ton (metric)",
    secondary: "A unit of mass defining the number of metric tons of a named item in a product.",
  },
  {
    value: "CUR",
    title: "curie",
    secondary: "",
  },
  {
    value: "CWA",
    title: "hundred pound (cwt) / hundred weight (US)",
    secondary: "",
  },
  {
    value: "CWI",
    title: "hundred weight (UK)",
    secondary: "",
  },
  {
    value: "D03",
    title: "kilowatt hour per hour",
    secondary: "A unit of accumulated energy of a thousand watts over a period of one hour.",
  },
  {
    value: "D04",
    title: "lot [unit of weight]",
    secondary: "A unit of weight equal to about 1/2 ounce or 15 grams.",
  },
  {
    value: "D1",
    title: "reciprocal second per steradian",
    secondary: "",
  },
  {
    value: "D10",
    title: "siemens per metre",
    secondary: "",
  },
  {
    value: "D11",
    title: "mebibit",
    secondary: "A unit of information equal to 2²⁰ (1048576) bits (binary digits).",
  },
  {
    value: "D12",
    title: "siemens square metre per mole",
    secondary: "",
  },
  {
    value: "D13",
    title: "sievert",
    secondary: "",
  },
  {
    value: "D15",
    title: "sone",
    secondary:
      "A unit of subjective sound loudness. One sone is the loudness of a pure tone of frequency one kilohertz and strength 40 decibels.",
  },
  {
    value: "D16",
    title: "square centimetre per erg",
    secondary: "",
  },
  {
    value: "D17",
    title: "square centimetre per steradian erg",
    secondary: "",
  },
  {
    value: "D18",
    title: "metre kelvin",
    secondary: "",
  },
  {
    value: "D19",
    title: "square metre kelvin per watt",
    secondary: "",
  },
  {
    value: "D2",
    title: "reciprocal second per steradian metre squared",
    secondary: "",
  },
  {
    value: "D20",
    title: "square metre per joule",
    secondary: "",
  },
  {
    value: "D21",
    title: "square metre per kilogram",
    secondary: "",
  },
  {
    value: "D22",
    title: "square metre per mole",
    secondary: "",
  },
  {
    value: "D23",
    title: "pen gram (protein)",
    secondary: "A unit of count defining the number of grams of amino acid prescribed for parenteral/enteral therapy.",
  },
  {
    value: "D24",
    title: "square metre per steradian",
    secondary: "",
  },
  {
    value: "D25",
    title: "square metre per steradian joule",
    secondary: "",
  },
  {
    value: "D26",
    title: "square metre per volt second",
    secondary: "",
  },
  {
    value: "D27",
    title: "steradian",
    secondary: "",
  },
  {
    value: "D29",
    title: "terahertz",
    secondary: "",
  },
  {
    value: "D30",
    title: "terajoule",
    secondary: "",
  },
  {
    value: "D31",
    title: "terawatt",
    secondary: "",
  },
  {
    value: "D32",
    title: "terawatt hour",
    secondary: "",
  },
  {
    value: "D33",
    title: "tesla",
    secondary: "",
  },
  {
    value: "D34",
    title: "tex",
    secondary: "A unit of yarn density. One decitex equals a mass of 1 gram per 1 kilometre of length.",
  },
  {
    value: "D36",
    title: "megabit",
    secondary: "A unit of information equal to 10⁶ (1000000) bits (binary digits).",
  },
  {
    value: "D41",
    title: "tonne per cubic metre",
    secondary: "",
  },
  {
    value: "D42",
    title: "tropical year",
    secondary: "",
  },
  {
    value: "D43",
    title: "unified atomic mass unit",
    secondary: "",
  },
  {
    value: "D44",
    title: "var",
    secondary: "The name of the unit is an acronym for volt-ampere-reactive.",
  },
  {
    value: "D45",
    title: "volt squared per kelvin squared",
    secondary: "",
  },
  {
    value: "D46",
    title: "volt - ampere",
    secondary: "",
  },
  {
    value: "D47",
    title: "volt per centimetre",
    secondary: "",
  },
  {
    value: "D48",
    title: "volt per kelvin",
    secondary: "",
  },
  {
    value: "D49",
    title: "millivolt per kelvin",
    secondary: "",
  },
  {
    value: "D5",
    title: "kilogram per square centimetre",
    secondary: "",
  },
  {
    value: "D50",
    title: "volt per metre",
    secondary: "",
  },
  {
    value: "D51",
    title: "volt per millimetre",
    secondary: "",
  },
  {
    value: "D52",
    title: "watt per kelvin",
    secondary: "",
  },
  {
    value: "D53",
    title: "watt per metre kelvin",
    secondary: "",
  },
  {
    value: "D54",
    title: "watt per square metre",
    secondary: "",
  },
  {
    value: "D55",
    title: "watt per square metre kelvin",
    secondary: "",
  },
  {
    value: "D56",
    title: "watt per square metre kelvin to the fourth power",
    secondary: "",
  },
  {
    value: "D57",
    title: "watt per steradian",
    secondary: "",
  },
  {
    value: "D58",
    title: "watt per steradian square metre",
    secondary: "",
  },
  {
    value: "D59",
    title: "weber per metre",
    secondary: "",
  },
  {
    value: "D6",
    title: "roentgen per second",
    secondary: "",
  },
  {
    value: "D60",
    title: "weber per millimetre",
    secondary: "",
  },
  {
    value: "D61",
    title: "minute [unit of angle]",
    secondary: "",
  },
  {
    value: "D62",
    title: "second [unit of angle]",
    secondary: "",
  },
  {
    value: "D63",
    title: "book",
    secondary:
      "A unit of count defining the number of books (book: set of items bound together or written document of a material whole).",
  },
  {
    value: "D65",
    title: "round",
    secondary: "A unit of count defining the number of rounds (round: A circular or cylindrical object).",
  },
  {
    value: "D68",
    title: "number of words",
    secondary: "A unit of count defining the number of words.",
  },
  {
    value: "D69",
    title: "inch to the fourth power",
    secondary: "",
  },
  {
    value: "D73",
    title: "joule square metre",
    secondary: "",
  },
  {
    value: "D74",
    title: "kilogram per mole",
    secondary: "",
  },
  {
    value: "D77",
    title: "megacoulomb",
    secondary: "",
  },
  {
    value: "D78",
    title: "megajoule per second",
    secondary: "A unit of accumulated energy equal to one million joules per second.",
  },
  {
    value: "D80",
    title: "microwatt",
    secondary: "",
  },
  {
    value: "D81",
    title: "microtesla",
    secondary: "",
  },
  {
    value: "D82",
    title: "microvolt",
    secondary: "",
  },
  {
    value: "D83",
    title: "millinewton metre",
    secondary: "",
  },
  {
    value: "D85",
    title: "microwatt per square metre",
    secondary: "",
  },
  {
    value: "D86",
    title: "millicoulomb",
    secondary: "",
  },
  {
    value: "D87",
    title: "millimole per kilogram",
    secondary: "",
  },
  {
    value: "D88",
    title: "millicoulomb per cubic metre",
    secondary: "",
  },
  {
    value: "D89",
    title: "millicoulomb per square metre",
    secondary: "",
  },
  {
    value: "D91",
    title: "rem",
    secondary: "",
  },
  {
    value: "D93",
    title: "second per cubic metre",
    secondary: "",
  },
  {
    value: "D94",
    title: "second per cubic metre radian",
    secondary: "",
  },
  {
    value: "D95",
    title: "joule per gram",
    secondary: "",
  },
  {
    value: "DAA",
    title: "decare",
    secondary: "",
  },
  {
    value: "DAD",
    title: "ten day",
    secondary: "A unit of time defining the number of days in multiples of 10.",
  },
  {
    value: "DAY",
    title: "day",
    secondary: "",
  },
  {
    value: "DB",
    title: "dry pound",
    secondary:
      "A unit of mass defining the number of pounds of a product, disregarding the water content of the product.",
  },
  {
    value: "DBM",
    title: "Decibel-milliwatts",
  },
  {
    value: "DBW",
    title: "Decibel watt",
  },
  {
    value: "DD",
    title: "degree [unit of angle]",
    secondary: "",
  },
  {
    value: "DEC",
    title: "decade",
    secondary:
      "A unit of count defining the number of decades (decade: quantity equal to 10 or time equal to 10 years).",
  },
  {
    value: "DG",
    title: "decigram",
    secondary: "",
  },
  {
    value: "DJ",
    title: "decagram",
    secondary: "",
  },
  {
    value: "DLT",
    title: "decilitre",
    secondary: "",
  },
  {
    value: "DMA",
    title: "cubic decametre",
    secondary: "",
  },
  {
    value: "DMK",
    title: "square decimetre",
    secondary: "",
  },
  {
    value: "DMO",
    title: "standard kilolitre",
    secondary:
      "A unit of volume defining the number of kilolitres of a product at a temperature of 15 degrees Celsius, especially in relation to hydrocarbon oils.",
  },
  {
    value: "DMQ",
    title: "cubic decimetre",
    secondary: "",
  },
  {
    value: "DMT",
    title: "decimetre",
    secondary: "",
  },
  {
    value: "DN",
    title: "decinewton metre",
    secondary: "",
  },
  {
    value: "DPC",
    title: "dozen piece",
    secondary:
      "A unit of count defining the number of pieces in multiples of 12 (piece: a single item, article or exemplar).",
  },
  {
    value: "DPR",
    title: "dozen pair",
    secondary: "A unit of count defining the number of pairs in multiples of 12 (pair: item described by two's).",
  },
  {
    value: "DPT",
    title: "displacement tonnage",
    secondary: "A unit of mass defining the volume of sea water a ship displaces, expressed as the number of tons.",
  },
  {
    value: "DRA",
    title: "dram (US)",
    secondary: "Synonym: drachm (UK), troy dram",
  },
  {
    value: "DRI",
    title: "dram (UK)",
    secondary: "Synonym: avoirdupois dram",
  },
  {
    value: "DRL",
    title: "dozen roll",
    secondary: "A unit of count defining the number of rolls, expressed in twelve roll units.",
  },
  {
    value: "DT",
    title: "dry ton",
    secondary:
      "A unit of mass defining the number of tons of a product, disregarding the water content of the product.",
  },
  {
    value: "DTN",
    title: "decitonne",
    secondary: "Synonym: centner, metric 100 kg; quintal, metric 100 kg",
  },
  {
    value: "DWT",
    title: "pennyweight",
    secondary: "",
  },
  {
    value: "DZN",
    title: "dozen",
    secondary: "A unit of count defining the number of units in multiples of 12.",
  },
  {
    value: "DZP",
    title: "dozen pack",
    secondary: "A unit of count defining the number of packs in multiples of 12 (pack: standard packaging unit).",
  },
  {
    value: "E01",
    title: "newton per square centimetre",
    secondary: "A measure of pressure expressed in newtons per square centimetre.",
  },
  {
    value: "E07",
    title: "megawatt hour per hour",
    secondary: "A unit of accumulated energy of a million watts over a period of one hour.",
  },
  {
    value: "E08",
    title: "megawatt per hertz",
    secondary:
      "A unit of energy expressed as the load change in million watts that will cause a frequency shift of one hertz.",
  },
  {
    value: "E09",
    title: "milliampere hour",
    secondary: "A unit of power load delivered at the rate of one thousandth of an ampere over a period of one hour.",
  },
  {
    value: "E10",
    title: "degree day",
    secondary:
      "A unit of measure used in meteorology and engineering to measure the demand for heating or cooling over a given period of days.",
  },
  {
    value: "E12",
    title: "mille",
    secondary: "A unit of count defining the number of cigarettes in units of 1000.",
  },
  {
    value: "E14",
    title: "kilocalorie (international table)",
    secondary: "A unit of heat energy equal to one thousand calories.",
  },
  {
    value: "E15",
    title: "kilocalorie (thermochemical) per hour",
    secondary: "A unit of energy equal to one thousand calories per hour.",
  },
  {
    value: "E16",
    title: "million Btu(IT) per hour",
    secondary: "A unit of power equal to one million British thermal units per hour.",
  },
  {
    value: "E17",
    title: "cubic foot per second",
    secondary: "A unit of volume equal to one cubic foot passing a given point in a period of one second.",
  },
  {
    value: "E18",
    title: "tonne per hour",
    secondary: "A unit of weight or mass equal to one tonne per hour.",
  },
  {
    value: "E19",
    title: "ping",
    secondary: "A unit of area equal to 3.3 square metres.",
  },
  {
    value: "E20",
    title: "megabit per second",
    secondary: "A unit of information equal to 10⁶ (1000000) bits (binary digits) per second.",
  },
  {
    value: "E21",
    title: "shares",
    secondary:
      "A unit of count defining the number of shares (share: a total or portion of the parts into which a business entity’s capital is divided).",
  },
  {
    value: "E22",
    title: "TEU",
    secondary:
      "A unit of count defining the number of twenty-foot equivalent units (TEUs) as a measure of containerized cargo capacity.",
  },
  {
    value: "E23",
    title: "tyre",
    secondary:
      "A unit of count defining the number of tyres (a solid or air-filled covering placed around a wheel rim to form a soft contact with the road, absorb shock and provide traction).",
  },
  {
    value: "E25",
    title: "active unit",
    secondary: "A unit of count defining the number of active units within a substance.",
  },
  {
    value: "E27",
    title: "dose",
    secondary: "A unit of count defining the number of doses (dose: a definite quantity of a medicine or drug).",
  },
  {
    value: "E28",
    title: "air dry ton",
    secondary:
      "A unit of mass defining the number of tons of a product, disregarding the water content of the product.",
  },
  {
    value: "E30",
    title: "strand",
    secondary:
      "A unit of count defining the number of strands (strand: long, thin, flexible, single thread, strip of fibre, constituent filament or multiples of the same, twisted together).",
  },
  {
    value: "E31",
    title: "square metre per litre",
    secondary: "A unit of count defining the number of square metres per litre.",
  },
  {
    value: "E32",
    title: "litre per hour",
    secondary: "A unit of count defining the number of litres per hour.",
  },
  {
    value: "E33",
    title: "foot per thousand",
    secondary: "A unit of count defining the number of feet per thousand units.",
  },
  {
    value: "E34",
    title: "gigabyte",
    secondary: "A unit of information equal to 10⁹ bytes.",
  },
  {
    value: "E35",
    title: "terabyte",
    secondary: "A unit of information equal to 10¹² bytes.",
  },
  {
    value: "E36",
    title: "petabyte",
    secondary: "A unit of information equal to 10¹⁵ bytes.",
  },
  {
    value: "E37",
    title: "pixel",
    secondary: "A unit of count defining the number of pixels (pixel: picture element).",
  },
  {
    value: "E38",
    title: "megapixel",
    secondary: "A unit of count equal to 10⁶ (1000000) pixels (picture elements).",
  },
  {
    value: "E39",
    title: "dots per inch",
    secondary:
      "A unit of information defining the number of dots per linear inch as a measure of the resolution or sharpness of a graphic image.",
  },
  {
    value: "E4",
    title: "gross kilogram",
    secondary: "A unit of mass defining the total number of kilograms before deductions.",
  },
  {
    value: "E40",
    title: "part per hundred thousand",
    secondary: "A unit of proportion equal to 10⁻⁵.",
  },
  {
    value: "E41",
    title: "kilogram-force per square millimetre",
    secondary: "A unit of pressure defining the number of kilograms force per square millimetre.",
  },
  {
    value: "E42",
    title: "kilogram-force per square centimetre",
    secondary: "A unit of pressure defining the number of kilograms force per square centimetre.",
  },
  {
    value: "E43",
    title: "joule per square centimetre",
    secondary: "A unit of energy defining the number of joules per square centimetre.",
  },
  {
    value: "E44",
    title: "kilogram-force metre per square centimetre",
    secondary: "A unit of torsion defining the torque kilogram-force metre per square centimetre.",
  },
  {
    value: "E45",
    title: "milliohm",
    secondary: "",
  },
  {
    value: "E46",
    title: "kilowatt hour per cubic metre",
    secondary: "A unit of energy consumption expressed as kilowatt hour per cubic metre.",
  },
  {
    value: "E47",
    title: "kilowatt hour per kelvin",
    secondary: "A unit of energy consumption expressed as kilowatt hour per kelvin.",
  },
  {
    value: "E48",
    title: "service unit",
    secondary:
      "A unit of count defining the number of service units (service unit: defined period / property / facility / utility of supply).",
  },
  {
    value: "E49",
    title: "working day",
    secondary:
      "A unit of count defining the number of working days (working day: a day on which work is ordinarily performed).",
  },
  {
    value: "E50",
    title: "accounting unit",
    secondary: "A unit of count defining the number of accounting units.",
  },
  {
    value: "E51",
    title: "job",
    secondary: "A unit of count defining the number of jobs.",
  },
  {
    value: "E52",
    title: "run foot",
    secondary: "A unit of count defining the number feet per run.",
  },
  {
    value: "E53",
    title: "test",
    secondary: "A unit of count defining the number of tests.",
  },
  {
    value: "E54",
    title: "trip",
    secondary: "A unit of count defining the number of trips.",
  },
  {
    value: "E55",
    title: "use",
    secondary: "A unit of count defining the number of times an object is used.",
  },
  {
    value: "E56",
    title: "well",
    secondary: "A unit of count defining the number of wells.",
  },
  {
    value: "E57",
    title: "zone",
    secondary: "A unit of count defining the number of zones.",
  },
  {
    value: "E58",
    title: "exabit per second",
    secondary: "A unit of information equal to 10¹⁸ bits (binary digits) per second.",
  },
  {
    value: "E59",
    title: "exbibyte",
    secondary: "A unit of information equal to 2⁶⁰ bytes.",
  },
  {
    value: "E60",
    title: "pebibyte",
    secondary: "A unit of information equal to 2⁵⁰ bytes.",
  },
  {
    value: "E61",
    title: "tebibyte",
    secondary: "A unit of information equal to 2⁴⁰ bytes.",
  },
  {
    value: "E62",
    title: "gibibyte",
    secondary: "A unit of information equal to 2³⁰ bytes.",
  },
  {
    value: "E63",
    title: "mebibyte",
    secondary: "A unit of information equal to 2²⁰ bytes.",
  },
  {
    value: "E64",
    title: "kibibyte",
    secondary: "A unit of information equal to 2¹⁰ bytes.",
  },
  {
    value: "E65",
    title: "exbibit per metre",
    secondary: "A unit of information equal to 2⁶⁰ bits (binary digits) per metre.",
  },
  {
    value: "E66",
    title: "exbibit per square metre",
    secondary: "A unit of information equal to 2⁶⁰ bits (binary digits) per square metre.",
  },
  {
    value: "E67",
    title: "exbibit per cubic metre",
    secondary: "A unit of information equal to 2⁶⁰ bits (binary digits) per cubic metre.",
  },
  {
    value: "E68",
    title: "gigabyte per second",
    secondary: "A unit of information equal to 10⁹ bytes per second.",
  },
  {
    value: "E69",
    title: "gibibit per metre",
    secondary: "A unit of information equal to 2³⁰ bits (binary digits) per metre.",
  },
  {
    value: "E70",
    title: "gibibit per square metre",
    secondary: "A unit of information equal to 2³⁰ bits (binary digits) per square metre.",
  },
  {
    value: "E71",
    title: "gibibit per cubic metre",
    secondary: "A unit of information equal to 2³⁰ bits (binary digits) per cubic metre.",
  },
  {
    value: "E72",
    title: "kibibit per metre",
    secondary: "A unit of information equal to 2¹⁰ bits (binary digits) per metre.",
  },
  {
    value: "E73",
    title: "kibibit per square metre",
    secondary: "A unit of information equal to 2¹⁰ bits (binary digits) per square metre.",
  },
  {
    value: "E74",
    title: "kibibit per cubic metre",
    secondary: "A unit of information equal to 2¹⁰ bits (binary digits) per cubic metre.",
  },
  {
    value: "E75",
    title: "mebibit per metre",
    secondary: "A unit of information equal to 2²⁰ bits (binary digits) per metre.",
  },
  {
    value: "E76",
    title: "mebibit per square metre",
    secondary: "A unit of information equal to 2²⁰ bits (binary digits) per square metre.",
  },
  {
    value: "E77",
    title: "mebibit per cubic metre",
    secondary: "A unit of information equal to 2²⁰ bits (binary digits) per cubic metre.",
  },
  {
    value: "E78",
    title: "petabit",
    secondary: "A unit of information equal to 10¹⁵ bits (binary digits).",
  },
  {
    value: "E79",
    title: "petabit per second",
    secondary: "A unit of information equal to 10¹⁵ bits (binary digits) per second.",
  },
  {
    value: "E80",
    title: "pebibit per metre",
    secondary: "A unit of information equal to 2⁵⁰ bits (binary digits) per metre.",
  },
  {
    value: "E81",
    title: "pebibit per square metre",
    secondary: "A unit of information equal to 2⁵⁰ bits (binary digits) per square metre.",
  },
  {
    value: "E82",
    title: "pebibit per cubic metre",
    secondary: "A unit of information equal to 2⁵⁰ bits (binary digits) per cubic metre.",
  },
  {
    value: "E83",
    title: "terabit",
    secondary: "A unit of information equal to 10¹² bits (binary digits).",
  },
  {
    value: "E84",
    title: "terabit per second",
    secondary: "A unit of information equal to 10¹² bits (binary digits) per second.",
  },
  {
    value: "E85",
    title: "tebibit per metre",
    secondary: "A unit of information equal to 2⁴⁰ bits (binary digits) per metre.",
  },
  {
    value: "E86",
    title: "tebibit per cubic metre",
    secondary: "A unit of information equal to 2⁴⁰ bits (binary digits) per cubic metre.",
  },
  {
    value: "E87",
    title: "tebibit per square metre",
    secondary: "A unit of information equal to 2⁴⁰ bits (binary digits) per square metre.",
  },
  {
    value: "E88",
    title: "bit per metre",
    secondary: "A unit of information equal to 1 bit (binary digit) per metre.",
  },
  {
    value: "E89",
    title: "bit per square metre",
    secondary: "A unit of information equal to 1 bit (binary digit) per square metre.",
  },
  {
    value: "E90",
    title: "reciprocal centimetre",
    secondary: "",
  },
  {
    value: "E91",
    title: "reciprocal day",
    secondary: "",
  },
  {
    value: "E92",
    title: "cubic decimetre per hour",
    secondary: "",
  },
  {
    value: "E93",
    title: "kilogram per hour",
    secondary: "",
  },
  {
    value: "E94",
    title: "kilomole per second",
    secondary: "",
  },
  {
    value: "E95",
    title: "mole per second",
    secondary: "",
  },
  {
    value: "E96",
    title: "degree per second",
    secondary: "",
  },
  {
    value: "E97",
    title: "millimetre per degree Celcius metre",
    secondary: "",
  },
  {
    value: "E98",
    title: "degree Celsius per kelvin",
    secondary: "",
  },
  {
    value: "E99",
    title: "hectopascal per bar",
    secondary: "",
  },
  {
    value: "EA",
    title: "each",
    secondary: "A unit of count defining the number of items regarded as separate units.",
  },
  {
    value: "EB",
    title: "electronic mail box",
    secondary: "A unit of count defining the number of electronic mail boxes.",
  },
  {
    value: "EQ",
    title: "equivalent gallon",
    secondary: "A unit of volume defining the number of gallons of product produced from concentrate.",
  },
  {
    value: "F01",
    title: "bit per cubic metre",
    secondary: "A unit of information equal to 1 bit (binary digit) per cubic metre.",
  },
  {
    value: "F02",
    title: "kelvin per kelvin",
    secondary: "",
  },
  {
    value: "F03",
    title: "kilopascal per bar",
    secondary: "",
  },
  {
    value: "F04",
    title: "millibar per bar",
    secondary: "",
  },
  {
    value: "F05",
    title: "megapascal per bar",
    secondary: "",
  },
  {
    value: "F06",
    title: "poise per bar",
    secondary: "",
  },
  {
    value: "F07",
    title: "pascal per bar",
    secondary: "",
  },
  {
    value: "F08",
    title: "milliampere per inch",
    secondary: "",
  },
  {
    value: "F10",
    title: "kelvin per hour",
    secondary: "",
  },
  {
    value: "F11",
    title: "kelvin per minute",
    secondary: "",
  },
  {
    value: "F12",
    title: "kelvin per second",
    secondary: "",
  },
  {
    value: "F13",
    title: "slug",
    secondary:
      "A unit of mass. One slug is the mass accelerated at 1 foot per second per second by a force of 1 pound.",
  },
  {
    value: "F14",
    title: "gram per kelvin",
    secondary: "",
  },
  {
    value: "F15",
    title: "kilogram per kelvin",
    secondary: "",
  },
  {
    value: "F16",
    title: "milligram per kelvin",
    secondary: "",
  },
  {
    value: "F17",
    title: "pound-force per foot",
    secondary: "",
  },
  {
    value: "F18",
    title: "kilogram square centimetre",
    secondary: "",
  },
  {
    value: "F19",
    title: "kilogram square millimetre",
    secondary: "",
  },
  {
    value: "F20",
    title: "pound inch squared",
    secondary: "",
  },
  {
    value: "F21",
    title: "pound-force inch",
    secondary: "",
  },
  {
    value: "F22",
    title: "pound-force foot per ampere",
    secondary: "",
  },
  {
    value: "F23",
    title: "gram per cubic decimetre",
    secondary: "",
  },
  {
    value: "F24",
    title: "kilogram per kilomol",
    secondary: "",
  },
  {
    value: "F25",
    title: "gram per hertz",
    secondary: "",
  },
  {
    value: "F26",
    title: "gram per day",
    secondary: "",
  },
  {
    value: "F27",
    title: "gram per hour",
    secondary: "",
  },
  {
    value: "F28",
    title: "gram per minute",
    secondary: "",
  },
  {
    value: "F29",
    title: "gram per second",
    secondary: "",
  },
  {
    value: "F30",
    title: "kilogram per day",
    secondary: "",
  },
  {
    value: "F31",
    title: "kilogram per minute",
    secondary: "",
  },
  {
    value: "F32",
    title: "milligram per day",
    secondary: "",
  },
  {
    value: "F33",
    title: "milligram per minute",
    secondary: "",
  },
  {
    value: "F34",
    title: "milligram per second",
    secondary: "",
  },
  {
    value: "F35",
    title: "gram per day kelvin",
    secondary: "",
  },
  {
    value: "F36",
    title: "gram per hour kelvin",
    secondary: "",
  },
  {
    value: "F37",
    title: "gram per minute kelvin",
    secondary: "",
  },
  {
    value: "F38",
    title: "gram per second kelvin",
    secondary: "",
  },
  {
    value: "F39",
    title: "kilogram per day kelvin",
    secondary: "",
  },
  {
    value: "F40",
    title: "kilogram per hour kelvin",
    secondary: "",
  },
  {
    value: "F41",
    title: "kilogram per minute kelvin",
    secondary: "",
  },
  {
    value: "F42",
    title: "kilogram per second kelvin",
    secondary: "",
  },
  {
    value: "F43",
    title: "milligram per day kelvin",
    secondary: "",
  },
  {
    value: "F44",
    title: "milligram per hour kelvin",
    secondary: "",
  },
  {
    value: "F45",
    title: "milligram per minute kelvin",
    secondary: "",
  },
  {
    value: "F46",
    title: "milligram per second kelvin",
    secondary: "",
  },
  {
    value: "F47",
    title: "newton per millimetre",
    secondary: "",
  },
  {
    value: "F48",
    title: "pound-force per inch",
    secondary: "",
  },
  {
    value: "F49",
    title: "rod [unit of distance]",
    secondary: "A unit of distance equal to 5.5 yards (16 feet 6 inches).",
  },
  {
    value: "F50",
    title: "micrometre per kelvin",
    secondary: "",
  },
  {
    value: "F51",
    title: "centimetre per kelvin",
    secondary: "",
  },
  {
    value: "F52",
    title: "metre per kelvin",
    secondary: "",
  },
  {
    value: "F53",
    title: "millimetre per kelvin",
    secondary: "",
  },
  {
    value: "F54",
    title: "milliohm per metre",
    secondary: "",
  },
  {
    value: "F55",
    title: "ohm per mile (statute mile)",
    secondary: "",
  },
  {
    value: "F56",
    title: "ohm per kilometre",
    secondary: "",
  },
  {
    value: "F57",
    title: "milliampere per pound-force per square inch",
    secondary: "",
  },
  {
    value: "F58",
    title: "reciprocal bar",
    secondary: "",
  },
  {
    value: "F59",
    title: "milliampere per bar",
    secondary: "",
  },
  {
    value: "F60",
    title: "degree Celsius per bar",
    secondary: "",
  },
  {
    value: "F61",
    title: "kelvin per bar",
    secondary: "",
  },
  {
    value: "F62",
    title: "gram per day bar",
    secondary: "",
  },
  {
    value: "F63",
    title: "gram per hour bar",
    secondary: "",
  },
  {
    value: "F64",
    title: "gram per minute bar",
    secondary: "",
  },
  {
    value: "F65",
    title: "gram per second bar",
    secondary: "",
  },
  {
    value: "F66",
    title: "kilogram per day bar",
    secondary: "",
  },
  {
    value: "F67",
    title: "kilogram per hour bar",
    secondary: "",
  },
  {
    value: "F68",
    title: "kilogram per minute bar",
    secondary: "",
  },
  {
    value: "F69",
    title: "kilogram per second bar",
    secondary: "",
  },
  {
    value: "F70",
    title: "milligram per day bar",
    secondary: "",
  },
  {
    value: "F71",
    title: "milligram per hour bar",
    secondary: "",
  },
  {
    value: "F72",
    title: "milligram per minute bar",
    secondary: "",
  },
  {
    value: "F73",
    title: "milligram per second bar",
    secondary: "",
  },
  {
    value: "F74",
    title: "gram per bar",
    secondary: "",
  },
  {
    value: "F75",
    title: "milligram per bar",
    secondary: "",
  },
  {
    value: "F76",
    title: "milliampere per millimetre",
    secondary: "",
  },
  {
    value: "F77",
    title: "pascal second per kelvin",
    secondary: "",
  },
  {
    value: "F78",
    title: "inch of water",
    secondary: "",
  },
  {
    value: "F79",
    title: "inch of mercury",
    secondary: "",
  },
  {
    value: "F80",
    title: "water horse power",
    secondary:
      "A unit of power defining the amount of power required to move a given volume of water against acceleration of gravity to a specified elevation (pressure head).",
  },
  {
    value: "F81",
    title: "bar per kelvin",
    secondary: "",
  },
  {
    value: "F82",
    title: "hectopascal per kelvin",
    secondary: "",
  },
  {
    value: "F83",
    title: "kilopascal per kelvin",
    secondary: "",
  },
  {
    value: "F84",
    title: "millibar per kelvin",
    secondary: "",
  },
  {
    value: "F85",
    title: "megapascal per kelvin",
    secondary: "",
  },
  {
    value: "F86",
    title: "poise per kelvin",
    secondary: "",
  },
  {
    value: "F87",
    title: "volt per litre minute",
    secondary: "",
  },
  {
    value: "F88",
    title: "newton centimetre",
    secondary: "",
  },
  {
    value: "F89",
    title: "newton metre per degree",
    secondary: "",
  },
  {
    value: "F90",
    title: "newton metre per ampere",
    secondary: "",
  },
  {
    value: "F91",
    title: "bar litre per second",
    secondary: "",
  },
  {
    value: "F92",
    title: "bar cubic metre per second",
    secondary: "",
  },
  {
    value: "F93",
    title: "hectopascal litre per second",
    secondary: "",
  },
  {
    value: "F94",
    title: "hectopascal cubic metre per second",
    secondary: "",
  },
  {
    value: "F95",
    title: "millibar litre per second",
    secondary: "",
  },
  {
    value: "F96",
    title: "millibar cubic metre per second",
    secondary: "",
  },
  {
    value: "F97",
    title: "megapascal litre per second",
    secondary: "",
  },
  {
    value: "F98",
    title: "megapascal cubic metre per second",
    secondary: "",
  },
  {
    value: "F99",
    title: "pascal litre per second",
    secondary: "",
  },
  {
    value: "FAH",
    title: "degree Fahrenheit",
    secondary: "Refer ISO 80000-5 (Quantities and units — Part 5: Thermodynamics)",
  },
  {
    value: "FAR",
    title: "farad",
    secondary: "",
  },
  {
    value: "FBM",
    title: "fibre metre",
    secondary: "A unit of length defining the number of metres of individual fibre.",
  },
  {
    value: "FC",
    title: "thousand cubic foot",
    secondary: "A unit of volume equal to one thousand cubic foot.",
  },
  {
    value: "FF",
    title: "hundred cubic metre",
    secondary: "A unit of volume equal to one hundred cubic metres.",
  },
  {
    value: "FH",
    title: "micromole",
    secondary: "",
  },
  {
    value: "FIT",
    title: "failures in time",
    secondary:
      "A unit of count defining the number of failures that can be expected over a specified time interval. Failure rates of semiconductor components are often specified as FIT (failures in time unit) where 1 FIT = 10⁻⁹ /h.",
  },
  {
    value: "FL",
    title: "flake ton",
    secondary: "A unit of mass defining the number of tons of a flaked substance (flake: a small flattish fragment).",
  },
  {
    value: "FNU",
    title: "Formazin nephelometric unit",
  },
  {
    value: "FOT",
    title: "foot",
    secondary: "",
  },
  {
    value: "FP",
    title: "pound per square foot",
    secondary: "",
  },
  {
    value: "FR",
    title: "foot per minute",
    secondary: "",
  },
  {
    value: "FS",
    title: "foot per second",
    secondary: "",
  },
  {
    value: "FTK",
    title: "square foot",
    secondary: "",
  },
  {
    value: "FTQ",
    title: "cubic foot",
    secondary: "",
  },
  {
    value: "G01",
    title: "pascal cubic metre per second",
    secondary: "",
  },
  {
    value: "G04",
    title: "centimetre per bar",
    secondary: "",
  },
  {
    value: "G05",
    title: "metre per bar",
    secondary: "",
  },
  {
    value: "G06",
    title: "millimetre per bar",
    secondary: "",
  },
  {
    value: "G08",
    title: "square inch per second",
    secondary: "",
  },
  {
    value: "G09",
    title: "square metre per second kelvin",
    secondary: "",
  },
  {
    value: "G10",
    title: "stokes per kelvin",
    secondary: "",
  },
  {
    value: "G11",
    title: "gram per cubic centimetre bar",
    secondary: "",
  },
  {
    value: "G12",
    title: "gram per cubic decimetre bar",
    secondary: "",
  },
  {
    value: "G13",
    title: "gram per litre bar",
    secondary: "",
  },
  {
    value: "G14",
    title: "gram per cubic metre bar",
    secondary: "",
  },
  {
    value: "G15",
    title: "gram per millilitre bar",
    secondary: "",
  },
  {
    value: "G16",
    title: "kilogram per cubic centimetre bar",
    secondary: "",
  },
  {
    value: "G17",
    title: "kilogram per litre bar",
    secondary: "",
  },
  {
    value: "G18",
    title: "kilogram per cubic metre bar",
    secondary: "",
  },
  {
    value: "G19",
    title: "newton metre per kilogram",
    secondary: "",
  },
  {
    value: "G2",
    title: "US gallon per minute",
    secondary: "",
  },
  {
    value: "G20",
    title: "pound-force foot per pound",
    secondary: "",
  },
  {
    value: "G21",
    title: "cup [unit of volume]",
    secondary: "",
  },
  {
    value: "G23",
    title: "peck",
    secondary: "",
  },
  {
    value: "G24",
    title: "tablespoon (US)",
    secondary: "",
  },
  {
    value: "G25",
    title: "teaspoon (US)",
    secondary: "",
  },
  {
    value: "G26",
    title: "stere",
    secondary: "",
  },
  {
    value: "G27",
    title: "cubic centimetre per kelvin",
    secondary: "",
  },
  {
    value: "G28",
    title: "litre per kelvin",
    secondary: "",
  },
  {
    value: "G29",
    title: "cubic metre per kelvin",
    secondary: "",
  },
  {
    value: "G3",
    title: "Imperial gallon per minute",
    secondary: "",
  },
  {
    value: "G30",
    title: "millilitre per kelvin",
    secondary: "",
  },
  {
    value: "G31",
    title: "kilogram per cubic centimetre",
    secondary: "",
  },
  {
    value: "G32",
    title: "ounce (avoirdupois) per cubic yard",
    secondary: "",
  },
  {
    value: "G33",
    title: "gram per cubic centimetre kelvin",
    secondary: "",
  },
  {
    value: "G34",
    title: "gram per cubic decimetre kelvin",
    secondary: "",
  },
  {
    value: "G35",
    title: "gram per litre kelvin",
    secondary: "",
  },
  {
    value: "G36",
    title: "gram per cubic metre kelvin",
    secondary: "",
  },
  {
    value: "G37",
    title: "gram per millilitre kelvin",
    secondary: "",
  },
  {
    value: "G38",
    title: "kilogram per cubic centimetre kelvin",
    secondary: "",
  },
  {
    value: "G39",
    title: "kilogram per litre kelvin",
    secondary: "",
  },
  {
    value: "G40",
    title: "kilogram per cubic metre kelvin",
    secondary: "",
  },
  {
    value: "G41",
    title: "square metre per second bar",
    secondary: "",
  },
  {
    value: "G42",
    title: "microsiemens per centimetre",
    secondary: "",
  },
  {
    value: "G43",
    title: "microsiemens per metre",
    secondary: "",
  },
  {
    value: "G44",
    title: "nanosiemens per centimetre",
    secondary: "",
  },
  {
    value: "G45",
    title: "nanosiemens per metre",
    secondary: "",
  },
  {
    value: "G46",
    title: "stokes per bar",
    secondary: "",
  },
  {
    value: "G47",
    title: "cubic centimetre per day",
    secondary: "",
  },
  {
    value: "G48",
    title: "cubic centimetre per hour",
    secondary: "",
  },
  {
    value: "G49",
    title: "cubic centimetre per minute",
    secondary: "",
  },
  {
    value: "G50",
    title: "gallon (US) per hour",
    secondary: "",
  },
  {
    value: "G51",
    title: "litre per second",
    secondary: "",
  },
  {
    value: "G52",
    title: "cubic metre per day",
    secondary: "",
  },
  {
    value: "G53",
    title: "cubic metre per minute",
    secondary: "",
  },
  {
    value: "G54",
    title: "millilitre per day",
    secondary: "",
  },
  {
    value: "G55",
    title: "millilitre per hour",
    secondary: "",
  },
  {
    value: "G56",
    title: "cubic inch per hour",
    secondary: "",
  },
  {
    value: "G57",
    title: "cubic inch per minute",
    secondary: "",
  },
  {
    value: "G58",
    title: "cubic inch per second",
    secondary: "",
  },
  {
    value: "G59",
    title: "milliampere per litre minute",
    secondary: "",
  },
  {
    value: "G60",
    title: "volt per bar",
    secondary: "",
  },
  {
    value: "G61",
    title: "cubic centimetre per day kelvin",
    secondary: "",
  },
  {
    value: "G62",
    title: "cubic centimetre per hour kelvin",
    secondary: "",
  },
  {
    value: "G63",
    title: "cubic centimetre per minute kelvin",
    secondary: "",
  },
  {
    value: "G64",
    title: "cubic centimetre per second kelvin",
    secondary: "",
  },
  {
    value: "G65",
    title: "litre per day kelvin",
    secondary: "",
  },
  {
    value: "G66",
    title: "litre per hour kelvin",
    secondary: "",
  },
  {
    value: "G67",
    title: "litre per minute kelvin",
    secondary: "",
  },
  {
    value: "G68",
    title: "litre per second kelvin",
    secondary: "",
  },
  {
    value: "G69",
    title: "cubic metre per day kelvin",
    secondary: "",
  },
  {
    value: "G70",
    title: "cubic metre per hour kelvin",
    secondary: "",
  },
  {
    value: "G71",
    title: "cubic metre per minute kelvin",
    secondary: "",
  },
  {
    value: "G72",
    title: "cubic metre per second kelvin",
    secondary: "",
  },
  {
    value: "G73",
    title: "millilitre per day kelvin",
    secondary: "",
  },
  {
    value: "G74",
    title: "millilitre per hour kelvin",
    secondary: "",
  },
  {
    value: "G75",
    title: "millilitre per minute kelvin",
    secondary: "",
  },
  {
    value: "G76",
    title: "millilitre per second kelvin",
    secondary: "",
  },
  {
    value: "G77",
    title: "millimetre to the fourth power",
    secondary: "",
  },
  {
    value: "G78",
    title: "cubic centimetre per day bar",
    secondary: "",
  },
  {
    value: "G79",
    title: "cubic centimetre per hour bar",
    secondary: "",
  },
  {
    value: "G80",
    title: "cubic centimetre per minute bar",
    secondary: "",
  },
  {
    value: "G81",
    title: "cubic centimetre per second bar",
    secondary: "",
  },
  {
    value: "G82",
    title: "litre per day bar",
    secondary: "",
  },
  {
    value: "G83",
    title: "litre per hour bar",
    secondary: "",
  },
  {
    value: "G84",
    title: "litre per minute bar",
    secondary: "",
  },
  {
    value: "G85",
    title: "litre per second bar",
    secondary: "",
  },
  {
    value: "G86",
    title: "cubic metre per day bar",
    secondary: "",
  },
  {
    value: "G87",
    title: "cubic metre per hour bar",
    secondary: "",
  },
  {
    value: "G88",
    title: "cubic metre per minute bar",
    secondary: "",
  },
  {
    value: "G89",
    title: "cubic metre per second bar",
    secondary: "",
  },
  {
    value: "G90",
    title: "millilitre per day bar",
    secondary: "",
  },
  {
    value: "G91",
    title: "millilitre per hour bar",
    secondary: "",
  },
  {
    value: "G92",
    title: "millilitre per minute bar",
    secondary: "",
  },
  {
    value: "G93",
    title: "millilitre per second bar",
    secondary: "",
  },
  {
    value: "G94",
    title: "cubic centimetre per bar",
    secondary: "",
  },
  {
    value: "G95",
    title: "litre per bar",
    secondary: "",
  },
  {
    value: "G96",
    title: "cubic metre per bar",
    secondary: "",
  },
  {
    value: "G97",
    title: "millilitre per bar",
    secondary: "",
  },
  {
    value: "G98",
    title: "microhenry per kiloohm",
    secondary: "",
  },
  {
    value: "G99",
    title: "microhenry per ohm",
    secondary: "",
  },
  {
    value: "GB",
    title: "gallon (US) per day",
    secondary: "",
  },
  {
    value: "GBQ",
    title: "gigabecquerel",
    secondary: "",
  },
  {
    value: "GDW",
    title: "gram, dry weight",
    secondary:
      "A unit of mass defining the number of grams of a product, disregarding the water content of the product.",
  },
  {
    value: "GE",
    title: "pound per gallon (US)",
    secondary: "",
  },
  {
    value: "GF",
    title: "gram per metre (gram per 100 centimetres)",
    secondary: "",
  },
  {
    value: "GFI",
    title: "gram of fissile isotope",
    secondary:
      "A unit of mass defining the number of grams of a fissile isotope (fissile isotope: an isotope whose nucleus is able to be split when irradiated with low energy neutrons).",
  },
  {
    value: "GGR",
    title: "great gross",
    secondary: "A unit of count defining the number of units in multiples of 1728 (12 x 12 x 12).",
  },
  {
    value: "GIA",
    title: "gill (US)",
    secondary: "",
  },
  {
    value: "GIC",
    title: "gram, including container",
    secondary: "A unit of mass defining the number of grams of a product, including its container.",
  },
  {
    value: "GII",
    title: "gill (UK)",
    secondary: "",
  },
  {
    value: "GIP",
    title: "gram, including inner packaging",
    secondary: "A unit of mass defining the number of grams of a product, including its inner packaging materials.",
  },
  {
    value: "GJ",
    title: "gram per millilitre",
    secondary: "",
  },
  {
    value: "GL",
    title: "gram per litre",
    secondary: "",
  },
  {
    value: "GLD",
    title: "dry gallon (US)",
    secondary: "",
  },
  {
    value: "GLI",
    title: "gallon (UK)",
    secondary: "",
  },
  {
    value: "GLL",
    title: "gallon (US)",
    secondary: "",
  },
  {
    value: "GM",
    title: "gram per square metre",
    secondary: "",
  },
  {
    value: "GO",
    title: "milligram per square metre",
    secondary: "",
  },
  {
    value: "GP",
    title: "milligram per cubic metre",
    secondary: "",
  },
  {
    value: "GQ",
    title: "microgram per cubic metre",
    secondary: "",
  },
  {
    value: "GRM",
    title: "gram",
    secondary: "",
  },
  {
    value: "GRN",
    title: "grain",
    secondary: "",
  },
  {
    value: "GRO",
    title: "gross",
    secondary: "A unit of count defining the number of units in multiples of 144 (12 x 12).",
  },
  {
    value: "GV",
    title: "gigajoule",
    secondary: "",
  },
  {
    value: "GWH",
    title: "gigawatt hour",
    secondary: "",
  },
  {
    value: "H03",
    title: "henry per kiloohm",
    secondary: "",
  },
  {
    value: "H04",
    title: "henry per ohm",
    secondary: "",
  },
  {
    value: "H05",
    title: "millihenry per kiloohm",
    secondary: "",
  },
  {
    value: "H06",
    title: "millihenry per ohm",
    secondary: "",
  },
  {
    value: "H07",
    title: "pascal second per bar",
    secondary: "",
  },
  {
    value: "H08",
    title: "microbecquerel",
    secondary: "",
  },
  {
    value: "H09",
    title: "reciprocal year",
    secondary: "",
  },
  {
    value: "H10",
    title: "reciprocal hour",
    secondary: "",
  },
  {
    value: "H11",
    title: "reciprocal month",
    secondary: "",
  },
  {
    value: "H12",
    title: "degree Celsius per hour",
    secondary: "",
  },
  {
    value: "H13",
    title: "degree Celsius per minute",
    secondary: "",
  },
  {
    value: "H14",
    title: "degree Celsius per second",
    secondary: "",
  },
  {
    value: "H15",
    title: "square centimetre per gram",
    secondary: "",
  },
  {
    value: "H16",
    title: "square decametre",
    secondary: "Synonym: are",
  },
  {
    value: "H18",
    title: "square hectometre",
    secondary: "Synonym: hectare",
  },
  {
    value: "H19",
    title: "cubic hectometre",
    secondary: "",
  },
  {
    value: "H20",
    title: "cubic kilometre",
    secondary: "",
  },
  {
    value: "H21",
    title: "blank",
    secondary: "A unit of count defining the number of blanks.",
  },
  {
    value: "H22",
    title: "volt square inch per pound-force",
    secondary: "",
  },
  {
    value: "H23",
    title: "volt per inch",
    secondary: "",
  },
  {
    value: "H24",
    title: "volt per microsecond",
    secondary: "",
  },
  {
    value: "H25",
    title: "percent per kelvin",
    secondary: "A unit of proportion, equal to 0.01, in relation to the SI base unit Kelvin.",
  },
  {
    value: "H26",
    title: "ohm per metre",
    secondary: "",
  },
  {
    value: "H27",
    title: "degree per metre",
    secondary: "",
  },
  {
    value: "H28",
    title: "microfarad per kilometre",
    secondary: "",
  },
  {
    value: "H29",
    title: "microgram per litre",
    secondary: "",
  },
  {
    value: "H30",
    title: "square micrometre (square micron)",
    secondary: "",
  },
  {
    value: "H31",
    title: "ampere per kilogram",
    secondary: "",
  },
  {
    value: "H32",
    title: "ampere squared second",
    secondary: "",
  },
  {
    value: "H33",
    title: "farad per kilometre",
    secondary: "",
  },
  {
    value: "H34",
    title: "hertz metre",
    secondary: "",
  },
  {
    value: "H35",
    title: "kelvin metre per watt",
    secondary: "",
  },
  {
    value: "H36",
    title: "megaohm per kilometre",
    secondary: "",
  },
  {
    value: "H37",
    title: "megaohm per metre",
    secondary: "",
  },
  {
    value: "H38",
    title: "megaampere",
    secondary: "",
  },
  {
    value: "H39",
    title: "megahertz kilometre",
    secondary: "",
  },
  {
    value: "H40",
    title: "newton per ampere",
    secondary: "",
  },
  {
    value: "H41",
    title: "newton metre watt to the power minus 0,5",
    secondary: "",
  },
  {
    value: "H42",
    title: "pascal per metre",
    secondary: "",
  },
  {
    value: "H43",
    title: "siemens per centimetre",
    secondary: "",
  },
  {
    value: "H44",
    title: "teraohm",
    secondary: "",
  },
  {
    value: "H45",
    title: "volt second per metre",
    secondary: "",
  },
  {
    value: "H46",
    title: "volt per second",
    secondary: "",
  },
  {
    value: "H47",
    title: "watt per cubic metre",
    secondary: "",
  },
  {
    value: "H48",
    title: "attofarad",
    secondary: "",
  },
  {
    value: "H49",
    title: "centimetre per hour",
    secondary: "",
  },
  {
    value: "H50",
    title: "reciprocal cubic centimetre",
    secondary: "",
  },
  {
    value: "H51",
    title: "decibel per kilometre",
    secondary: "",
  },
  {
    value: "H52",
    title: "decibel per metre",
    secondary: "",
  },
  {
    value: "H53",
    title: "kilogram per bar",
    secondary: "",
  },
  {
    value: "H54",
    title: "kilogram per cubic decimetre kelvin",
    secondary: "",
  },
  {
    value: "H55",
    title: "kilogram per cubic decimetre bar",
    secondary: "",
  },
  {
    value: "H56",
    title: "kilogram per square metre second",
    secondary: "",
  },
  {
    value: "H57",
    title: "inch per two pi radiant",
    secondary: "",
  },
  {
    value: "H58",
    title: "metre per volt second",
    secondary: "",
  },
  {
    value: "H59",
    title: "square metre per newton",
    secondary: "",
  },
  {
    value: "H60",
    title: "cubic metre per cubic metre",
    secondary: "",
  },
  {
    value: "H61",
    title: "millisiemens per centimetre",
    secondary: "",
  },
  {
    value: "H62",
    title: "millivolt per minute",
    secondary: "",
  },
  {
    value: "H63",
    title: "milligram per square centimetre",
    secondary: "",
  },
  {
    value: "H64",
    title: "milligram per gram",
    secondary: "",
  },
  {
    value: "H65",
    title: "millilitre per cubic metre",
    secondary: "",
  },
  {
    value: "H66",
    title: "millimetre per year",
    secondary: "",
  },
  {
    value: "H67",
    title: "millimetre per hour",
    secondary: "",
  },
  {
    value: "H68",
    title: "millimole per gram",
    secondary: "",
  },
  {
    value: "H69",
    title: "picopascal per kilometre",
    secondary: "",
  },
  {
    value: "H70",
    title: "picosecond",
    secondary: "",
  },
  {
    value: "H71",
    title: "percent per month",
    secondary: "A unit of proportion, equal to 0.01, in relation to a month.",
  },
  {
    value: "H72",
    title: "percent per hectobar",
    secondary: "A unit of proportion, equal to 0.01, in relation to 100-fold of the unit bar.",
  },
  {
    value: "H73",
    title: "percent per decakelvin",
    secondary: "A unit of proportion, equal to 0.01, in relation to 10-fold of the SI base unit Kelvin.",
  },
  {
    value: "H74",
    title: "watt per metre",
    secondary: "",
  },
  {
    value: "H75",
    title: "decapascal",
    secondary: "",
  },
  {
    value: "H76",
    title: "gram per millimetre",
    secondary: "",
  },
  {
    value: "H77",
    title: "module width",
    secondary:
      "A unit of measure used to describe the breadth of electronic assemblies as an installation standard or mounting dimension.",
  },
  {
    value: "H79",
    title: "French gauge",
    secondary:
      "A unit of distance used for measuring the diameter of small tubes such as urological instruments and catheters. Synonym: French, Charrière, Charrière gauge",
  },
  {
    value: "H80",
    title: "rack unit",
    secondary:
      "A unit of measure used to describe the height in rack units of equipment intended for mounting in a 19-inch rack or a 23-inch rack. One rack unit is 1.75 inches (44.45 mm) high.",
  },
  {
    value: "H81",
    title: "millimetre per minute",
    secondary: "",
  },
  {
    value: "H82",
    title: "big point",
    secondary:
      "A unit of length defining the number of big points (big point: Adobe software(US) defines the big point to be exactly 1/72 inch (0.013 888 9 inch or 0.352 777 8 millimeters))",
  },
  {
    value: "H83",
    title: "litre per kilogram",
    secondary: "",
  },
  {
    value: "H84",
    title: "gram millimetre",
    secondary: "",
  },
  {
    value: "H85",
    title: "reciprocal week",
    secondary: "",
  },
  {
    value: "H87",
    title: "piece",
    secondary: "A unit of count defining the number of pieces (piece: a single item, article or exemplar).",
  },
  {
    value: "H88",
    title: "megaohm kilometre",
    secondary: "",
  },
  {
    value: "H89",
    title: "percent per ohm",
    secondary: "A unit of proportion, equal to 0.01, in relation to the SI derived unit ohm.",
  },
  {
    value: "H90",
    title: "percent per degree",
    secondary: "A unit of proportion, equal to 0.01, in relation to an angle of one degree.",
  },
  {
    value: "H91",
    title: "percent per ten thousand",
    secondary: "A unit of proportion, equal to 0.01, in relation to multiples of ten thousand.",
  },
  {
    value: "H92",
    title: "percent per one hundred thousand",
    secondary: "A unit of proportion, equal to 0.01, in relation to multiples of one hundred thousand.",
  },
  {
    value: "H93",
    title: "percent per hundred",
    secondary: "A unit of proportion, equal to 0.01, in relation to multiples of one hundred.",
  },
  {
    value: "H94",
    title: "percent per thousand",
    secondary: "A unit of proportion, equal to 0.01, in relation to multiples of one thousand.",
  },
  {
    value: "H95",
    title: "percent per volt",
    secondary: "A unit of proportion, equal to 0.01, in relation to the SI derived unit volt.",
  },
  {
    value: "H96",
    title: "percent per bar",
    secondary: "A unit of proportion, equal to 0.01, in relation to an atmospheric pressure of one bar.",
  },
  {
    value: "H98",
    title: "percent per inch",
    secondary: "A unit of proportion, equal to 0.01, in relation to an inch.",
  },
  {
    value: "H99",
    title: "percent per metre",
    secondary: "A unit of proportion, equal to 0.01, in relation to a metre.",
  },
  {
    value: "HA",
    title: "hank",
    secondary: "A unit of length, typically for yarn.",
  },
  {
    value: "HAD",
    title: "Piece Day",
  },
  {
    value: "HBA",
    title: "hectobar",
    secondary: "",
  },
  {
    value: "HBX",
    title: "hundred boxes",
    secondary: "A unit of count defining the number of boxes in multiples of one hundred box units.",
  },
  {
    value: "HC",
    title: "hundred count",
    secondary: "A unit of count defining the number of units counted in multiples of 100.",
  },
  {
    value: "HDW",
    title: "hundred kilogram, dry weight",
    secondary:
      "A unit of mass defining the number of hundred kilograms of a product, disregarding the water content of the product.",
  },
  {
    value: "HEA",
    title: "head",
    secondary: "A unit of count defining the number of heads (head: a person or animal considered as one of a number).",
  },
  {
    value: "HGM",
    title: "hectogram",
    secondary: "",
  },
  {
    value: "HH",
    title: "hundred cubic foot",
    secondary: "A unit of volume equal to one hundred cubic foot.",
  },
  {
    value: "HIU",
    title: "hundred international unit",
    secondary: "A unit of count defining the number of international units in multiples of 100.",
  },
  {
    value: "HKM",
    title: "hundred kilogram, net mass",
    secondary: "A unit of mass defining the number of hundred kilograms of a product, after deductions.",
  },
  {
    value: "HLT",
    title: "hectolitre",
    secondary: "",
  },
  {
    value: "HM",
    title: "mile per hour (statute mile)",
    secondary: "",
  },
  {
    value: "HMO",
    title: "Piece Month",
  },
  {
    value: "HMQ",
    title: "million cubic metre",
    secondary: "A unit of volume equal to one million cubic metres.",
  },
  {
    value: "HMT",
    title: "hectometre",
    secondary: "",
  },
  {
    value: "HPA",
    title: "hectolitre of pure alcohol",
    secondary: "A unit of volume equal to one hundred litres of pure alcohol.",
  },
  {
    value: "HTZ",
    title: "hertz",
    secondary: "",
  },
  {
    value: "HUR",
    title: "hour",
    secondary: "",
  },
  {
    value: "IA",
    title: "inch pound (pound inch)",
    secondary: "",
  },
  {
    value: "IE",
    title: "person",
    secondary: "A unit of count defining the number of persons.",
  },
  {
    value: "INH",
    title: "inch",
    secondary: "",
  },
  {
    value: "INK",
    title: "square inch",
    secondary: "",
  },
  {
    value: "INQ",
    title: "cubic inch",
    secondary: "Synonym: inch cubed",
  },
  {
    value: "ISD",
    title: "international sugar degree",
    secondary: "A unit of measure defining the sugar content of a solution, expressed in degrees.",
  },
  {
    value: "IU",
    title: "inch per second",
    secondary: "",
  },
  {
    value: "IUG",
    title: "international unit per gram",
  },
  {
    value: "IV",
    title: "inch per second squared",
    secondary: "",
  },
  {
    value: "J10",
    title: "percent per millimetre",
    secondary: "A unit of proportion, equal to 0.01, in relation to a millimetre.",
  },
  {
    value: "J12",
    title: "per mille per psi",
    secondary: "A unit of pressure equal to one thousandth of a psi (pound-force per square inch).",
  },
  {
    value: "J13",
    title: "degree API",
    secondary:
      "A unit of relative density as a measure of how heavy or light a petroleum liquid is compared to water (API: American Petroleum Institute).",
  },
  {
    value: "J14",
    title: "degree Baume (origin scale)",
    secondary: "A traditional unit of relative density for liquids. Named after Antoine Baumé.",
  },
  {
    value: "J15",
    title: "degree Baume (US heavy)",
    secondary: "A unit of relative density for liquids heavier than water.",
  },
  {
    value: "J16",
    title: "degree Baume (US light)",
    secondary: "A unit of relative density for liquids lighter than water.",
  },
  {
    value: "J17",
    title: "degree Balling",
    secondary: "A unit of density as a measure of sugar content, especially of beer wort. Named after Karl Balling.",
  },
  {
    value: "J18",
    title: "degree Brix",
    secondary:
      "A unit of proportion used in measuring the dissolved sugar-to-water mass ratio of a liquid. Named after Adolf Brix.",
  },
  {
    value: "J19",
    title: "degree Fahrenheit hour square foot per British thermal unit (thermochemical)",
    secondary: "",
  },
  {
    value: "J2",
    title: "joule per kilogram",
    secondary: "",
  },
  {
    value: "J20",
    title: "degree Fahrenheit per kelvin",
    secondary: "",
  },
  {
    value: "J21",
    title: "degree Fahrenheit per bar",
    secondary: "",
  },
  {
    value: "J22",
    title: "degree Fahrenheit hour square foot per British thermal unit (international table)",
    secondary: "",
  },
  {
    value: "J23",
    title: "degree Fahrenheit per hour",
    secondary: "",
  },
  {
    value: "J24",
    title: "degree Fahrenheit per minute",
    secondary: "",
  },
  {
    value: "J25",
    title: "degree Fahrenheit per second",
    secondary: "",
  },
  {
    value: "J26",
    title: "reciprocal degree Fahrenheit",
    secondary: "",
  },
  {
    value: "J27",
    title: "degree Oechsle",
    secondary:
      "A unit of density as a measure of sugar content of must, the unfermented liqueur from which wine is made. Named after Ferdinand Oechsle.",
  },
  {
    value: "J28",
    title: "degree Rankine per hour",
    secondary: "",
  },
  {
    value: "J29",
    title: "degree Rankine per minute",
    secondary: "",
  },
  {
    value: "J30",
    title: "degree Rankine per second",
    secondary: "",
  },
  {
    value: "J31",
    title: "degree Twaddell",
    secondary:
      "A unit of density for liquids that are heavier than water. 1 degree Twaddle represents a difference in specific gravity of 0.005.",
  },
  {
    value: "J32",
    title: "micropoise",
    secondary: "",
  },
  {
    value: "J33",
    title: "microgram per kilogram",
    secondary: "",
  },
  {
    value: "J34",
    title: "microgram per cubic metre kelvin",
    secondary: "",
  },
  {
    value: "J35",
    title: "microgram per cubic metre bar",
    secondary: "",
  },
  {
    value: "J36",
    title: "microlitre per litre",
    secondary: "",
  },
  {
    value: "J38",
    title: "baud",
    secondary: "A unit of signal transmission speed equal to one signalling event per second.",
  },
  {
    value: "J39",
    title: "British thermal unit (mean)",
    secondary: "",
  },
  {
    value: "J40",
    title: "British thermal unit (international table) foot per hour square foot degree Fahrenheit",
    secondary: "",
  },
  {
    value: "J41",
    title: "British thermal unit (international table) inch per hour square foot degree Fahrenheit",
    secondary: "",
  },
  {
    value: "J42",
    title: "British thermal unit (international table) inch per second square foot degree Fahrenheit",
    secondary: "",
  },
  {
    value: "J43",
    title: "British thermal unit (international table) per pound degree Fahrenheit",
    secondary: "",
  },
  {
    value: "J44",
    title: "British thermal unit (international table) per minute",
    secondary: "",
  },
  {
    value: "J45",
    title: "British thermal unit (international table) per second",
    secondary: "",
  },
  {
    value: "J46",
    title: "British thermal unit (thermochemical) foot per hour square foot degree Fahrenheit",
    secondary: "",
  },
  {
    value: "J47",
    title: "British thermal unit (thermochemical) per hour",
    secondary: "",
  },
  {
    value: "J48",
    title: "British thermal unit (thermochemical) inch per hour square foot degree Fahrenheit",
    secondary: "",
  },
  {
    value: "J49",
    title: "British thermal unit (thermochemical) inch per second square foot degree Fahrenheit",
    secondary: "",
  },
  {
    value: "J50",
    title: "British thermal unit (thermochemical) per pound degree Fahrenheit",
    secondary: "",
  },
  {
    value: "J51",
    title: "British thermal unit (thermochemical) per minute",
    secondary: "",
  },
  {
    value: "J52",
    title: "British thermal unit (thermochemical) per second",
    secondary: "",
  },
  {
    value: "J53",
    title: "coulomb square metre per kilogram",
    secondary: "",
  },
  {
    value: "J54",
    title: "megabaud",
    secondary: "A unit of signal transmission speed equal to 10⁶ (1000000) signaling events per second.",
  },
  {
    value: "J55",
    title: "watt second",
    secondary: "",
  },
  {
    value: "J56",
    title: "bar per bar",
    secondary: "",
  },
  {
    value: "J57",
    title: "barrel (UK petroleum)",
    secondary: "",
  },
  {
    value: "J58",
    title: "barrel (UK petroleum) per minute",
    secondary: "",
  },
  {
    value: "J59",
    title: "barrel (UK petroleum) per day",
    secondary: "",
  },
  {
    value: "J60",
    title: "barrel (UK petroleum) per hour",
    secondary: "",
  },
  {
    value: "J61",
    title: "barrel (UK petroleum) per second",
    secondary: "",
  },
  {
    value: "J62",
    title: "barrel (US petroleum) per hour",
    secondary: "",
  },
  {
    value: "J63",
    title: "barrel (US petroleum) per second",
    secondary: "",
  },
  {
    value: "J64",
    title: "bushel (UK) per day",
    secondary: "",
  },
  {
    value: "J65",
    title: "bushel (UK) per hour",
    secondary: "",
  },
  {
    value: "J66",
    title: "bushel (UK) per minute",
    secondary: "",
  },
  {
    value: "J67",
    title: "bushel (UK) per second",
    secondary: "",
  },
  {
    value: "J68",
    title: "bushel (US dry) per day",
    secondary: "",
  },
  {
    value: "J69",
    title: "bushel (US dry) per hour",
    secondary: "",
  },
  {
    value: "J70",
    title: "bushel (US dry) per minute",
    secondary: "",
  },
  {
    value: "J71",
    title: "bushel (US dry) per second",
    secondary: "",
  },
  {
    value: "J72",
    title: "centinewton metre",
    secondary: "",
  },
  {
    value: "J73",
    title: "centipoise per kelvin",
    secondary: "",
  },
  {
    value: "J74",
    title: "centipoise per bar",
    secondary: "",
  },
  {
    value: "J75",
    title: "calorie (mean)",
    secondary: "",
  },
  {
    value: "J76",
    title: "calorie (international table) per gram degree Celsius",
    secondary: "",
  },
  {
    value: "J78",
    title: "calorie (thermochemical) per centimetre second degree Celsius",
    secondary: "",
  },
  {
    value: "J79",
    title: "calorie (thermochemical) per gram degree Celsius",
    secondary: "",
  },
  {
    value: "J81",
    title: "calorie (thermochemical) per minute",
    secondary: "",
  },
  {
    value: "J82",
    title: "calorie (thermochemical) per second",
    secondary: "",
  },
  {
    value: "J83",
    title: "clo",
    secondary: "",
  },
  {
    value: "J84",
    title: "centimetre per second kelvin",
    secondary: "",
  },
  {
    value: "J85",
    title: "centimetre per second bar",
    secondary: "",
  },
  {
    value: "J87",
    title: "cubic centimetre per cubic metre",
    secondary: "",
  },
  {
    value: "J90",
    title: "cubic decimetre per day",
    secondary: "",
  },
  {
    value: "J91",
    title: "cubic decimetre per cubic metre",
    secondary: "",
  },
  {
    value: "J92",
    title: "cubic decimetre per minute",
    secondary: "",
  },
  {
    value: "J93",
    title: "cubic decimetre per second",
    secondary: "",
  },
  {
    value: "J95",
    title: "ounce (UK fluid) per day",
    secondary: "",
  },
  {
    value: "J96",
    title: "ounce (UK fluid) per hour",
    secondary: "",
  },
  {
    value: "J97",
    title: "ounce (UK fluid) per minute",
    secondary: "",
  },
  {
    value: "J98",
    title: "ounce (UK fluid) per second",
    secondary: "",
  },
  {
    value: "J99",
    title: "ounce (US fluid) per day",
    secondary: "",
  },
  {
    value: "JE",
    title: "joule per kelvin",
    secondary: "",
  },
  {
    value: "JK",
    title: "megajoule per kilogram",
    secondary: "",
  },
  {
    value: "JM",
    title: "megajoule per cubic metre",
    secondary: "",
  },
  {
    value: "JNT",
    title: "pipeline joint",
    secondary: "A count of the number of pipeline joints.",
  },
  {
    value: "JOU",
    title: "joule",
    secondary: "",
  },
  {
    value: "JPS",
    title: "hundred metre",
    secondary: "A unit of count defining the number of 100 metre lengths.",
  },
  {
    value: "JWL",
    title: "number of jewels",
    secondary: "A unit of count defining the number of jewels (jewel: precious stone).",
  },
  {
    value: "K1",
    title: "kilowatt demand",
    secondary: "A unit of measure defining the power load measured at predetermined intervals.",
  },
  {
    value: "K10",
    title: "ounce (US fluid) per hour",
    secondary: "",
  },
  {
    value: "K11",
    title: "ounce (US fluid) per minute",
    secondary: "",
  },
  {
    value: "K12",
    title: "ounce (US fluid) per second",
    secondary: "",
  },
  {
    value: "K13",
    title: "foot per degree Fahrenheit",
    secondary: "",
  },
  {
    value: "K14",
    title: "foot per hour",
    secondary: "",
  },
  {
    value: "K15",
    title: "foot pound-force per hour",
    secondary: "",
  },
  {
    value: "K16",
    title: "foot pound-force per minute",
    secondary: "",
  },
  {
    value: "K17",
    title: "foot per psi",
    secondary: "",
  },
  {
    value: "K18",
    title: "foot per second degree Fahrenheit",
    secondary: "",
  },
  {
    value: "K19",
    title: "foot per second psi",
    secondary: "",
  },
  {
    value: "K2",
    title: "kilovolt ampere reactive demand",
    secondary: "A unit of measure defining the reactive power demand equal to one kilovolt ampere of reactive power.",
  },
  {
    value: "K20",
    title: "reciprocal cubic foot",
    secondary: "",
  },
  {
    value: "K21",
    title: "cubic foot per degree Fahrenheit",
    secondary: "",
  },
  {
    value: "K22",
    title: "cubic foot per day",
    secondary: "",
  },
  {
    value: "K23",
    title: "cubic foot per psi",
    secondary: "",
  },
  {
    value: "K26",
    title: "gallon (UK) per day",
    secondary: "",
  },
  {
    value: "K27",
    title: "gallon (UK) per hour",
    secondary: "",
  },
  {
    value: "K28",
    title: "gallon (UK) per second",
    secondary: "",
  },
  {
    value: "K3",
    title: "kilovolt ampere reactive hour",
    secondary:
      "A unit of measure defining the accumulated reactive energy equal to one kilovolt ampere of reactive power per hour.",
  },
  {
    value: "K30",
    title: "gallon (US liquid) per second",
    secondary: "",
  },
  {
    value: "K31",
    title: "gram-force per square centimetre",
    secondary: "",
  },
  {
    value: "K32",
    title: "gill (UK) per day",
    secondary: "",
  },
  {
    value: "K33",
    title: "gill (UK) per hour",
    secondary: "",
  },
  {
    value: "K34",
    title: "gill (UK) per minute",
    secondary: "",
  },
  {
    value: "K35",
    title: "gill (UK) per second",
    secondary: "",
  },
  {
    value: "K36",
    title: "gill (US) per day",
    secondary: "",
  },
  {
    value: "K37",
    title: "gill (US) per hour",
    secondary: "",
  },
  {
    value: "K38",
    title: "gill (US) per minute",
    secondary: "",
  },
  {
    value: "K39",
    title: "gill (US) per second",
    secondary: "",
  },
  {
    value: "K40",
    title: "standard acceleration of free fall",
    secondary: "",
  },
  {
    value: "K41",
    title: "grain per gallon (US)",
    secondary: "",
  },
  {
    value: "K42",
    title: "horsepower (boiler)",
    secondary: "",
  },
  {
    value: "K43",
    title: "horsepower (electric)",
    secondary: "",
  },
  {
    value: "K45",
    title: "inch per degree Fahrenheit",
    secondary: "",
  },
  {
    value: "K46",
    title: "inch per psi",
    secondary: "",
  },
  {
    value: "K47",
    title: "inch per second degree Fahrenheit",
    secondary: "",
  },
  {
    value: "K48",
    title: "inch per second psi",
    secondary: "",
  },
  {
    value: "K49",
    title: "reciprocal cubic inch",
    secondary: "",
  },
  {
    value: "K50",
    title: "kilobaud",
    secondary: "A unit of signal transmission speed equal to 10³ (1000) signaling events per second.",
  },
  {
    value: "K51",
    title: "kilocalorie (mean)",
    secondary: "",
  },
  {
    value: "K52",
    title: "kilocalorie (international table) per hour metre degree Celsius",
    secondary: "",
  },
  {
    value: "K53",
    title: "kilocalorie (thermochemical)",
    secondary: "",
  },
  {
    value: "K54",
    title: "kilocalorie (thermochemical) per minute",
    secondary: "",
  },
  {
    value: "K55",
    title: "kilocalorie (thermochemical) per second",
    secondary: "",
  },
  {
    value: "K58",
    title: "kilomole per hour",
    secondary: "",
  },
  {
    value: "K59",
    title: "kilomole per cubic metre kelvin",
    secondary: "",
  },
  {
    value: "K6",
    title: "kilolitre",
    secondary: "",
  },
  {
    value: "K60",
    title: "kilomole per cubic metre bar",
    secondary: "",
  },
  {
    value: "K61",
    title: "kilomole per minute",
    secondary: "",
  },
  {
    value: "K62",
    title: "litre per litre",
    secondary: "",
  },
  {
    value: "K63",
    title: "reciprocal litre",
    secondary: "",
  },
  {
    value: "K64",
    title: "pound (avoirdupois) per degree Fahrenheit",
    secondary: "",
  },
  {
    value: "K65",
    title: "pound (avoirdupois) square foot",
    secondary: "",
  },
  {
    value: "K66",
    title: "pound (avoirdupois) per day",
    secondary: "",
  },
  {
    value: "K67",
    title: "pound per foot hour",
    secondary: "",
  },
  {
    value: "K68",
    title: "pound per foot second",
    secondary: "",
  },
  {
    value: "K69",
    title: "pound (avoirdupois) per cubic foot degree Fahrenheit",
    secondary: "",
  },
  {
    value: "K70",
    title: "pound (avoirdupois) per cubic foot psi",
    secondary: "",
  },
  {
    value: "K71",
    title: "pound (avoirdupois) per gallon (UK)",
    secondary: "",
  },
  {
    value: "K73",
    title: "pound (avoirdupois) per hour degree Fahrenheit",
    secondary: "",
  },
  {
    value: "K74",
    title: "pound (avoirdupois) per hour psi",
    secondary: "",
  },
  {
    value: "K75",
    title: "pound (avoirdupois) per cubic inch degree Fahrenheit",
    secondary: "",
  },
  {
    value: "K76",
    title: "pound (avoirdupois) per cubic inch psi",
    secondary: "",
  },
  {
    value: "K77",
    title: "pound (avoirdupois) per psi",
    secondary: "",
  },
  {
    value: "K78",
    title: "pound (avoirdupois) per minute",
    secondary: "",
  },
  {
    value: "K79",
    title: "pound (avoirdupois) per minute degree Fahrenheit",
    secondary: "",
  },
  {
    value: "K80",
    title: "pound (avoirdupois) per minute psi",
    secondary: "",
  },
  {
    value: "K81",
    title: "pound (avoirdupois) per second",
    secondary: "",
  },
  {
    value: "K82",
    title: "pound (avoirdupois) per second degree Fahrenheit",
    secondary: "",
  },
  {
    value: "K83",
    title: "pound (avoirdupois) per second psi",
    secondary: "",
  },
  {
    value: "K84",
    title: "pound per cubic yard",
    secondary: "",
  },
  {
    value: "K85",
    title: "pound-force per square foot",
    secondary: "",
  },
  {
    value: "K86",
    title: "pound-force per square inch degree Fahrenheit",
    secondary: "",
  },
  {
    value: "K87",
    title: "psi cubic inch per second",
    secondary: "",
  },
  {
    value: "K88",
    title: "psi litre per second",
    secondary: "",
  },
  {
    value: "K89",
    title: "psi cubic metre per second",
    secondary: "",
  },
  {
    value: "K90",
    title: "psi cubic yard per second",
    secondary: "",
  },
  {
    value: "K91",
    title: "pound-force second per square foot",
    secondary: "",
  },
  {
    value: "K92",
    title: "pound-force second per square inch",
    secondary: "",
  },
  {
    value: "K93",
    title: "reciprocal psi",
    secondary: "",
  },
  {
    value: "K94",
    title: "quart (UK liquid) per day",
    secondary: "",
  },
  {
    value: "K95",
    title: "quart (UK liquid) per hour",
    secondary: "",
  },
  {
    value: "K96",
    title: "quart (UK liquid) per minute",
    secondary: "",
  },
  {
    value: "K97",
    title: "quart (UK liquid) per second",
    secondary: "",
  },
  {
    value: "K98",
    title: "quart (US liquid) per day",
    secondary: "",
  },
  {
    value: "K99",
    title: "quart (US liquid) per hour",
    secondary: "",
  },
  {
    value: "KA",
    title: "cake",
    secondary: "A unit of count defining the number of cakes (cake: object shaped into a flat, compact mass).",
  },
  {
    value: "KAT",
    title: "katal",
    secondary: "A unit of catalytic activity defining the catalytic activity of enzymes and other catalysts.",
  },
  {
    value: "KB",
    title: "kilocharacter",
    secondary: "A unit of information equal to 10³ (1000) characters.",
  },
  {
    value: "KBA",
    title: "kilobar",
    secondary: "",
  },
  {
    value: "KCC",
    title: "kilogram of choline chloride",
    secondary: "A unit of mass equal to one thousand grams of choline chloride.",
  },
  {
    value: "KDW",
    title: "kilogram drained net weight",
    secondary:
      "A unit of mass defining the net number of kilograms of a product, disregarding the liquid content of the product.",
  },
  {
    value: "KEL",
    title: "kelvin",
    secondary: "Refer ISO 80000-5 (Quantities and units — Part 5: Thermodynamics)",
  },
  {
    value: "KGM",
    title: "kilogram",
    secondary: "A unit of mass equal to one thousand grams.",
  },
  {
    value: "KGS",
    title: "kilogram per second",
    secondary: "",
  },
  {
    value: "KHY",
    title: "kilogram of hydrogen peroxide",
    secondary: "A unit of mass equal to one thousand grams of hydrogen peroxide.",
  },
  {
    value: "KHZ",
    title: "kilohertz",
    secondary: "",
  },
  {
    value: "KI",
    title: "kilogram per millimetre width",
    secondary: "",
  },
  {
    value: "KIC",
    title: "kilogram, including container",
    secondary: "A unit of mass defining the number of kilograms of a product, including its container.",
  },
  {
    value: "KIP",
    title: "kilogram, including inner packaging",
    secondary: "A unit of mass defining the number of kilograms of a product, including its inner packaging materials.",
  },
  {
    value: "KJ",
    title: "kilosegment",
    secondary: "A unit of information equal to 10³ (1000) segments.",
  },
  {
    value: "KJO",
    title: "kilojoule",
    secondary: "",
  },
  {
    value: "KL",
    title: "kilogram per metre",
    secondary: "",
  },
  {
    value: "KLK",
    title: "lactic dry material percentage",
    secondary: "A unit of proportion defining the percentage of dry lactic material in a product.",
  },
  {
    value: "KLX",
    title: "kilolux",
    secondary: "A unit of illuminance equal to one thousand lux.",
  },
  {
    value: "KMA",
    title: "kilogram of methylamine",
    secondary: "A unit of mass equal to one thousand grams of methylamine.",
  },
  {
    value: "KMH",
    title: "kilometre per hour",
    secondary: "",
  },
  {
    value: "KMK",
    title: "square kilometre",
    secondary: "",
  },
  {
    value: "KMQ",
    title: "kilogram per cubic metre",
    secondary: "A unit of weight expressed in kilograms of a substance that fills a volume of one cubic metre.",
  },
  {
    value: "KMT",
    title: "kilometre",
    secondary: "",
  },
  {
    value: "KNI",
    title: "kilogram of nitrogen",
    secondary: "A unit of mass equal to one thousand grams of nitrogen.",
  },
  {
    value: "KNM",
    title: "kilonewton per square metre",
    secondary: "Pressure expressed in kN/m2.",
  },
  {
    value: "KNS",
    title: "kilogram named substance",
    secondary: "A unit of mass equal to one kilogram of a named substance.",
  },
  {
    value: "KNT",
    title: "knot",
    secondary: "",
  },
  {
    value: "KO",
    title: "milliequivalence caustic potash per gram of product",
    secondary:
      "A unit of count defining the number of milligrams of potassium hydroxide per gram of product as a measure of the concentration of potassium hydroxide in the product.",
  },
  {
    value: "KPA",
    title: "kilopascal",
    secondary: "",
  },
  {
    value: "KPH",
    title: "kilogram of potassium hydroxide (caustic potash)",
    secondary: "A unit of mass equal to one thousand grams of potassium hydroxide (caustic potash).",
  },
  {
    value: "KPO",
    title: "kilogram of potassium oxide",
    secondary: "A unit of mass equal to one thousand grams of potassium oxide.",
  },
  {
    value: "KPP",
    title: "kilogram of phosphorus pentoxide (phosphoric anhydride)",
    secondary: "A unit of mass equal to one thousand grams of phosphorus pentoxide phosphoric anhydride.",
  },
  {
    value: "KR",
    title: "kiloroentgen",
    secondary: "",
  },
  {
    value: "KSD",
    title: "kilogram of substance 90 % dry",
    secondary: "A unit of mass equal to one thousand grams of a named substance that is 90% dry.",
  },
  {
    value: "KSH",
    title: "kilogram of sodium hydroxide (caustic soda)",
    secondary: "A unit of mass equal to one thousand grams of sodium hydroxide (caustic soda).",
  },
  {
    value: "KT",
    title: "kit",
    secondary: "A unit of count defining the number of kits (kit: tub, barrel or pail).",
  },
  {
    value: "KTN",
    title: "kilotonne",
    secondary: "",
  },
  {
    value: "KUR",
    title: "kilogram of uranium",
    secondary: "A unit of mass equal to one thousand grams of uranium.",
  },
  {
    value: "KVA",
    title: "kilovolt - ampere",
    secondary: "",
  },
  {
    value: "KVR",
    title: "kilovar",
    secondary: "",
  },
  {
    value: "KVT",
    title: "kilovolt",
    secondary: "",
  },
  {
    value: "KW",
    title: "kilogram per millimetre",
    secondary: "",
  },
  {
    value: "KWH",
    title: "kilowatt hour",
    secondary: "",
  },
  {
    value: "KWN",
    title: "Kilowatt hour per normalized cubic metre",
  },
  {
    value: "KWO",
    title: "kilogram of tungsten trioxide",
    secondary: "A unit of mass equal to one thousand grams of tungsten trioxide.",
  },
  {
    value: "KWS",
    title: "Kilowatt hour per standard cubic metre",
  },
  {
    value: "KWT",
    title: "kilowatt",
    secondary: "",
  },
  {
    value: "KWY",
    title: "kilowatt year",
  },
  {
    value: "KX",
    title: "millilitre per kilogram",
    secondary: "",
  },
  {
    value: "L10",
    title: "quart (US liquid) per minute",
    secondary: "",
  },
  {
    value: "L11",
    title: "quart (US liquid) per second",
    secondary: "",
  },
  {
    value: "L12",
    title: "metre per second kelvin",
    secondary: "",
  },
  {
    value: "L13",
    title: "metre per second bar",
    secondary: "",
  },
  {
    value: "L14",
    title: "square metre hour degree Celsius per kilocalorie (international table)",
    secondary: "",
  },
  {
    value: "L15",
    title: "millipascal second per kelvin",
    secondary: "",
  },
  {
    value: "L16",
    title: "millipascal second per bar",
    secondary: "",
  },
  {
    value: "L17",
    title: "milligram per cubic metre kelvin",
    secondary: "",
  },
  {
    value: "L18",
    title: "milligram per cubic metre bar",
    secondary: "",
  },
  {
    value: "L19",
    title: "millilitre per litre",
    secondary: "",
  },
  {
    value: "L2",
    title: "litre per minute",
    secondary: "",
  },
  {
    value: "L20",
    title: "reciprocal cubic millimetre",
    secondary: "",
  },
  {
    value: "L21",
    title: "cubic millimetre per cubic metre",
    secondary: "",
  },
  {
    value: "L23",
    title: "mole per hour",
    secondary: "",
  },
  {
    value: "L24",
    title: "mole per kilogram kelvin",
    secondary: "",
  },
  {
    value: "L25",
    title: "mole per kilogram bar",
    secondary: "",
  },
  {
    value: "L26",
    title: "mole per litre kelvin",
    secondary: "",
  },
  {
    value: "L27",
    title: "mole per litre bar",
    secondary: "",
  },
  {
    value: "L28",
    title: "mole per cubic metre kelvin",
    secondary: "",
  },
  {
    value: "L29",
    title: "mole per cubic metre bar",
    secondary: "",
  },
  {
    value: "L30",
    title: "mole per minute",
    secondary: "",
  },
  {
    value: "L31",
    title: "milliroentgen aequivalent men",
    secondary: "",
  },
  {
    value: "L32",
    title: "nanogram per kilogram",
    secondary: "",
  },
  {
    value: "L33",
    title: "ounce (avoirdupois) per day",
    secondary: "",
  },
  {
    value: "L34",
    title: "ounce (avoirdupois) per hour",
    secondary: "",
  },
  {
    value: "L35",
    title: "ounce (avoirdupois) per minute",
    secondary: "",
  },
  {
    value: "L36",
    title: "ounce (avoirdupois) per second",
    secondary: "",
  },
  {
    value: "L37",
    title: "ounce (avoirdupois) per gallon (UK)",
    secondary: "",
  },
  {
    value: "L38",
    title: "ounce (avoirdupois) per gallon (US)",
    secondary: "",
  },
  {
    value: "L39",
    title: "ounce (avoirdupois) per cubic inch",
    secondary: "",
  },
  {
    value: "L40",
    title: "ounce (avoirdupois)-force",
    secondary: "",
  },
  {
    value: "L41",
    title: "ounce (avoirdupois)-force inch",
    secondary: "",
  },
  {
    value: "L42",
    title: "picosiemens per metre",
    secondary: "",
  },
  {
    value: "L43",
    title: "peck (UK)",
    secondary: "",
  },
  {
    value: "L44",
    title: "peck (UK) per day",
    secondary: "",
  },
  {
    value: "L45",
    title: "peck (UK) per hour",
    secondary: "",
  },
  {
    value: "L46",
    title: "peck (UK) per minute",
    secondary: "",
  },
  {
    value: "L47",
    title: "peck (UK) per second",
    secondary: "",
  },
  {
    value: "L48",
    title: "peck (US dry) per day",
    secondary: "",
  },
  {
    value: "L49",
    title: "peck (US dry) per hour",
    secondary: "",
  },
  {
    value: "L50",
    title: "peck (US dry) per minute",
    secondary: "",
  },
  {
    value: "L51",
    title: "peck (US dry) per second",
    secondary: "",
  },
  {
    value: "L52",
    title: "psi per psi",
    secondary: "",
  },
  {
    value: "L53",
    title: "pint (UK) per day",
    secondary: "",
  },
  {
    value: "L54",
    title: "pint (UK) per hour",
    secondary: "",
  },
  {
    value: "L55",
    title: "pint (UK) per minute",
    secondary: "",
  },
  {
    value: "L56",
    title: "pint (UK) per second",
    secondary: "",
  },
  {
    value: "L57",
    title: "pint (US liquid) per day",
    secondary: "",
  },
  {
    value: "L58",
    title: "pint (US liquid) per hour",
    secondary: "",
  },
  {
    value: "L59",
    title: "pint (US liquid) per minute",
    secondary: "",
  },
  {
    value: "L60",
    title: "pint (US liquid) per second",
    secondary: "",
  },
  {
    value: "L63",
    title: "slug per day",
    secondary: "",
  },
  {
    value: "L64",
    title: "slug per foot second",
    secondary: "",
  },
  {
    value: "L65",
    title: "slug per cubic foot",
    secondary: "",
  },
  {
    value: "L66",
    title: "slug per hour",
    secondary: "",
  },
  {
    value: "L67",
    title: "slug per minute",
    secondary: "",
  },
  {
    value: "L68",
    title: "slug per second",
    secondary: "",
  },
  {
    value: "L69",
    title: "tonne per kelvin",
    secondary: "",
  },
  {
    value: "L70",
    title: "tonne per bar",
    secondary: "",
  },
  {
    value: "L71",
    title: "tonne per day",
    secondary: "",
  },
  {
    value: "L72",
    title: "tonne per day kelvin",
    secondary: "",
  },
  {
    value: "L73",
    title: "tonne per day bar",
    secondary: "",
  },
  {
    value: "L74",
    title: "tonne per hour kelvin",
    secondary: "",
  },
  {
    value: "L75",
    title: "tonne per hour bar",
    secondary: "",
  },
  {
    value: "L76",
    title: "tonne per cubic metre kelvin",
    secondary: "",
  },
  {
    value: "L77",
    title: "tonne per cubic metre bar",
    secondary: "",
  },
  {
    value: "L78",
    title: "tonne per minute",
    secondary: "",
  },
  {
    value: "L79",
    title: "tonne per minute kelvin",
    secondary: "",
  },
  {
    value: "L80",
    title: "tonne per minute bar",
    secondary: "",
  },
  {
    value: "L81",
    title: "tonne per second",
    secondary: "",
  },
  {
    value: "L82",
    title: "tonne per second kelvin",
    secondary: "",
  },
  {
    value: "L83",
    title: "tonne per second bar",
    secondary: "",
  },
  {
    value: "L84",
    title: "ton (UK shipping)",
    secondary: "",
  },
  {
    value: "L85",
    title: "ton long per day",
    secondary: "",
  },
  {
    value: "L86",
    title: "ton (US shipping)",
    secondary: "",
  },
  {
    value: "L87",
    title: "ton short per degree Fahrenheit",
    secondary: "",
  },
  {
    value: "L88",
    title: "ton short per day",
    secondary: "",
  },
  {
    value: "L89",
    title: "ton short per hour degree Fahrenheit",
    secondary: "",
  },
  {
    value: "L90",
    title: "ton short per hour psi",
    secondary: "",
  },
  {
    value: "L91",
    title: "ton short per psi",
    secondary: "",
  },
  {
    value: "L92",
    title: "ton (UK long) per cubic yard",
    secondary: "",
  },
  {
    value: "L93",
    title: "ton (US short) per cubic yard",
    secondary: "",
  },
  {
    value: "L94",
    title: "ton-force (US short)",
    secondary: "",
  },
  {
    value: "L95",
    title: "common year",
    secondary: "",
  },
  {
    value: "L96",
    title: "sidereal year",
    secondary: "",
  },
  {
    value: "L98",
    title: "yard per degree Fahrenheit",
    secondary: "",
  },
  {
    value: "L99",
    title: "yard per psi",
    secondary: "",
  },
  {
    value: "LA",
    title: "pound per cubic inch",
    secondary: "",
  },
  {
    value: "LAC",
    title: "lactose excess percentage",
    secondary:
      "A unit of proportion defining the percentage of lactose in a product that exceeds a defined percentage level.",
  },
  {
    value: "LBR",
    title: "pound",
    secondary: "",
  },
  {
    value: "LBT",
    title: "troy pound (US)",
    secondary: "",
  },
  {
    value: "LD",
    title: "litre per day",
    secondary: "",
  },
  {
    value: "LEF",
    title: "leaf",
    secondary: "A unit of count defining the number of leaves.",
  },
  {
    value: "LF",
    title: "linear foot",
    secondary: "A unit of count defining the number of feet (12-inch) in length of a uniform width object.",
  },
  {
    value: "LH",
    title: "labour hour",
    secondary: "A unit of time defining the number of labour hours.",
  },
  {
    value: "LK",
    title: "link",
    secondary: "A unit of distance equal to 0.01 chain.",
  },
  {
    value: "LM",
    title: "linear metre",
    secondary: "A unit of count defining the number of metres in length of a uniform width object.",
  },
  {
    value: "LN",
    title: "length",
    secondary: "A unit of distance defining the linear extent of an item measured from end to end.",
  },
  {
    value: "LO",
    title: "lot [unit of procurement]",
    secondary: "A unit of count defining the number of lots (lot: a collection of associated items).",
  },
  {
    value: "LP",
    title: "liquid pound",
    secondary: "A unit of mass defining the number of pounds of a liquid substance.",
  },
  {
    value: "LPA",
    title: "litre of pure alcohol",
    secondary: "A unit of volume equal to one litre of pure alcohol.",
  },
  {
    value: "LR",
    title: "layer",
    secondary: "A unit of count defining the number of layers.",
  },
  {
    value: "LS",
    title: "lump sum",
    secondary: "A unit of count defining the number of whole or a complete monetary amounts.",
  },
  {
    value: "LTN",
    title: "ton (UK) or long ton (US)",
    secondary: "Synonym: gross ton (2240 lb)",
  },
  {
    value: "LTR",
    title: "litre",
    secondary: "",
  },
  {
    value: "LUB",
    title: "metric ton, lubricating oil",
    secondary: "A unit of mass defining the number of metric tons of lubricating oil.",
  },
  {
    value: "LUM",
    title: "lumen",
    secondary: "",
  },
  {
    value: "LUX",
    title: "lux",
    secondary: "",
  },
  {
    value: "LY",
    title: "linear yard",
    secondary: "A unit of count defining the number of 36-inch units in length of a uniform width object.",
  },
  {
    value: "M1",
    title: "milligram per litre",
    secondary: "",
  },
  {
    value: "M10",
    title: "reciprocal cubic yard",
    secondary: "",
  },
  {
    value: "M11",
    title: "cubic yard per degree Fahrenheit",
    secondary: "",
  },
  {
    value: "M12",
    title: "cubic yard per day",
    secondary: "",
  },
  {
    value: "M13",
    title: "cubic yard per hour",
    secondary: "",
  },
  {
    value: "M14",
    title: "cubic yard per psi",
    secondary: "",
  },
  {
    value: "M15",
    title: "cubic yard per minute",
    secondary: "",
  },
  {
    value: "M16",
    title: "cubic yard per second",
    secondary: "",
  },
  {
    value: "M17",
    title: "kilohertz metre",
    secondary: "",
  },
  {
    value: "M18",
    title: "gigahertz metre",
    secondary: "",
  },
  {
    value: "M19",
    title: "Beaufort",
    secondary:
      "An empirical measure for describing wind speed based mainly on observed sea conditions. The Beaufort scale indicates the wind speed by numbers that typically range from 0 for calm, to 12 for hurricane.",
  },
  {
    value: "M20",
    title: "reciprocal megakelvin or megakelvin to the power minus one",
    secondary: "",
  },
  {
    value: "M21",
    title: "reciprocal kilovolt - ampere reciprocal hour",
    secondary: "",
  },
  {
    value: "M22",
    title: "millilitre per square centimetre minute",
    secondary: "",
  },
  {
    value: "M23",
    title: "newton per centimetre",
    secondary: "",
  },
  {
    value: "M24",
    title: "ohm kilometre",
    secondary: "",
  },
  {
    value: "M25",
    title: "percent per degree Celsius",
    secondary: "A unit of proportion, equal to 0.01, in relation to a temperature of one degree.",
  },
  {
    value: "M26",
    title: "gigaohm per metre",
    secondary: "",
  },
  {
    value: "M27",
    title: "megahertz metre",
    secondary: "",
  },
  {
    value: "M29",
    title: "kilogram per kilogram",
    secondary: "",
  },
  {
    value: "M30",
    title: "reciprocal volt - ampere reciprocal second",
    secondary: "",
  },
  {
    value: "M31",
    title: "kilogram per kilometre",
    secondary: "",
  },
  {
    value: "M32",
    title: "pascal second per litre",
    secondary: "",
  },
  {
    value: "M33",
    title: "millimole per litre",
    secondary: "",
  },
  {
    value: "M34",
    title: "newton metre per square metre",
    secondary: "",
  },
  {
    value: "M35",
    title: "millivolt - ampere",
    secondary: "",
  },
  {
    value: "M36",
    title: "30-day month",
    secondary:
      "A unit of count defining the number of months expressed in multiples of 30 days, one day equals 24 hours.",
  },
  {
    value: "M37",
    title: "actual/360",
    secondary:
      "A unit of count defining the number of years expressed in multiples of 360 days, one day equals 24 hours.",
  },
  {
    value: "M38",
    title: "kilometre per second squared",
    secondary: "1000-fold of the SI base unit metre divided by the power of the SI base unit second by exponent 2.",
  },
  {
    value: "M39",
    title: "centimetre per second squared",
    secondary: "0,01-fold of the SI base unit metre divided by the power of the SI base unit second by exponent 2.",
  },
  {
    value: "M4",
    title: "monetary value",
    secondary: "A unit of measure expressed as a monetary amount.",
  },
  {
    value: "M40",
    title: "yard per second squared",
    secondary:
      "Unit of the length according to the Anglo-American and Imperial system of units divided by the power of the SI base unit second by exponent 2.",
  },
  {
    value: "M41",
    title: "millimetre per second squared",
    secondary: "0,001-fold of the SI base unit metre divided by the power of the SI base unit second by exponent 2.",
  },
  {
    value: "M42",
    title: "mile (statute mile) per second squared",
    secondary:
      "Unit of the length according to the Imperial system of units divided by the power of the SI base unit second by exponent 2.",
  },
  {
    value: "M43",
    title: "mil",
    secondary:
      "Unit to indicate an angle at military zone, equal to the 6400th part of the full circle of the 360° or 2·p·rad.",
  },
  {
    value: "M44",
    title: "revolution",
    secondary: "Unit to identify an angle of the full circle of 360° or 2·p·rad (Refer ISO/TC12 SI Guide).",
  },
  {
    value: "M45",
    title: "degree [unit of angle] per second squared",
    secondary: "360 part of a full circle divided by the power of the SI base unit second and the exponent 2.",
  },
  {
    value: "M46",
    title: "revolution per minute",
    secondary: "Unit of the angular velocity.",
  },
  {
    value: "M47",
    title: "circular mil",
    secondary:
      "Unit of an area, of which the size is given by a diameter of length of 1 mm (0,001 in) based on the formula: area = p·(diameter/2)².",
  },
  {
    value: "M48",
    title: "square mile (based on U.S. survey foot)",
    secondary: "Unit of the area, which is mainly common in the agriculture and forestry.",
  },
  {
    value: "M49",
    title: "chain (based on U.S. survey foot)",
    secondary: "Unit of the length according the Anglo-American system of units.",
  },
  {
    value: "M5",
    title: "microcurie",
    secondary: "",
  },
  {
    value: "M50",
    title: "furlong",
    secondary:
      "Unit commonly used in Great Britain at rural distances: 1 furlong = 40 rods = 10 chains (UK) = 1/8 mile = 1/10 furlong = 220 yards = 660 foot.",
  },
  {
    value: "M51",
    title: "foot (U.S. survey)",
    secondary: "Unit commonly used in the United States for ordnance survey.",
  },
  {
    value: "M52",
    title: "mile (based on U.S. survey foot)",
    secondary: "Unit commonly used in the United States for ordnance survey.",
  },
  {
    value: "M53",
    title: "metre per pascal",
    secondary: "SI base unit metre divided by the derived SI unit pascal.",
  },
  {
    value: "M55",
    title: "metre per radiant",
    secondary: "Unit of the translation factor for implementation from rotation to linear movement.",
  },
  {
    value: "M56",
    title: "shake",
    secondary: "Unit for a very short period.",
  },
  {
    value: "M57",
    title: "mile per minute",
    secondary: "Unit of velocity from the Imperial system of units.",
  },
  {
    value: "M58",
    title: "mile per second",
    secondary: "Unit of the velocity from the Imperial system of units.",
  },
  {
    value: "M59",
    title: "metre per second pascal",
    secondary: "SI base unit meter divided by the product of SI base unit second and the derived SI unit pascal.",
  },
  {
    value: "M60",
    title: "metre per hour",
    secondary: "SI base unit metre divided by the unit hour.",
  },
  {
    value: "M61",
    title: "inch per year",
    secondary:
      "Unit of the length according to the Anglo-American and Imperial system of units divided by the unit common year with 365 days.",
  },
  {
    value: "M62",
    title: "kilometre per second",
    secondary: "1000-fold of the SI base unit metre divided by the SI base unit second.",
  },
  {
    value: "M63",
    title: "inch per minute",
    secondary: "Unit inch according to the Anglo-American and Imperial system of units divided by the unit minute.",
  },
  {
    value: "M64",
    title: "yard per second",
    secondary:
      "Unit yard according to the Anglo-American and Imperial system of units divided by the SI base unit second.",
  },
  {
    value: "M65",
    title: "yard per minute",
    secondary: "Unit yard according to the Anglo-American and Imperial system of units divided by the unit minute.",
  },
  {
    value: "M66",
    title: "yard per hour",
    secondary: "Unit yard according to the Anglo-American and Imperial system of units divided by the unit hour.",
  },
  {
    value: "M67",
    title: "acre-foot (based on U.S. survey foot)",
    secondary: "Unit of the volume, which is used in the United States to measure/gauge the capacity of reservoirs.",
  },
  {
    value: "M68",
    title: "cord (128 ft3)",
    secondary: "Traditional unit of the volume of stacked firewood which has been measured with a cord.",
  },
  {
    value: "M69",
    title: "cubic mile (UK statute)",
    secondary: "Unit of volume according to the Imperial system of units.",
  },
  {
    value: "M7",
    title: "micro-inch",
    secondary: "",
  },
  {
    value: "M70",
    title: "ton, register",
    secondary: "Traditional unit of the cargo capacity.",
  },
  {
    value: "M71",
    title: "cubic metre per pascal",
    secondary: "Power of the SI base unit meter by exponent 3 divided by the derived SI base unit pascal.",
  },
  {
    value: "M72",
    title: "bel",
    secondary: "Logarithmic relationship to base 10.",
  },
  {
    value: "M73",
    title: "kilogram per cubic metre pascal",
    secondary:
      "SI base unit kilogram divided by the product of the power of the SI base unit metre with exponent 3 and the derived SI unit pascal.",
  },
  {
    value: "M74",
    title: "kilogram per pascal",
    secondary: "SI base unit kilogram divided by the derived SI unit pascal.",
  },
  {
    value: "M75",
    title: "kilopound-force",
    secondary:
      "1000-fold of the unit of the force pound-force (lbf) according to the Anglo-American system of units with the relationship.",
  },
  {
    value: "M76",
    title: "poundal",
    secondary:
      "Non SI-conforming unit of the power, which corresponds to a mass of a pound multiplied with the acceleration of a foot per square second.",
  },
  {
    value: "M77",
    title: "kilogram metre per second squared",
    secondary:
      "Product of the SI base unit kilogram and the SI base unit metre divided by the power of the SI base unit second by exponent 2.",
  },
  {
    value: "M78",
    title: "pond",
    secondary:
      "0,001-fold of the unit of the weight, defined as a mass of 1 kg which finds out about a weight strength from 1 kp by the gravitational force at sea level which corresponds to a strength of 9,806 65 newton.",
  },
  {
    value: "M79",
    title: "square foot per hour",
    secondary:
      "Power of the unit foot according to the Anglo-American and Imperial system of units by exponent 2 divided by the unit of time hour.",
  },
  {
    value: "M80",
    title: "stokes per pascal",
    secondary: "CGS (Centimetre-Gram-Second system) unit stokes divided by the derived SI unit pascal.",
  },
  {
    value: "M81",
    title: "square centimetre per second",
    secondary: "0,000 1-fold of the power of the SI base unit metre by exponent 2 divided by the SI base unit second.",
  },
  {
    value: "M82",
    title: "square metre per second pascal",
    secondary:
      "Power of the SI base unit metre with the exponent 2 divided by the SI base unit second and the derived SI unit pascal.",
  },
  {
    value: "M83",
    title: "denier",
    secondary: "Traditional unit for the indication of the linear mass of textile fibers and yarns.",
  },
  {
    value: "M84",
    title: "pound per yard",
    secondary: "Unit for linear mass according to avoirdupois system of units.",
  },
  {
    value: "M85",
    title: "ton, assay",
    secondary:
      "Non SI-conforming unit of the mass used in the mineralogy to determine the concentration of precious metals in ore according to the mass of the precious metal in milligrams in a sample of the mass of an assay sound (number of troy ounces in a short ton (1 000 lb)).",
  },
  {
    value: "M86",
    title: "pfund",
    secondary: "Outdated unit of the mass used in Germany.",
  },
  {
    value: "M87",
    title: "kilogram per second pascal",
    secondary:
      "SI base unit kilogram divided by the product of the SI base unit second and the derived SI unit pascal.",
  },
  {
    value: "M88",
    title: "tonne per month",
    secondary: "Unit tonne divided by the unit month.",
  },
  {
    value: "M89",
    title: "tonne per year",
    secondary: "Unit tonne divided by the unit year with 365 days.",
  },
  {
    value: "M9",
    title: "million Btu per 1000 cubic foot",
    secondary: "",
  },
  {
    value: "M90",
    title: "kilopound per hour",
    secondary:
      "1000-fold of the unit of the mass avoirdupois pound according to the avoirdupois unit system divided by the unit hour.",
  },
  {
    value: "M91",
    title: "pound per pound",
    secondary:
      "Proportion of the mass consisting of the avoirdupois pound according to the avoirdupois unit system divided by the avoirdupois pound according to the avoirdupois unit system.",
  },
  {
    value: "M92",
    title: "pound-force foot",
    secondary:
      "Product of the unit pound-force according to the Anglo-American system of units and the unit foot according to the Anglo-American and the Imperial system of units.",
  },
  {
    value: "M93",
    title: "newton metre per radian",
    secondary: "Product of the derived SI unit newton and the SI base unit metre divided by the unit radian.",
  },
  {
    value: "M94",
    title: "kilogram metre",
    secondary: "Unit of imbalance as a product of the SI base unit kilogram and the SI base unit metre.",
  },
  {
    value: "M95",
    title: "poundal foot",
    secondary:
      "Product of the non SI-conforming unit of the force poundal and the unit foot according to the Anglo-American and Imperial system of units .",
  },
  {
    value: "M96",
    title: "poundal inch",
    secondary:
      "Product of the non SI-conforming unit of the force poundal and the unit inch according to the Anglo-American and Imperial system of units .",
  },
  {
    value: "M97",
    title: "dyne metre",
    secondary: "CGS (Centimetre-Gram-Second system) unit of the rotational moment.",
  },
  {
    value: "M98",
    title: "kilogram centimetre per second",
    secondary:
      "Product of the SI base unit kilogram and the 0,01-fold of the SI base unit metre divided by the SI base unit second.",
  },
  {
    value: "M99",
    title: "gram centimetre per second",
    secondary:
      "Product of the 0,001-fold of the SI base unit kilogram and the 0,01-fold of the SI base unit metre divided by the SI base unit second.",
  },
  {
    value: "MAH",
    title: "megavolt ampere reactive hour",
    secondary: "A unit of electrical reactive power defining the total amount of reactive power across a power system.",
  },
  {
    value: "MAL",
    title: "megalitre",
    secondary: "",
  },
  {
    value: "MAM",
    title: "megametre",
    secondary: "",
  },
  {
    value: "MAR",
    title: "megavar",
    secondary:
      "A unit of electrical reactive power represented by a current of one thousand amperes flowing due a potential difference of one thousand volts where the sine of the phase angle between them is 1.",
  },
  {
    value: "MAW",
    title: "megawatt",
    secondary:
      "A unit of power defining the rate of energy transferred or consumed when a current of 1000 amperes flows due to a potential of 1000 volts at unity power factor.",
  },
  {
    value: "MBE",
    title: "thousand standard brick equivalent",
    secondary: "A unit of count defining the number of one thousand brick equivalent units.",
  },
  {
    value: "MBF",
    title: "thousand board foot",
    secondary: "A unit of volume equal to one thousand board foot.",
  },
  {
    value: "MBR",
    title: "millibar",
    secondary: "",
  },
  {
    value: "MC",
    title: "microgram",
    secondary: "",
  },
  {
    value: "MCU",
    title: "millicurie",
    secondary: "",
  },
  {
    value: "MD",
    title: "air dry metric ton",
    secondary:
      "A unit of count defining the number of metric tons of a product, disregarding the water content of the product.",
  },
  {
    value: "MGM",
    title: "milligram",
    secondary: "",
  },
  {
    value: "MHZ",
    title: "megahertz",
    secondary: "",
  },
  {
    value: "MIK",
    title: "square mile (statute mile)",
    secondary: "",
  },
  {
    value: "MIL",
    title: "thousand",
    secondary: "",
  },
  {
    value: "MIN",
    title: "minute [unit of time]",
    secondary: "",
  },
  {
    value: "MIO",
    title: "million",
    secondary: "",
  },
  {
    value: "MIU",
    title: "million international unit",
    secondary: "A unit of count defining the number of international units in multiples of 10.",
  },
  {
    value: "MKD",
    title: "Square Metre Day",
  },
  {
    value: "MKM",
    title: "Square Metre Month",
  },
  {
    value: "MKW",
    title: "Square Metre Week",
  },
  {
    value: "MLD",
    title: "milliard",
    secondary: "Synonym: billion (US)",
  },
  {
    value: "MLT",
    title: "millilitre",
    secondary: "",
  },
  {
    value: "MMK",
    title: "square millimetre",
    secondary: "",
  },
  {
    value: "MMQ",
    title: "cubic millimetre",
    secondary: "",
  },
  {
    value: "MMT",
    title: "millimetre",
    secondary: "",
  },
  {
    value: "MND",
    title: "kilogram, dry weight",
    secondary:
      "A unit of mass defining the number of kilograms of a product, disregarding the water content of the product.",
  },
  {
    value: "MNJ",
    title: "Mega Joule per Normalised cubic Metre",
  },
  {
    value: "MON",
    title: "month",
    secondary: "Unit of time equal to 1/12 of a year of 365,25 days.",
  },
  {
    value: "MPA",
    title: "megapascal",
    secondary: "",
  },
  {
    value: "MQD",
    title: "Cubic Metre Day",
  },
  {
    value: "MQH",
    title: "cubic metre per hour",
    secondary: "",
  },
  {
    value: "MQM",
    title: "Cubic Metre Month",
  },
  {
    value: "MQS",
    title: "cubic metre per second",
    secondary: "",
  },
  {
    value: "MQW",
    title: "Cubic Metre Week",
  },
  {
    value: "MRD",
    title: "Metre Day",
  },
  {
    value: "MRM",
    title: "Metre Month",
  },
  {
    value: "MRW",
    title: "Metre Week",
  },
  {
    value: "MSK",
    title: "metre per second squared",
    secondary: "",
  },
  {
    value: "MTK",
    title: "square metre",
    secondary: "",
  },
  {
    value: "MTQ",
    title: "cubic metre",
    secondary: "Synonym: metre cubed",
  },
  {
    value: "MTR",
    title: "metre",
    secondary: "",
  },
  {
    value: "MTS",
    title: "metre per second",
    secondary: "",
  },
  {
    value: "MTZ",
    title: "milihertz",
  },
  {
    value: "MVA",
    title: "megavolt - ampere",
    secondary: "",
  },
  {
    value: "MWH",
    title: "megawatt hour (1000 kW.h)",
    secondary: "A unit of power defining the total amount of bulk energy transferred or consumed.",
  },
  {
    value: "N1",
    title: "pen calorie",
    secondary: "A unit of count defining the number of calories prescribed daily for parenteral/enteral therapy.",
  },
  {
    value: "N10",
    title: "pound foot per second",
    secondary:
      "Product of the avoirdupois pound according to the avoirdupois unit system and the unit foot according to the Anglo-American and Imperial system of units divided by the SI base unit second.",
  },
  {
    value: "N11",
    title: "pound inch per second",
    secondary:
      "Product of the avoirdupois pound according to the avoirdupois unit system and the unit inch according to the Anglo-American and Imperial system of units divided by the SI base unit second.",
  },
  {
    value: "N12",
    title: "Pferdestaerke",
    secondary: "Obsolete unit of the power relating to DIN 1301-3:1979: 1 PS = 735,498 75 W.",
  },
  {
    value: "N13",
    title: "centimetre of mercury (0 ºC)",
    secondary:
      "Non SI-conforming unit of pressure, at which a value of 1 cmHg meets the static pressure, which is generated by a mercury at a temperature of 0 °C with a height of 1 centimetre .",
  },
  {
    value: "N14",
    title: "centimetre of water (4 ºC)",
    secondary:
      "Non SI-conforming unit of pressure, at which a value of 1 cmH2O meets the static pressure, which is generated by a head of water at a temperature of 4 °C with a height of 1 centimetre .",
  },
  {
    value: "N15",
    title: "foot of water (39.2 ºF)",
    secondary:
      "Non SI-conforming unit of pressure according to the Anglo-American and Imperial system for units, whereas the value of 1 ftH2O is equivalent to the static pressure, which is generated by a head of water at a temperature 39,2°F with a height of 1 foot .",
  },
  {
    value: "N16",
    title: "inch of mercury (32 ºF)",
    secondary:
      "Non SI-conforming unit of pressure according to the Anglo-American and Imperial system for units, whereas the value of 1 inHg meets the static pressure, which is generated by a mercury at a temperature of 32°F with a height of 1 inch.",
  },
  {
    value: "N17",
    title: "inch of mercury (60 ºF)",
    secondary:
      "Non SI-conforming unit of pressure according to the Anglo-American and Imperial system for units, whereas the value of 1 inHg meets the static pressure, which is generated by a mercury at a temperature of 60°F with a height of 1 inch.",
  },
  {
    value: "N18",
    title: "inch of water (39.2 ºF)",
    secondary:
      "Non SI-conforming unit of pressure according to the Anglo-American and Imperial system for units, whereas the value of 1 inH2O meets the static pressure, which is generated by a head of water at a temperature of 39,2°F with a height of 1 inch .",
  },
  {
    value: "N19",
    title: "inch of water (60 ºF)",
    secondary:
      "Non SI-conforming unit of pressure according to the Anglo-American and Imperial system for units, whereas the value of 1 inH2O meets the static pressure, which is generated by a head of water at a temperature of 60°F with a height of 1 inch .",
  },
  {
    value: "N20",
    title: "kip per square inch",
    secondary:
      "Non SI-conforming unit of the pressure according to the Anglo-American system of units as the 1000-fold of the unit of the force pound-force divided by the power of the unit inch by exponent 2.",
  },
  {
    value: "N21",
    title: "poundal per square foot",
    secondary:
      "Non SI-conforming unit of pressure by the Imperial system of units according to NIST: 1 pdl/ft² = 1,488 164 Pa.",
  },
  {
    value: "N22",
    title: "ounce (avoirdupois) per square inch",
    secondary:
      "Unit of the surface specific mass (avoirdupois ounce according to the avoirdupois system of units according to the surface square inch according to the Anglo-American and Imperial system of units).",
  },
  {
    value: "N23",
    title: "conventional metre of water",
    secondary:
      "Not SI-conforming unit of pressure, whereas a value of 1 mH2O is equivalent to the static pressure, which is produced by one metre high water column .",
  },
  {
    value: "N24",
    title: "gram per square millimetre",
    secondary:
      "0,001-fold of the SI base unit kilogram divided by the 0.000 001-fold of the power of the SI base unit meter by exponent 2.",
  },
  {
    value: "N25",
    title: "pound per square yard",
    secondary:
      "Unit for areal-related mass as a unit pound according to the avoirdupois unit system divided by the power of the unit yard according to the Anglo-American and Imperial system of units with exponent 2.",
  },
  {
    value: "N26",
    title: "poundal per square inch",
    secondary:
      "Non SI-conforming unit of the pressure according to the Imperial system of units (poundal by square inch).",
  },
  {
    value: "N27",
    title: "foot to the fourth power",
    secondary:
      "Power of the unit foot according to the Anglo-American and Imperial system of units by exponent 4 according to NIST: 1 ft4 = 8,630 975 m4.",
  },
  {
    value: "N28",
    title: "cubic decimetre per kilogram",
    secondary: "0,001 fold of the power of the SI base unit meter by exponent 3 divided by the SI based unit kilogram.",
  },
  {
    value: "N29",
    title: "cubic foot per pound",
    secondary:
      "Power of the unit foot according to the Anglo-American and Imperial system of units by exponent 3 divided by the unit avoirdupois pound according to the avoirdupois unit system.",
  },
  {
    value: "N3",
    title: "print point",
    secondary: "",
  },
  {
    value: "N30",
    title: "cubic inch per pound",
    secondary:
      "Power of the unit inch according to the Anglo-American and Imperial system of units by exponent 3 divided by the avoirdupois pound according to the avoirdupois unit system .",
  },
  {
    value: "N31",
    title: "kilonewton per metre",
    secondary: "1000-fold of the derived SI unit newton divided by the SI base unit metre.",
  },
  {
    value: "N32",
    title: "poundal per inch",
    secondary:
      "Non SI-conforming unit of the surface tension according to the Imperial unit system as quotient poundal by inch.",
  },
  {
    value: "N33",
    title: "pound-force per yard",
    secondary: "Unit of force per unit length based on the Anglo-American system of units.",
  },
  {
    value: "N34",
    title: "poundal second per square foot",
    secondary: "Non SI-conforming unit of viscosity.",
  },
  {
    value: "N35",
    title: "poise per pascal",
    secondary: "CGS (Centimetre-Gram-Second system) unit poise divided by the derived SI unit pascal.",
  },
  {
    value: "N36",
    title: "newton second per square metre",
    secondary:
      "Unit of the dynamic viscosity as a product of unit of the pressure (newton by square metre) multiplied with the SI base unit second.",
  },
  {
    value: "N37",
    title: "kilogram per metre second",
    secondary:
      "Unit of the dynamic viscosity as a quotient SI base unit kilogram divided by the SI base unit metre and by the SI base unit second.",
  },
  {
    value: "N38",
    title: "kilogram per metre minute",
    secondary:
      "Unit of the dynamic viscosity as a quotient SI base unit kilogram divided by the SI base unit metre and by the unit minute.",
  },
  {
    value: "N39",
    title: "kilogram per metre day",
    secondary:
      "Unit of the dynamic viscosity as a quotient SI base unit kilogram divided by the SI base unit metre and by the unit day.",
  },
  {
    value: "N40",
    title: "kilogram per metre hour",
    secondary:
      "Unit of the dynamic viscosity as a quotient SI base unit kilogram divided by the SI base unit metre and by the unit hour.",
  },
  {
    value: "N41",
    title: "gram per centimetre second",
    secondary:
      "Unit of the dynamic viscosity as a quotient of the 0,001-fold of the SI base unit kilogram divided by the 0,01-fold of the SI base unit metre and SI base unit second.",
  },
  {
    value: "N42",
    title: "poundal second per square inch",
    secondary:
      "Non SI-conforming unit of dynamic viscosity according to the Imperial system of units as product unit of the pressure (poundal by square inch) multiplied by the SI base unit second.",
  },
  {
    value: "N43",
    title: "pound per foot minute",
    secondary: "Unit of the dynamic viscosity according to the Anglo-American unit system.",
  },
  {
    value: "N44",
    title: "pound per foot day",
    secondary: "Unit of the dynamic viscosity according to the Anglo-American unit system.",
  },
  {
    value: "N45",
    title: "cubic metre per second pascal",
    secondary:
      "Power of the SI base unit meter by exponent 3 divided by the product of the SI base unit second and the derived SI base unit pascal.",
  },
  {
    value: "N46",
    title: "foot poundal",
    secondary: "Unit of the work (force-path).",
  },
  {
    value: "N47",
    title: "inch poundal",
    secondary:
      "Unit of work (force multiplied by path) according to the Imperial system of units as a product unit inch multiplied by poundal.",
  },
  {
    value: "N48",
    title: "watt per square centimetre",
    secondary: "Derived SI unit watt divided by the power of the 0,01-fold the SI base unit metre by exponent 2.",
  },
  {
    value: "N49",
    title: "watt per square inch",
    secondary:
      "Derived SI unit watt divided by the power of the unit inch according to the Anglo-American and Imperial system of units by exponent 2.",
  },
  {
    value: "N50",
    title: "British thermal unit (international table) per square foot hour",
    secondary: "Unit of the surface heat flux according to the Imperial system of units.",
  },
  {
    value: "N51",
    title: "British thermal unit (thermochemical) per square foot hour",
    secondary: "Unit of the surface heat flux according to the Imperial system of units.",
  },
  {
    value: "N52",
    title: "British thermal unit (thermochemical) per square foot minute",
    secondary: "Unit of the surface heat flux according to the Imperial system of units.",
  },
  {
    value: "N53",
    title: "British thermal unit (international table) per square foot second",
    secondary: "Unit of the surface heat flux according to the Imperial system of units.",
  },
  {
    value: "N54",
    title: "British thermal unit (thermochemical) per square foot second",
    secondary: "Unit of the surface heat flux according to the Imperial system of units.",
  },
  {
    value: "N55",
    title: "British thermal unit (international table) per square inch second",
    secondary: "Unit of the surface heat flux according to the Imperial system of units.",
  },
  {
    value: "N56",
    title: "calorie (thermochemical) per square centimetre minute",
    secondary: "Unit of the surface heat flux according to the Imperial system of units.",
  },
  {
    value: "N57",
    title: "calorie (thermochemical) per square centimetre second",
    secondary: "Unit of the surface heat flux according to the Imperial system of units.",
  },
  {
    value: "N58",
    title: "British thermal unit (international table) per cubic foot",
    secondary: "Unit of the energy density according to the Imperial system of units.",
  },
  {
    value: "N59",
    title: "British thermal unit (thermochemical) per cubic foot",
    secondary: "Unit of the energy density according to the Imperial system of units.",
  },
  {
    value: "N60",
    title: "British thermal unit (international table) per degree Fahrenheit",
    secondary: "Unit of the heat capacity according to the Imperial system of units.",
  },
  {
    value: "N61",
    title: "British thermal unit (thermochemical) per degree Fahrenheit",
    secondary: "Unit of the heat capacity according to the Imperial system of units.",
  },
  {
    value: "N62",
    title: "British thermal unit (international table) per degree Rankine",
    secondary: "Unit of the heat capacity according to the Imperial system of units.",
  },
  {
    value: "N63",
    title: "British thermal unit (thermochemical) per degree Rankine",
    secondary: "Unit of the heat capacity according to the Imperial system of units.",
  },
  {
    value: "N64",
    title: "British thermal unit (thermochemical) per pound degree Rankine",
    secondary:
      "Unit of the heat capacity (British thermal unit according to the international table according to the Rankine degree) according to the Imperial system of units divided by the unit avoirdupois pound according to the avoirdupois system of units.",
  },
  {
    value: "N65",
    title: "kilocalorie (international table) per gram kelvin",
    secondary:
      "Unit of the mass-related heat capacity as quotient 1000-fold of the calorie (international table) divided by the product of the 0,001-fold of the SI base units kilogram and kelvin.",
  },
  {
    value: "N66",
    title: "British thermal unit (39 ºF)",
    secondary: "Unit of heat energy according to the Imperial system of units in a reference temperature of 39 °F.",
  },
  {
    value: "N67",
    title: "British thermal unit (59 ºF)",
    secondary: "Unit of heat energy according to the Imperial system of units in a reference temperature of 59 °F.",
  },
  {
    value: "N68",
    title: "British thermal unit (60 ºF)",
    secondary: "Unit of head energy according to the Imperial system of units at a reference temperature of 60 °F.",
  },
  {
    value: "N69",
    title: "calorie (20 ºC)",
    secondary:
      "Unit for quantity of heat, which is to be required for 1 g air free water at a constant pressure from 101,325 kPa, to warm up the pressure of standard atmosphere at sea level, from 19,5 °C on 20,5 °C.",
  },
  {
    value: "N70",
    title: "quad (1015 BtuIT)",
    secondary: "Unit of heat energy according to the imperial system of units.",
  },
  {
    value: "N71",
    title: "therm (EC)",
    secondary: "Unit of heat energy in commercial use, within the EU defined: 1 thm (EC) = 100 000 BtuIT.",
  },
  {
    value: "N72",
    title: "therm (U.S.)",
    secondary: "Unit of heat energy in commercial use.",
  },
  {
    value: "N73",
    title: "British thermal unit (thermochemical) per pound",
    secondary:
      "Unit of the heat energy according to the Imperial system of units divided the unit avoirdupois pound according to the avoirdupois system of units.",
  },
  {
    value: "N74",
    title: "British thermal unit (international table) per hour square foot degree Fahrenheit",
    secondary: "Unit of the heat transition coefficient according to the Imperial system of units.",
  },
  {
    value: "N75",
    title: "British thermal unit (thermochemical) per hour square foot degree Fahrenheit",
    secondary: "Unit of the heat transition coefficient according to the imperial system of units.",
  },
  {
    value: "N76",
    title: "British thermal unit (international table) per second square foot degree Fahrenheit",
    secondary: "Unit of the heat transition coefficient according to the imperial system of units.",
  },
  {
    value: "N77",
    title: "British thermal unit (thermochemical) per second square foot degree Fahrenheit",
    secondary: "Unit of the heat transition coefficient according to the imperial system of units.",
  },
  {
    value: "N78",
    title: "kilowatt per square metre kelvin",
    secondary:
      "1000-fold of the derived SI unit watt divided by the product of the power of the SI base unit metre by exponent 2 and the SI base unit kelvin.",
  },
  {
    value: "N79",
    title: "kelvin per pascal",
    secondary: "SI base unit kelvin divided by the derived SI unit pascal.",
  },
  {
    value: "N80",
    title: "watt per metre degree Celsius",
    secondary:
      "Derived SI unit watt divided by the product of the SI base unit metre and the unit for temperature degree Celsius.",
  },
  {
    value: "N81",
    title: "kilowatt per metre kelvin",
    secondary:
      "1000-fold of the derived SI unit watt divided by the product of the SI base unit metre and the SI base unit kelvin.",
  },
  {
    value: "N82",
    title: "kilowatt per metre degree Celsius",
    secondary:
      "1000-fold of the derived SI unit watt divided by the product of the SI base unit metre and the unit for temperature degree Celsius.",
  },
  {
    value: "N83",
    title: "metre per degree Celcius metre",
    secondary: "SI base unit metre divided by the product of the unit degree Celsius and the SI base unit metre.",
  },
  {
    value: "N84",
    title: "degree Fahrenheit hour per British thermal unit (international table)",
    secondary: "Non SI-conforming unit of the thermal resistance according to the Imperial system of units.",
  },
  {
    value: "N85",
    title: "degree Fahrenheit hour per British thermal unit (thermochemical)",
    secondary: "Non SI-conforming unit of the thermal resistance according to the Imperial system of units.",
  },
  {
    value: "N86",
    title: "degree Fahrenheit second per British thermal unit (international table)",
    secondary: "Non SI-conforming unit of the thermal resistance according to the Imperial system of units.",
  },
  {
    value: "N87",
    title: "degree Fahrenheit second per British thermal unit (thermochemical)",
    secondary: "Non SI-conforming unit of the thermal resistance according to the Imperial system of units.",
  },
  {
    value: "N88",
    title: "degree Fahrenheit hour square foot per British thermal unit (international table) inch",
    secondary: "Unit of specific thermal resistance according to the Imperial system of units.",
  },
  {
    value: "N89",
    title: "degree Fahrenheit hour square foot per British thermal unit (thermochemical) inch",
    secondary: "Unit of specific thermal resistance according to the Imperial system of units.",
  },
  {
    value: "N90",
    title: "kilofarad",
    secondary: "1000-fold of the derived SI unit farad.",
  },
  {
    value: "N91",
    title: "reciprocal joule",
    secondary: "Reciprocal of the derived SI unit joule.",
  },
  {
    value: "N92",
    title: "picosiemens",
    secondary: "0,000 000 000 001-fold of the derived SI unit siemens.",
  },
  {
    value: "N93",
    title: "ampere per pascal",
    secondary: "SI base unit ampere divided by the derived SI unit pascal.",
  },
  {
    value: "N94",
    title: "franklin",
    secondary:
      "CGS (Centimetre-Gram-Second system) unit of the electrical charge, where the charge amounts to exactly 1 Fr where the force of 1 dyn on an equal load is performed at a distance of 1 cm.",
  },
  {
    value: "N95",
    title: "ampere minute",
    secondary:
      "A unit of electric charge defining the amount of charge accumulated by a steady flow of one ampere for one minute..",
  },
  {
    value: "N96",
    title: "biot",
    secondary:
      "CGS (Centimetre-Gram-Second system) unit of the electric power which is defined by a force of 2 dyn per cm between two parallel conductors of infinite length with negligible cross-section in the distance of 1 cm.",
  },
  {
    value: "N97",
    title: "gilbert",
    secondary:
      "CGS (Centimetre-Gram-Second system) unit of the magnetomotive force, which is defined by the work to increase the magnetic potential of a positive common pol with 1 erg.",
  },
  {
    value: "N98",
    title: "volt per pascal",
    secondary: "Derived SI unit volt divided by the derived SI unit pascal.",
  },
  {
    value: "N99",
    title: "picovolt",
    secondary: "0,000 000 000 001-fold of the derived SI unit volt.",
  },
  {
    value: "NA",
    title: "milligram per kilogram",
    secondary: "",
  },
  {
    value: "NAR",
    title: "number of articles",
    secondary: "A unit of count defining the number of articles (article: item).",
  },
  {
    value: "NCL",
    title: "number of cells",
    secondary:
      "A unit of count defining the number of cells (cell: an enclosed or circumscribed space, cavity, or volume).",
  },
  {
    value: "NEW",
    title: "newton",
    secondary: "",
  },
  {
    value: "NF",
    title: "message",
    secondary: "A unit of count defining the number of messages.",
  },
  {
    value: "NIL",
    title: "nil",
    secondary: "A unit of count defining the number of instances of nothing.",
  },
  {
    value: "NIU",
    title: "number of international units",
    secondary: "A unit of count defining the number of international units.",
  },
  {
    value: "NL",
    title: "load",
    secondary:
      "A unit of volume defining the number of loads (load: a quantity of items carried or processed at one time).",
  },
  {
    value: "NM3",
    title: "Normalised cubic metre",
    secondary: "Normalised cubic metre (temperature 0°C and pressure 101325 millibars )",
  },
  {
    value: "NMI",
    title: "nautical mile",
    secondary: "",
  },
  {
    value: "NMP",
    title: "number of packs",
    secondary: "A unit of count defining the number of packs (pack: a collection of objects packaged together).",
  },
  {
    value: "NPT",
    title: "number of parts",
    secondary: "A unit of count defining the number of parts (part: component of a larger entity).",
  },
  {
    value: "NT",
    title: "net ton",
    secondary:
      "A unit of mass equal to 2000 pounds, see ton (US). Refer International Convention on tonnage measurement of Ships.",
  },
  {
    value: "NTU",
    title: "Nephelometric turbidity unit",
  },
  {
    value: "NU",
    title: "newton metre",
    secondary: "",
  },
  {
    value: "NX",
    title: "part per thousand",
    secondary: "A unit of proportion equal to 10⁻³. Synonym: per mille",
  },
  {
    value: "OA",
    title: "panel",
    secondary:
      "A unit of count defining the number of panels (panel: a distinct, usually rectangular, section of a surface).",
  },
  {
    value: "ODE",
    title: "ozone depletion equivalent",
    secondary:
      "A unit of mass defining the ozone depletion potential in kilograms of a product relative to the calculated depletion for the reference substance, Trichlorofluoromethane (CFC-11).",
  },
  {
    value: "ODG",
    title: "ODS Grams",
  },
  {
    value: "ODK",
    title: "ODS Kilograms",
  },
  {
    value: "ODM",
    title: "ODS Milligrams",
  },
  {
    value: "OHM",
    title: "ohm",
    secondary: "",
  },
  {
    value: "ON",
    title: "ounce per square yard",
    secondary: "",
  },
  {
    value: "ONZ",
    title: "ounce (avoirdupois)",
    secondary: "",
  },
  {
    value: "OPM",
    title: "oscillations per minute",
    secondary: "The number of oscillations per minute.",
  },
  {
    value: "OT",
    title: "overtime hour",
    secondary: "A unit of time defining the number of overtime hours.",
  },
  {
    value: "OZA",
    title: "fluid ounce (US)",
    secondary: "",
  },
  {
    value: "OZI",
    title: "fluid ounce (UK)",
    secondary: "",
  },
  {
    value: "P1",
    title: "percent",
    secondary: "A unit of proportion equal to 0.01.",
  },
  {
    value: "P10",
    title: "coulomb per metre",
    secondary: "Derived SI unit coulomb divided by the SI base unit metre.",
  },
  {
    value: "P11",
    title: "kiloweber",
    secondary: "1000 fold of the derived SI unit weber.",
  },
  {
    value: "P12",
    title: "gamma",
    secondary: "Unit of magnetic flow density.",
  },
  {
    value: "P13",
    title: "kilotesla",
    secondary: "1000-fold of the derived SI unit tesla.",
  },
  {
    value: "P14",
    title: "joule per second",
    secondary: "Quotient of the derived SI unit joule divided by the SI base unit second.",
  },
  {
    value: "P15",
    title: "joule per minute",
    secondary: "Quotient from the derived SI unit joule divided by the unit minute.",
  },
  {
    value: "P16",
    title: "joule per hour",
    secondary: "Quotient from the derived SI unit joule divided by the unit hour.",
  },
  {
    value: "P17",
    title: "joule per day",
    secondary: "Quotient from the derived SI unit joule divided by the unit day.",
  },
  {
    value: "P18",
    title: "kilojoule per second",
    secondary: "Quotient from the 1000-fold of the derived SI unit joule divided by the SI base unit second.",
  },
  {
    value: "P19",
    title: "kilojoule per minute",
    secondary: "Quotient from the 1000-fold of the derived SI unit joule divided by the unit minute.",
  },
  {
    value: "P2",
    title: "pound per foot",
    secondary: "",
  },
  {
    value: "P20",
    title: "kilojoule per hour",
    secondary: "Quotient from the 1000-fold of the derived SI unit joule divided by the unit hour.",
  },
  {
    value: "P21",
    title: "kilojoule per day",
    secondary: "Quotient from the 1000-fold of the derived SI unit joule divided by the unit day.",
  },
  {
    value: "P22",
    title: "nanoohm",
    secondary: "0,000 000 001-fold of the derived SI unit ohm.",
  },
  {
    value: "P23",
    title: "ohm circular-mil per foot",
    secondary: "Unit of resistivity.",
  },
  {
    value: "P24",
    title: "kilohenry",
    secondary: "1000-fold of the derived SI unit henry.",
  },
  {
    value: "P25",
    title: "lumen per square foot",
    secondary:
      "Derived SI unit lumen divided by the power of the unit foot according to the Anglo-American and Imperial system of units by exponent 2.",
  },
  {
    value: "P26",
    title: "phot",
    secondary: "CGS (Centimetre-Gram-Second system) unit of luminance, defined as lumen by square centimetre.",
  },
  {
    value: "P27",
    title: "footcandle",
    secondary:
      "Non SI conform traditional unit, defined as density of light which impinges on a surface which has a distance of one foot from a light source, which shines with an intensity of an international candle.",
  },
  {
    value: "P28",
    title: "candela per square inch",
    secondary:
      "SI base unit candela divided by the power of unit inch according to the Anglo-American and Imperial system of units by exponent 2.",
  },
  {
    value: "P29",
    title: "footlambert",
    secondary:
      "Unit of the luminance according to the Anglo-American system of units, defined as emitted or reflected luminance of a lm/ft².",
  },
  {
    value: "P30",
    title: "lambert",
    secondary:
      "CGS (Centimetre-Gram-Second system) unit of luminance, defined as the emitted or reflected luminance by one lumen per square centimetre.",
  },
  {
    value: "P31",
    title: "stilb",
    secondary:
      "CGS (Centimetre-Gram-Second system) unit of luminance, defined as emitted or reflected luminance by one lumen per square centimetre.",
  },
  {
    value: "P32",
    title: "candela per square foot",
    secondary:
      "Base unit SI candela divided by the power of the unit foot according to the Anglo-American and Imperial system of units by exponent 2.",
  },
  {
    value: "P33",
    title: "kilocandela",
    secondary: "1000-fold of the SI base unit candela.",
  },
  {
    value: "P34",
    title: "millicandela",
    secondary: "0,001-fold of the SI base unit candela.",
  },
  {
    value: "P35",
    title: "Hefner-Kerze",
    secondary: "Obsolete, non-legal unit of the power in Germany relating to DIN 1301-3:1979: 1 HK = 0,903 cd.",
  },
  {
    value: "P36",
    title: "international candle",
    secondary: "Obsolete, non-legal unit of the power in Germany relating to DIN 1301-3:1979: 1 HK = 1,019 cd.",
  },
  {
    value: "P37",
    title: "British thermal unit (international table) per square foot",
    secondary: "Unit of the areal-related energy transmission according to the Imperial system of units.",
  },
  {
    value: "P38",
    title: "British thermal unit (thermochemical) per square foot",
    secondary: "Unit of the areal-related energy transmission according to the Imperial system of units.",
  },
  {
    value: "P39",
    title: "calorie (thermochemical) per square centimetre",
    secondary: "Unit of the areal-related energy transmission according to the Imperial system of units.",
  },
  {
    value: "P40",
    title: "langley",
    secondary:
      "CGS (Centimetre-Gram-Second system) unit of the areal-related energy transmission (as a measure of the incident quantity of heat of solar radiation on the earth's surface).",
  },
  {
    value: "P41",
    title: "decade (logarithmic)",
    secondary:
      "1 Dec := log2 10 ˜ 3,32 according to the logarithm for frequency range between f1 and f2, when f2/f1 = 10.",
  },
  {
    value: "P42",
    title: "pascal squared second",
    secondary:
      "Unit of the set as a product of the power of derived SI unit pascal with exponent 2 and the SI base unit second.",
  },
  {
    value: "P43",
    title: "bel per metre",
    secondary: "Unit bel divided by the SI base unit metre.",
  },
  {
    value: "P44",
    title: "pound mole",
    secondary:
      "Non SI-conforming unit of quantity of a substance relating that one pound mole of a chemical composition corresponds to the same number of pounds as the molecular weight of one molecule of this composition in atomic mass units.",
  },
  {
    value: "P45",
    title: "pound mole per second",
    secondary:
      "Non SI-conforming unit of the power of the amount of substance non-SI compliant unit of the molar flux relating that a pound mole of a chemical composition the same number of pound corresponds like the molecular weight of a molecule of this composition in atomic mass units.",
  },
  {
    value: "P46",
    title: "pound mole per minute",
    secondary:
      "Non SI-conforming unit of the power of the amount of substance non-SI compliant unit of the molar flux relating that a pound mole of a chemical composition the same number of pound corresponds like the molecular weight of a molecule of this composition in atomic mass units.",
  },
  {
    value: "P47",
    title: "kilomole per kilogram",
    secondary: "1000-fold of the SI base unit mol divided by the SI base unit kilogram.",
  },
  {
    value: "P48",
    title: "pound mole per pound",
    secondary:
      "Non SI-conforming unit of the material molar flux divided by the avoirdupois pound for mass according to the avoirdupois unit system.",
  },
  {
    value: "P49",
    title: "newton square metre per ampere",
    secondary:
      "Product of the derived SI unit newton and the power of SI base unit metre with exponent 2 divided by the SI base unit ampere.",
  },
  {
    value: "P5",
    title: "five pack",
    secondary: "A unit of count defining the number of five-packs (five-pack: set of five items packaged together).",
  },
  {
    value: "P50",
    title: "weber metre",
    secondary: "Product of the derived SI unit weber and SI base unit metre.",
  },
  {
    value: "P51",
    title: "mol per kilogram pascal",
    secondary: "SI base unit mol divided by the product of the SI base unit kilogram and the derived SI unit pascal.",
  },
  {
    value: "P52",
    title: "mol per cubic metre pascal",
    secondary:
      "SI base unit mol divided by the product of the power from the SI base unit metre with exponent 3 and the derived SI unit pascal.",
  },
  {
    value: "P53",
    title: "unit pole",
    secondary:
      "CGS (Centimetre-Gram-Second system) unit for magnetic flux of a magnetic pole (according to the interaction of identical poles of 1 dyn at a distance of a cm).",
  },
  {
    value: "P54",
    title: "milligray per second",
    secondary: "0,001-fold of the derived SI unit gray divided by the SI base unit second.",
  },
  {
    value: "P55",
    title: "microgray per second",
    secondary: "0,000 001-fold of the derived SI unit gray divided by the SI base unit second.",
  },
  {
    value: "P56",
    title: "nanogray per second",
    secondary: "0,000 000 001-fold of the derived SI unit gray divided by the SI base unit second.",
  },
  {
    value: "P57",
    title: "gray per minute",
    secondary: "SI derived unit gray divided by the unit minute.",
  },
  {
    value: "P58",
    title: "milligray per minute",
    secondary: "0,001-fold of the derived SI unit gray divided by the unit minute.",
  },
  {
    value: "P59",
    title: "microgray per minute",
    secondary: "0,000 001-fold of the derived SI unit gray divided by the unit minute.",
  },
  {
    value: "P60",
    title: "nanogray per minute",
    secondary: "0,000 000 001-fold of the derived SI unit gray divided by the unit minute.",
  },
  {
    value: "P61",
    title: "gray per hour",
    secondary: "SI derived unit gray divided by the unit hour.",
  },
  {
    value: "P62",
    title: "milligray per hour",
    secondary: "0,001-fold of the derived SI unit gray divided by the unit hour.",
  },
  {
    value: "P63",
    title: "microgray per hour",
    secondary: "0,000 001-fold of the derived SI unit gray divided by the unit hour.",
  },
  {
    value: "P64",
    title: "nanogray per hour",
    secondary: "0,000 000 001-fold of the derived SI unit gray divided by the unit hour.",
  },
  {
    value: "P65",
    title: "sievert per second",
    secondary: "Derived SI unit sievert divided by the SI base unit second.",
  },
  {
    value: "P66",
    title: "millisievert per second",
    secondary: "0,001-fold of the derived SI unit sievert divided by the SI base unit second.",
  },
  {
    value: "P67",
    title: "microsievert per second",
    secondary: "0,000 001-fold of the derived SI unit sievert divided by the SI base unit second.",
  },
  {
    value: "P68",
    title: "nanosievert per second",
    secondary: "0,000 000 001-fold of the derived SI unit sievert divided by the SI base unit second.",
  },
  {
    value: "P69",
    title: "rem per second",
    secondary: "Unit for the equivalent tin rate relating to DIN 1301-3:1979: 1 rem/s = 0,01 J/(kg·s) = 1 Sv/s.",
  },
  {
    value: "P70",
    title: "sievert per hour",
    secondary: "Derived SI unit sievert divided by the unit hour.",
  },
  {
    value: "P71",
    title: "millisievert per hour",
    secondary: "0,001-fold of the derived SI unit sievert divided by the unit hour.",
  },
  {
    value: "P72",
    title: "microsievert per hour",
    secondary: "0,000 001-fold of the derived SI unit sievert divided by the unit hour.",
  },
  {
    value: "P73",
    title: "nanosievert per hour",
    secondary: "0,000 000 001-fold of the derived SI unit sievert divided by the unit hour.",
  },
  {
    value: "P74",
    title: "sievert per minute",
    secondary: "Derived SI unit sievert divided by the unit minute.",
  },
  {
    value: "P75",
    title: "millisievert per minute",
    secondary: "0,001-fold of the derived SI unit sievert divided by the unit minute.",
  },
  {
    value: "P76",
    title: "microsievert per minute",
    secondary: "0,000 001-fold of the derived SI unit sievert divided by the unit minute.",
  },
  {
    value: "P77",
    title: "nanosievert per minute",
    secondary: "0,000 000 001-fold of the derived SI unit sievert divided by the unit minute.",
  },
  {
    value: "P78",
    title: "reciprocal square inch",
    secondary:
      "Complement of the power of the unit inch according to the Anglo-American and Imperial system of units by exponent 2.",
  },
  {
    value: "P79",
    title: "pascal square metre per kilogram",
    secondary:
      "Unit of the burst index as derived unit for pressure pascal related to the substance, represented as a quotient from the SI base unit kilogram divided by the power of the SI base unit metre by exponent 2.",
  },
  {
    value: "P80",
    title: "millipascal per metre",
    secondary: "0,001-fold of the derived SI unit pascal divided by the SI base unit metre.",
  },
  {
    value: "P81",
    title: "kilopascal per metre",
    secondary: "1000-fold of the derived SI unit pascal divided by the SI base unit metre.",
  },
  {
    value: "P82",
    title: "hectopascal per metre",
    secondary: "100-fold of the derived SI unit pascal divided by the SI base unit metre.",
  },
  {
    value: "P83",
    title: "standard atmosphere per metre",
    secondary: "Outdated unit of the pressure divided by the SI base unit metre.",
  },
  {
    value: "P84",
    title: "technical atmosphere per metre",
    secondary:
      "Obsolete and non-legal unit of the pressure which is generated by a 10 metre water column divided by the SI base unit metre.",
  },
  {
    value: "P85",
    title: "torr per metre",
    secondary: "CGS (Centimetre-Gram-Second system) unit of the pressure divided by the SI base unit metre.",
  },
  {
    value: "P86",
    title: "psi per inch",
    secondary:
      "Compound unit for pressure (pound-force according to the Anglo-American unit system divided by the power of the unit inch according to the Anglo-American and Imperial system of units with the exponent 2) divided by the unit inch according to the Anglo-American and Imperial system of units .",
  },
  {
    value: "P87",
    title: "cubic metre per second square metre",
    secondary: "Unit of volume flow cubic meters by second related to the transmission surface in square metres.",
  },
  {
    value: "P88",
    title: "rhe",
    secondary: "Non SI-conforming unit of fluidity of dynamic viscosity.",
  },
  {
    value: "P89",
    title: "pound-force foot per inch",
    secondary:
      "Unit for length-related rotational moment according to the Anglo-American and Imperial system of units.",
  },
  {
    value: "P90",
    title: "pound-force inch per inch",
    secondary:
      "Unit for length-related rotational moment according to the Anglo-American and Imperial system of units.",
  },
  {
    value: "P91",
    title: "perm (0 ºC)",
    secondary:
      "Traditional unit for the ability of a material to allow the transition of the steam, defined at a temperature of 0 °C as steam transmittance, where the mass of one grain steam penetrates an area of one foot squared at a pressure from one inch mercury per hour.",
  },
  {
    value: "P92",
    title: "perm (23 ºC)",
    secondary:
      "Traditional unit for the ability of a material to allow the transition of the steam, defined at a temperature of 23 °C as steam transmittance at which the mass of one grain of steam penetrates an area of one square foot at a pressure of one inch mercury per hour.",
  },
  {
    value: "P93",
    title: "byte per second",
    secondary: "Unit byte divided by the SI base unit second.",
  },
  {
    value: "P94",
    title: "kilobyte per second",
    secondary: "1000-fold of the unit byte divided by the SI base unit second.",
  },
  {
    value: "P95",
    title: "megabyte per second",
    secondary: "1 000 000-fold of the unit byte divided by the SI base unit second.",
  },
  {
    value: "P96",
    title: "reciprocal volt",
    secondary: "Reciprocal of the derived SI unit volt.",
  },
  {
    value: "P97",
    title: "reciprocal radian",
    secondary: "Reciprocal of the unit radian.",
  },
  {
    value: "P98",
    title: "pascal to the power sum of stoichiometric numbers",
    secondary: "Unit of the equilibrium constant on the basis of the pressure(ISO 80000-9:2009, 9-35.a).",
  },
  {
    value: "P99",
    title: "mole per cubiv metre to the power sum of stoichiometric numbers",
    secondary: "Unit of the equilibrium constant on the basis of the concentration (ISO 80000-9:2009, 9-36.a).",
  },
  {
    value: "PAL",
    title: "pascal",
    secondary: "",
  },
  {
    value: "PD",
    title: "pad",
    secondary: "A unit of count defining the number of pads (pad: block of paper sheets fastened together at one end).",
  },
  {
    value: "PFL",
    title: "proof litre",
    secondary:
      "A unit of volume equal to one litre of proof spirits, or the alcohol equivalent thereof. Used for measuring the strength of distilled alcoholic liquors, expressed as a percentage of the alcohol content of a standard mixture at a specific temperature.",
  },
  {
    value: "PGL",
    title: "proof gallon",
    secondary:
      "A unit of volume equal to one gallon of proof spirits, or the alcohol equivalent thereof. Used for measuring the strength of distilled alcoholic liquors, expressed as a percentage of the alcohol content of a standard mixture at a specific temperature.",
  },
  {
    value: "PI",
    title: "pitch",
    secondary: "A unit of count defining the number of characters that fit in a horizontal inch.",
  },
  {
    value: "PLA",
    title: "degree Plato",
    secondary: "A unit of proportion defining the sugar content of a product, especially in relation to beer.",
  },
  {
    value: "PO",
    title: "pound per inch of length",
    secondary: "",
  },
  {
    value: "PQ",
    title: "page per inch",
    secondary:
      "A unit of quantity defining the degree of thickness of a bound publication, expressed as the number of pages per inch of thickness.",
  },
  {
    value: "PR",
    title: "pair",
    secondary: "A unit of count defining the number of pairs (pair: item described by two's).",
  },
  {
    value: "PS",
    title: "pound-force per square inch",
    secondary: "",
  },
  {
    value: "PTD",
    title: "dry pint (US)",
    secondary: "",
  },
  {
    value: "PTI",
    title: "pint (UK)",
    secondary: "",
  },
  {
    value: "PTL",
    title: "liquid pint (US)",
    secondary: "",
  },
  {
    value: "PTN",
    title: "portion",
    secondary: "A quantity of allowance of food allotted to, or enough for, one person.",
  },
  {
    value: "Q10",
    title: "joule per tesla",
    secondary:
      "Unit of the magnetic dipole moment of the molecule as derived SI unit joule divided by the derived SI unit tesla.",
  },
  {
    value: "Q11",
    title: "erlang",
    secondary:
      "Unit of the market value according to the feature of a single feature as a statistical measurement of the existing utilization.",
  },
  {
    value: "Q12",
    title: "octet",
    secondary: "Synonym for byte: 1 octet = 8 bit = 1 byte.",
  },
  {
    value: "Q13",
    title: "octet per second",
    secondary: "Unit octet divided by the SI base unit second.",
  },
  {
    value: "Q14",
    title: "shannon",
    secondary:
      "Logarithmic unit for information equal to the content of decision of a sentence of two mutually exclusive events, expressed as a logarithm to base 2.",
  },
  {
    value: "Q15",
    title: "hartley",
    secondary:
      "Logarithmic unit for information equal to the content of decision of a sentence of ten mutually exclusive events, expressed as a logarithm to base 10.",
  },
  {
    value: "Q16",
    title: "natural unit of information",
    secondary:
      "Logarithmic unit for information equal to the content of decision of a sentence of ,718 281 828 459 mutually exclusive events, expressed as a logarithm to base Euler value e.",
  },
  {
    value: "Q17",
    title: "shannon per second",
    secondary:
      "Time related logarithmic unit for information equal to the content of decision of a sentence of two mutually exclusive events, expressed as a logarithm to base 2.",
  },
  {
    value: "Q18",
    title: "hartley per second",
    secondary:
      "Time related logarithmic unit for information equal to the content of decision of a sentence of ten mutually exclusive events, expressed as a logarithm to base 10.",
  },
  {
    value: "Q19",
    title: "natural unit of information per second",
    secondary:
      "Time related logarithmic unit for information equal to the content of decision of a sentence of 2,718 281 828 459 mutually exclusive events, expressed as a logarithm to base of the Euler value e.",
  },
  {
    value: "Q20",
    title: "second per kilogramm",
    secondary:
      "Unit of the Einstein transition probability for spontaneous or inducing emissions and absorption according to ISO 80000-7:2008, expressed as SI base unit second divided by the SI base unit kilogram.",
  },
  {
    value: "Q21",
    title: "watt square metre",
    secondary:
      "Unit of the first radiation constants c1 = 2·p·h·c0², the value of which is 3,741 771 18·10?¹6-fold that of the comparative value of the product of the derived SI unit watt multiplied with the power of the SI base unit metre with the exponent 2.",
  },
  {
    value: "Q22",
    title: "second per radian cubic metre",
    secondary:
      "Unit of the density of states as an expression of angular frequency as complement of the product of hertz and radiant and the power of SI base unit metre by exponent 3 .",
  },
  {
    value: "Q23",
    title: "weber to the power minus one",
    secondary:
      "Complement of the derived SI unit weber as unit of the Josephson constant, which value is equal to the 384 597,891-fold of the reference value gigahertz divided by volt.",
  },
  {
    value: "Q24",
    title: "reciprocal inch",
    secondary: "Complement of the unit inch according to the Anglo-American and Imperial system of units.",
  },
  {
    value: "Q25",
    title: "dioptre",
    secondary:
      "Unit used at the statement of relative refractive indexes of optical systems as complement of the focal length with correspondence to: 1 dpt = 1/m.",
  },
  {
    value: "Q26",
    title: "one per one",
    secondary:
      "Value of the quotient from two physical units of the same kind as a numerator and denominator whereas the units are shortened mutually.",
  },
  {
    value: "Q27",
    title: "newton metre per metre",
    secondary:
      "Unit for length-related rotational moment as product of the derived SI unit newton and the SI base unit metre divided by the SI base unit metre.",
  },
  {
    value: "Q28",
    title: "kilogram per square metre pascal second",
    secondary: "Unit for the ability of a material to allow the transition of steam.",
  },
  {
    value: "Q29",
    title: "microgram per hectogram",
    secondary: "Microgram per hectogram.",
  },
  {
    value: "Q30",
    title: "pH (potential of Hydrogen)",
    secondary:
      "The activity of the (solvated) hydrogen ion (a logarithmic measure used to state the acidity or alkalinity of a chemical solution).",
  },
  {
    value: "Q31",
    title: "kilojoule per gram",
    secondary: "",
  },
  {
    value: "Q32",
    title: "femtolitre",
    secondary: "",
  },
  {
    value: "Q33",
    title: "picolitre",
    secondary: "",
  },
  {
    value: "Q34",
    title: "nanolitre",
    secondary: "",
  },
  {
    value: "Q35",
    title: "megawatts per minute",
    secondary: "A unit of power defining the total amount of bulk energy transferred or consumer per minute.",
  },
  {
    value: "Q36",
    title: "square metre per cubic metre",
    secondary: "A unit of the amount of surface area per unit volume of an object or collection of objects.",
  },
  {
    value: "Q37",
    title: "Standard cubic metre per day",
    secondary: "Standard cubic metre (temperature 15°C and pressure 101325 millibars ) per day",
  },
  {
    value: "Q38",
    title: "Standard cubic metre per hour",
    secondary: "Standard cubic metre (temperature 15°C and pressure 101325 millibars ) per hour",
  },
  {
    value: "Q39",
    title: "Normalized cubic metre per day",
    secondary: "Normalized cubic metre (temperature 0°C and pressure 101325 millibars ) per day",
  },
  {
    value: "Q40",
    title: "Normalized cubic metre per hour",
    secondary: "Normalized cubic metre (temperature 0°C and pressure 101325 millibars ) per hour",
  },
  {
    value: "Q41",
    title: "Joule per normalised cubic metre",
  },
  {
    value: "Q42",
    title: "Joule per standard cubic metre",
  },
  {
    value: "Q3",
    title: "meal",
    secondary:
      "A unit of count defining the number of meals (meal: an amount of food to be eaten on a single occasion).",
  },
  {
    value: "QA",
    title: "page - facsimile",
    secondary: "A unit of count defining the number of facsimile pages.",
  },
  {
    value: "QAN",
    title: "quarter (of a year)",
    secondary: "A unit of time defining the number of quarters (3 months).",
  },
  {
    value: "QB",
    title: "page - hardcopy",
    secondary:
      "A unit of count defining the number of hardcopy pages (hardcopy page: a page rendered as printed or written output on paper, film, or other permanent medium).",
  },
  {
    value: "QR",
    title: "quire",
    secondary:
      "A unit of count for paper, expressed as the number of quires (quire: a number of paper sheets, typically 25).",
  },
  {
    value: "QTD",
    title: "dry quart (US)",
    secondary: "",
  },
  {
    value: "QTI",
    title: "quart (UK)",
    secondary: "",
  },
  {
    value: "QTL",
    title: "liquid quart (US)",
    secondary: "",
  },
  {
    value: "QTR",
    title: "quarter (UK)",
    secondary:
      "A traditional unit of weight equal to 1/4 hundredweight. In the United Kingdom, one quarter equals 28 pounds.",
  },
  {
    value: "R1",
    title: "pica",
    secondary:
      "A unit of count defining the number of picas. (pica: typographical length equal to 12 points or 4.22 mm (approx.)).",
  },
  {
    value: "R9",
    title: "thousand cubic metre",
    secondary: "A unit of volume equal to one thousand cubic metres.",
  },
  {
    value: "RH",
    title: "running or operating hour",
    secondary: "A unit of time defining the number of hours of operation.",
  },
  {
    value: "RM",
    title: "ream",
    secondary:
      "A unit of count for paper, expressed as the number of reams (ream: a large quantity of paper sheets, typically 500).",
  },
  {
    value: "ROM",
    title: "room",
    secondary: "A unit of count defining the number of rooms.",
  },
  {
    value: "RP",
    title: "pound per ream",
    secondary:
      "A unit of mass for paper, expressed as pounds per ream. (ream: a large quantity of paper, typically 500 sheets).",
  },
  {
    value: "RPM",
    title: "revolutions per minute",
    secondary: "Refer ISO/TC12 SI Guide",
  },
  {
    value: "RPS",
    title: "revolutions per second",
    secondary: "Refer ISO/TC12 SI Guide",
  },
  {
    value: "RT",
    title: "revenue ton mile",
    secondary:
      "A unit of information typically used for billing purposes, expressed as the number of revenue tons (revenue ton: either a metric ton or a cubic metres, whichever is the larger), moved over a distance of one mile.",
  },
  {
    value: "S3",
    title: "square foot per second",
    secondary: "Synonym: foot squared per second",
  },
  {
    value: "S4",
    title: "square metre per second",
    secondary: "Synonym: metre squared per second (square metres/second US)",
  },
  {
    value: "SAN",
    title: "half year (6 months)",
    secondary: "A unit of time defining the number of half years (6 months).",
  },
  {
    value: "SCO",
    title: "score",
    secondary: "A unit of count defining the number of units in multiples of 20.",
  },
  {
    value: "SCR",
    title: "scruple",
    secondary: "",
  },
  {
    value: "SEC",
    title: "second [unit of time]",
    secondary: "",
  },
  {
    value: "SET",
    title: "set",
    secondary: "A unit of count defining the number of sets (set: a number of objects grouped together).",
  },
  {
    value: "SG",
    title: "segment",
    secondary: "A unit of information equal to 64000 bytes.",
  },
  {
    value: "SIE",
    title: "siemens",
    secondary: "",
  },
  {
    value: "SM3",
    title: "Standard cubic metre",
    secondary: "Standard cubic metre (temperature 15°C and pressure 101325 millibars )",
  },
  {
    value: "SMI",
    title: "mile (statute mile)",
    secondary: "",
  },
  {
    value: "SQ",
    title: "square",
    secondary: "A unit of count defining the number of squares (square: rectangular shape).",
  },
  {
    value: "SQR",
    title: "square, roofing",
    secondary:
      "A unit of count defining the number of squares of roofing materials, measured in multiples of 100 square feet.",
  },
  {
    value: "SR",
    title: "strip",
    secondary: "A unit of count defining the number of strips (strip: long narrow piece of an object).",
  },
  {
    value: "STC",
    title: "stick",
    secondary:
      "A unit of count defining the number of sticks (stick: slender and often cylindrical piece of a substance).",
  },
  {
    value: "STI",
    title: "stone (UK)",
    secondary: "",
  },
  {
    value: "STK",
    title: "stick, cigarette",
    secondary:
      "A unit of count defining the number of cigarettes in the smallest unit for stock-taking and/or duty computation.",
  },
  {
    value: "STL",
    title: "standard litre",
    secondary:
      "A unit of volume defining the number of litres of a product at a temperature of 15 degrees Celsius, especially in relation to hydrocarbon oils.",
  },
  {
    value: "STN",
    title: "ton (US) or short ton (UK/US)",
    secondary: "Synonym: net ton (2000 lb)",
  },
  {
    value: "STW",
    title: "straw",
    secondary: "A unit of count defining the number of straws (straw: a slender tube used for sucking up liquids).",
  },
  {
    value: "SW",
    title: "skein",
    secondary: "A unit of count defining the number of skeins (skein: a loosely-coiled bundle of yarn or thread).",
  },
  {
    value: "SX",
    title: "shipment",
    secondary:
      "A unit of count defining the number of shipments (shipment: an amount of goods shipped or transported).",
  },
  {
    value: "SYR",
    title: "syringe",
    secondary:
      "A unit of count defining the number of syringes (syringe: a small device for pumping, spraying and/or injecting liquids through a small aperture).",
  },
  {
    value: "T0",
    title: "telecommunication line in service",
    secondary: "A unit of count defining the number of lines in service.",
  },
  {
    value: "T3",
    title: "thousand piece",
    secondary:
      "A unit of count defining the number of pieces in multiples of 1000 (piece: a single item, article or exemplar).",
  },
  {
    value: "TAH",
    title: "kiloampere hour (thousand ampere hour)",
    secondary: "",
  },
  {
    value: "TAN",
    title: "total acid number",
    secondary:
      "A unit of chemistry defining the amount of potassium hydroxide (KOH) in milligrams that is needed to neutralize the acids in one gram of oil. It is an important quality measurement of crude oil.",
  },
  {
    value: "TI",
    title: "thousand square inch",
    secondary: "",
  },
  {
    value: "TIC",
    title: "metric ton, including container",
    secondary: "A unit of mass defining the number of metric tons of a product, including its container.",
  },
  {
    value: "TIP",
    title: "metric ton, including inner packaging",
    secondary:
      "A unit of mass defining the number of metric tons of a product, including its inner packaging materials.",
  },
  {
    value: "TKM",
    title: "tonne kilometre",
    secondary:
      "A unit of information typically used for billing purposes, expressed as the number of tonnes (metric tons) moved over a distance of one kilometre.",
  },
  {
    value: "TMS",
    title: "kilogram of imported meat, less offal",
    secondary:
      "A unit of mass equal to one thousand grams of imported meat, disregarding less valuable by-products such as the entrails.",
  },
  {
    value: "TNE",
    title: "tonne (metric ton)",
    secondary: "Synonym: metric ton",
  },
  {
    value: "TP",
    title: "ten pack",
    secondary: "A unit of count defining the number of items in multiples of 10.",
  },
  {
    value: "TPI",
    title: "teeth per inch",
    secondary: "The number of teeth per inch.",
  },
  {
    value: "TPR",
    title: "ten pair",
    secondary: "A unit of count defining the number of pairs in multiples of 10 (pair: item described by two's).",
  },
  {
    value: "TQD",
    title: "thousand cubic metre per day",
    secondary: "A unit of volume equal to one thousand cubic metres per day.",
  },
  {
    value: "TRL",
    title: "trillion (EUR)",
    secondary: "",
  },
  {
    value: "TST",
    title: "ten set",
    secondary:
      "A unit of count defining the number of sets in multiples of 10 (set: a number of objects grouped together).",
  },
  {
    value: "TTS",
    title: "ten thousand sticks",
    secondary:
      "A unit of count defining the number of sticks in multiples of 10000 (stick: slender and often cylindrical piece of a substance).",
  },
  {
    value: "U1",
    title: "treatment",
    secondary:
      "A unit of count defining the number of treatments (treatment: subjection to the action of a chemical, physical or biological agent).",
  },
  {
    value: "U2",
    title: "tablet",
    secondary: "A unit of count defining the number of tablets (tablet: a small flat or compressed solid object).",
  },
  {
    value: "UB",
    title: "telecommunication line in service average",
    secondary: "A unit of count defining the average number of lines in service.",
  },
  {
    value: "UC",
    title: "telecommunication port",
    secondary: "A unit of count defining the number of network access ports.",
  },
  {
    value: "VA",
    title: "volt - ampere per kilogram",
    secondary: "",
  },
  {
    value: "VLT",
    title: "volt",
    secondary: "",
  },
  {
    value: "VP",
    title: "percent volume",
    secondary: "A measure of concentration, typically expressed as the percentage volume of a solute in a solution.",
  },
  {
    value: "W2",
    title: "wet kilo",
    secondary:
      "A unit of mass defining the number of kilograms of a product, including the water content of the product.",
  },
  {
    value: "WA",
    title: "watt per kilogram",
    secondary: "",
  },
  {
    value: "WB",
    title: "wet pound",
    secondary:
      "A unit of mass defining the number of pounds of a material, including the water content of the material.",
  },
  {
    value: "WCD",
    title: "cord",
    secondary: "A unit of volume used for measuring lumber. One board foot equals 1/12 of a cubic foot.",
  },
  {
    value: "WE",
    title: "wet ton",
    secondary: "A unit of mass defining the number of tons of a material, including the water content of the material.",
  },
  {
    value: "WEB",
    title: "weber",
    secondary: "",
  },
  {
    value: "WEE",
    title: "week",
    secondary: "",
  },
  {
    value: "WG",
    title: "wine gallon",
    secondary: "A unit of volume equal to 231 cubic inches.",
  },
  {
    value: "WHR",
    title: "watt hour",
    secondary: "",
  },
  {
    value: "WM",
    title: "working month",
    secondary: "A unit of time defining the number of working months.",
  },
  {
    value: "WSD",
    title: "standard",
    secondary: "A unit of volume of finished lumber equal to 165 cubic feet. Synonym: standard cubic foot",
  },
  {
    value: "WTT",
    title: "watt",
    secondary: "",
  },
  {
    value: "X1",
    title: "Gunter's chain",
    secondary: "A unit of distance used or formerly used by British surveyors.",
  },
  {
    value: "YDK",
    title: "square yard",
    secondary: "",
  },
  {
    value: "YDQ",
    title: "cubic yard",
    secondary: "",
  },
  {
    value: "YRD",
    title: "yard",
    secondary: "",
  },
  {
    value: "Z11",
    title: "hanging container",
    secondary: "A unit of count defining the number of hanging containers.",
  },
  {
    value: "Z9",
    title: "nanomole",
  },
  {
    value: "ZP",
    title: "page",
    secondary: "A unit of count defining the number of pages.",
  },
  {
    value: "ZZ",
    title: "mutually defined",
    secondary: "A unit of measure as agreed in common between two or more parties.",
  },
  {
    value: "X1A",
    title: "Drum, steel",
  },
  {
    value: "X1B",
    title: "Drum, aluminium",
  },
  {
    value: "X1D",
    title: "Drum, plywood",
  },
  {
    value: "X1F",
    title: "Container, flexible",
    secondary: "A packaging container of flexible construction.",
  },
  {
    value: "X1G",
    title: "Drum, fibre",
  },
  {
    value: "X1W",
    title: "Drum, wooden",
  },
  {
    value: "X2C",
    title: "Barrel, wooden",
  },
  {
    value: "X3A",
    title: "Jerrican, steel",
  },
  {
    value: "X3H",
    title: "Jerrican, plastic",
  },
  {
    value: "X43",
    title: "Bag, super bulk",
    secondary: "A cloth plastic or paper based bag having the dimensions of the pallet on which it is constructed.",
  },
  {
    value: "X44",
    title: "Bag, polybag",
    secondary:
      "A type of plastic bag, typically used to wrap promotional pieces, publications, product samples, and/or catalogues.",
  },
  {
    value: "X4A",
    title: "Box, steel",
  },
  {
    value: "X4B",
    title: "Box, aluminium",
  },
  {
    value: "X4C",
    title: "Box, natural wood",
  },
  {
    value: "X4D",
    title: "Box, plywood",
  },
  {
    value: "X4F",
    title: "Box, reconstituted wood",
  },
  {
    value: "X4G",
    title: "Box, fibreboard",
  },
  {
    value: "X4H",
    title: "Box, plastic",
  },
  {
    value: "X5H",
    title: "Bag, woven plastic",
  },
  {
    value: "X5L",
    title: "Bag, textile",
  },
  {
    value: "X5M",
    title: "Bag, paper",
  },
  {
    value: "X6H",
    title: "Composite packaging, plastic receptacle",
  },
  {
    value: "X6P",
    title: "Composite packaging, glass receptacle",
  },
  {
    value: "X7A",
    title: "Case, car",
    secondary: "A type of portable container designed to store equipment for carriage in an automobile.",
  },
  {
    value: "X7B",
    title: "Case, wooden",
    secondary: "A case made of wood for retaining substances or articles.",
  },
  {
    value: "X8A",
    title: "Pallet, wooden",
    secondary:
      "A platform or open-ended box, made of wood, on which goods are retained for ease of mechanical handling during transport and storage.",
  },
  {
    value: "X8B",
    title: "Crate, wooden",
    secondary:
      "A receptacle, made of wood, on which goods are retained for ease of mechanical handling during transport and storage.",
  },
  {
    value: "X8C",
    title: "Bundle, wooden",
    secondary: "Loose or unpacked pieces of wood tied or wrapped together.",
  },
  {
    value: "XAA",
    title: "Intermediate bulk container, rigid plastic",
  },
  {
    value: "XAB",
    title: "Receptacle, fibre",
    secondary: "Containment vessel made of fibre used for retaining substances or articles.",
  },
  {
    value: "XAC",
    title: "Receptacle, paper",
    secondary: "Containment vessel made of paper for retaining substances or articles.",
  },
  {
    value: "XAD",
    title: "Receptacle, wooden",
    secondary: "Containment vessel made of wood for retaining substances or articles.",
  },
  {
    value: "XAE",
    title: "Aerosol",
  },
  {
    value: "XAF",
    title: "Pallet, modular, collars 80cms * 60cms",
    secondary: "Standard sized pallet of dimensions 80 centimeters by 60 centimeters (cms).",
  },
  {
    value: "XAG",
    title: "Pallet, shrinkwrapped",
    secondary:
      "Pallet load secured with transparent plastic film that has been wrapped around and then shrunk tightly.",
  },
  {
    value: "XAH",
    title: "Pallet, 100cms * 110cms",
    secondary: "Standard sized pallet of dimensions 100centimeters by 110 centimeters (cms).",
  },
  {
    value: "XAI",
    title: "Clamshell",
  },
  {
    value: "XAJ",
    title: "Cone",
    secondary: "Container used in the transport of linear material such as yarn.",
  },
  {
    value: "XAL",
    title: "Ball",
    secondary: "A spherical containment vessel for retaining substances or articles.",
  },
  {
    value: "XAM",
    title: "Ampoule, non-protected",
  },
  {
    value: "XAP",
    title: "Ampoule, protected",
  },
  {
    value: "XAT",
    title: "Atomizer",
  },
  {
    value: "XAV",
    title: "Capsule",
  },
  {
    value: "XB4",
    title: "Belt",
    secondary: "A band use to retain multiple articles together.",
  },
  {
    value: "XBA",
    title: "Barrel",
  },
  {
    value: "XBB",
    title: "Bobbin",
  },
  {
    value: "XBC",
    title: "Bottlecrate / bottlerack",
  },
  {
    value: "XBD",
    title: "Board",
  },
  {
    value: "XBE",
    title: "Bundle",
  },
  {
    value: "XBF",
    title: "Balloon, non-protected",
  },
  {
    value: "XBG",
    title: "Bag",
    secondary: "A receptacle made of flexible material with an open or closed top.",
  },
  {
    value: "XBH",
    title: "Bunch",
  },
  {
    value: "XBI",
    title: "Bin",
  },
  {
    value: "XBJ",
    title: "Bucket",
  },
  {
    value: "XBK",
    title: "Basket",
  },
  {
    value: "XBL",
    title: "Bale, compressed",
  },
  {
    value: "XBM",
    title: "Basin",
  },
  {
    value: "XBN",
    title: "Bale, non-compressed",
  },
  {
    value: "XBO",
    title: "Bottle, non-protected, cylindrical",
    secondary: "A narrow-necked cylindrical shaped vessel without external protective packing material.",
  },
  {
    value: "XBP",
    title: "Balloon, protected",
  },
  {
    value: "XBQ",
    title: "Bottle, protected cylindrical",
    secondary: "A narrow-necked cylindrical shaped vessel with external protective packing material.",
  },
  {
    value: "XBR",
    title: "Bar",
  },
  {
    value: "XBS",
    title: "Bottle, non-protected, bulbous",
    secondary: "A narrow-necked bulb shaped vessel without external protective packing material.",
  },
  {
    value: "XBT",
    title: "Bolt",
  },
  {
    value: "XBU",
    title: "Butt",
  },
  {
    value: "XBV",
    title: "Bottle, protected bulbous",
    secondary: "A narrow-necked bulb shaped vessel with external protective packing material.",
  },
  {
    value: "XBW",
    title: "Box, for liquids",
  },
  {
    value: "XBX",
    title: "Box",
  },
  {
    value: "XBY",
    title: "Board, in bundle/bunch/truss",
  },
  {
    value: "XBZ",
    title: "Bars, in bundle/bunch/truss",
  },
  {
    value: "XCA",
    title: "Can, rectangular",
  },
  {
    value: "XCB",
    title: "Crate, beer",
  },
  {
    value: "XCC",
    title: "Churn",
  },
  {
    value: "XCD",
    title: "Can, with handle and spout",
  },
  {
    value: "XCE",
    title: "Creel",
  },
  {
    value: "XCF",
    title: "Coffer",
  },
  {
    value: "XCG",
    title: "Cage",
  },
  {
    value: "XCH",
    title: "Chest",
  },
  {
    value: "XCI",
    title: "Canister",
  },
  {
    value: "XCJ",
    title: "Coffin",
  },
  {
    value: "XCK",
    title: "Cask",
  },
  {
    value: "XCL",
    title: "Coil",
  },
  {
    value: "XCM",
    title: "Card",
    secondary: "A flat package usually made of fibreboard from/to which product is often hung or attached.",
  },
  {
    value: "XCN",
    title: "Container, not otherwise specified as transport equipment",
  },
  {
    value: "XCO",
    title: "Carboy, non-protected",
  },
  {
    value: "XCP",
    title: "Carboy, protected",
  },
  {
    value: "XCQ",
    title: "Cartridge",
    secondary: "Package containing a charge such as propelling explosive for firearms or ink toner for a printer.",
  },
  {
    value: "XCR",
    title: "Crate",
  },
  {
    value: "XCS",
    title: "Case",
  },
  {
    value: "XCT",
    title: "Carton",
  },
  {
    value: "XCU",
    title: "Cup",
  },
  {
    value: "XCV",
    title: "Cover",
  },
  {
    value: "XCW",
    title: "Cage, roll",
  },
  {
    value: "XCX",
    title: "Can, cylindrical",
  },
  {
    value: "XCY",
    title: "Cylinder",
  },
  {
    value: "XCZ",
    title: "Canvas",
  },
  {
    value: "XDA",
    title: "Crate, multiple layer, plastic",
  },
  {
    value: "XDB",
    title: "Crate, multiple layer, wooden",
  },
  {
    value: "XDC",
    title: "Crate, multiple layer, cardboard",
  },
  {
    value: "XDG",
    title: "Cage, Commonwealth Handling Equipment Pool (CHEP)",
  },
  {
    value: "XDH",
    title: "Box, Commonwealth Handling Equipment Pool (CHEP), Eurobox",
    secondary: "A box mounted on a pallet base under the control of CHEP.",
  },
  {
    value: "XDI",
    title: "Drum, iron",
  },
  {
    value: "XDJ",
    title: "Demijohn, non-protected",
  },
  {
    value: "XDK",
    title: "Crate, bulk, cardboard",
  },
  {
    value: "XDL",
    title: "Crate, bulk, plastic",
  },
  {
    value: "XDM",
    title: "Crate, bulk, wooden",
  },
  {
    value: "XDN",
    title: "Dispenser",
  },
  {
    value: "XDP",
    title: "Demijohn, protected",
  },
  {
    value: "XDR",
    title: "Drum",
  },
  {
    value: "XDS",
    title: "Tray, one layer no cover, plastic",
  },
  {
    value: "XDT",
    title: "Tray, one layer no cover, wooden",
  },
  {
    value: "XDU",
    title: "Tray, one layer no cover, polystyrene",
  },
  {
    value: "XDV",
    title: "Tray, one layer no cover, cardboard",
  },
  {
    value: "XDW",
    title: "Tray, two layers no cover, plastic tray",
  },
  {
    value: "XDX",
    title: "Tray, two layers no cover, wooden",
  },
  {
    value: "XDY",
    title: "Tray, two layers no cover, cardboard",
  },
  {
    value: "XEC",
    title: "Bag, plastic",
  },
  {
    value: "XED",
    title: "Case, with pallet base",
  },
  {
    value: "XEE",
    title: "Case, with pallet base, wooden",
  },
  {
    value: "XEF",
    title: "Case, with pallet base, cardboard",
  },
  {
    value: "XEG",
    title: "Case, with pallet base, plastic",
  },
  {
    value: "XEH",
    title: "Case, with pallet base, metal",
  },
  {
    value: "XEI",
    title: "Case, isothermic",
  },
  {
    value: "XEN",
    title: "Envelope",
  },
  {
    value: "XFB",
    title: "Flexibag",
    secondary:
      "A flexible containment bag made of plastic, typically for the transportation bulk non-hazardous cargoes using standard size shipping containers.",
  },
  {
    value: "XFC",
    title: "Crate, fruit",
  },
  {
    value: "XFD",
    title: "Crate, framed",
  },
  {
    value: "XFE",
    title: "Flexitank",
    secondary:
      "A flexible containment tank made of plastic, typically for the transportation bulk non-hazardous cargoes using standard size shipping containers.",
  },
  {
    value: "XFI",
    title: "Firkin",
  },
  {
    value: "XFL",
    title: "Flask",
  },
  {
    value: "XFO",
    title: "Footlocker",
  },
  {
    value: "XFP",
    title: "Filmpack",
  },
  {
    value: "XFR",
    title: "Frame",
  },
  {
    value: "XFT",
    title: "Foodtainer",
  },
  {
    value: "XFW",
    title: "Cart, flatbed",
    secondary:
      "Wheeled flat bedded device on which trays or other regular shaped items are packed for transportation purposes.",
  },
  {
    value: "XFX",
    title: "Bag, flexible container",
  },
  {
    value: "XGB",
    title: "Bottle, gas",
    secondary: "A narrow-necked metal cylinder for retention of liquefied or compressed gas.",
  },
  {
    value: "XGI",
    title: "Girder",
  },
  {
    value: "XGL",
    title: "Container, gallon",
    secondary: "A container with a capacity of one gallon.",
  },
  {
    value: "XGR",
    title: "Receptacle, glass",
    secondary: "Containment vessel made of glass for retaining substances or articles.",
  },
  {
    value: "XGU",
    title: "Tray, containing horizontally stacked flat items",
    secondary: "Tray containing flat items stacked on top of one another.",
  },
  {
    value: "XGY",
    title: "Bag, gunny",
    secondary:
      "A sack made of gunny or burlap, used for transporting coarse commodities, such as grains, potatoes, and other agricultural products.",
  },
  {
    value: "XGZ",
    title: "Girders, in bundle/bunch/truss",
  },
  {
    value: "XHA",
    title: "Basket, with handle, plastic",
  },
  {
    value: "XHB",
    title: "Basket, with handle, wooden",
  },
  {
    value: "XHC",
    title: "Basket, with handle, cardboard",
  },
  {
    value: "XHG",
    title: "Hogshead",
  },
  {
    value: "XHN",
    title: "Hanger",
    secondary: "A purpose shaped device with a hook at the top for hanging items from a rail.",
  },
  {
    value: "XHR",
    title: "Hamper",
  },
  {
    value: "XIA",
    title: "Package, display, wooden",
  },
  {
    value: "XIB",
    title: "Package, display, cardboard",
  },
  {
    value: "XIC",
    title: "Package, display, plastic",
  },
  {
    value: "XID",
    title: "Package, display, metal",
  },
  {
    value: "XIE",
    title: "Package, show",
  },
  {
    value: "XIF",
    title: "Package, flow",
    secondary:
      "A flexible tubular package or skin, possibly transparent, often used for containment of foodstuffs (e.g. salami sausage).",
  },
  {
    value: "XIG",
    title: "Package, paper wrapped",
  },
  {
    value: "XIH",
    title: "Drum, plastic",
  },
  {
    value: "XIK",
    title: "Package, cardboard, with bottle grip-holes",
    secondary:
      "Packaging material made out of cardboard that facilitates the separation of individual glass or plastic bottles.",
  },
  {
    value: "XIL",
    title: "Tray, rigid, lidded stackable (CEN TS 14482:2002)",
    secondary: "Lidded stackable rigid tray compliant with CEN TS 14482:2002.",
  },
  {
    value: "XIN",
    title: "Ingot",
  },
  {
    value: "XIZ",
    title: "Ingots, in bundle/bunch/truss",
  },
  {
    value: "XJB",
    title: "Bag, jumbo",
    secondary:
      "A flexible containment bag, widely used for storage, transportation and handling of powder, flake or granular materials. Typically constructed from woven polypropylene (PP) fabric in the form of cubic bags.",
  },
  {
    value: "XJC",
    title: "Jerrican, rectangular",
  },
  {
    value: "XJG",
    title: "Jug",
  },
  {
    value: "XJR",
    title: "Jar",
  },
  {
    value: "XJT",
    title: "Jutebag",
  },
  {
    value: "XJY",
    title: "Jerrican, cylindrical",
  },
  {
    value: "XKG",
    title: "Keg",
  },
  {
    value: "XKI",
    title: "Kit",
    secondary: "A set of articles or implements used for a specific purpose.",
  },
  {
    value: "XLE",
    title: "Luggage",
    secondary: "A collection of bags, cases and/or containers which hold personal belongings for a journey.",
  },
  {
    value: "XLG",
    title: "Log",
  },
  {
    value: "XLT",
    title: "Lot",
  },
  {
    value: "XLU",
    title: "Lug",
    secondary: "A wooden box for the transportation and storage of fruit or vegetables.",
  },
  {
    value: "XLV",
    title: "Liftvan",
    secondary: "A wooden or metal container used for packing household goods and personal effects.",
  },
  {
    value: "XLZ",
    title: "Logs, in bundle/bunch/truss",
  },
  {
    value: "XMA",
    title: "Crate, metal",
    secondary: "Containment box made of metal for retaining substances or articles.",
  },
  {
    value: "XMB",
    title: "Bag, multiply",
  },
  {
    value: "XMC",
    title: "Crate, milk",
  },
  {
    value: "XME",
    title: "Container, metal",
    secondary:
      "A type of containment box made of metal for retaining substances or articles, not otherwise specified as transport equipment.",
  },
  {
    value: "XMR",
    title: "Receptacle, metal",
    secondary: "Containment vessel made of metal for retaining substances or articles.",
  },
  {
    value: "XMS",
    title: "Sack, multi-wall",
  },
  {
    value: "XMT",
    title: "Mat",
  },
  {
    value: "XMW",
    title: "Receptacle, plastic wrapped",
    secondary: "Containment vessel wrapped with plastic for retaining substances or articles.",
  },
  {
    value: "XMX",
    title: "Matchbox",
  },
  {
    value: "XNA",
    title: "Not available",
  },
  {
    value: "XNE",
    title: "Unpacked or unpackaged",
  },
  {
    value: "XNF",
    title: "Unpacked or unpackaged, single unit",
  },
  {
    value: "XNG",
    title: "Unpacked or unpackaged, multiple units",
  },
  {
    value: "XNS",
    title: "Nest",
  },
  {
    value: "XNT",
    title: "Net",
  },
  {
    value: "XNU",
    title: "Net, tube, plastic",
  },
  {
    value: "XNV",
    title: "Net, tube, textile",
  },
  {
    value: "XO1",
    title: "Two sided cage on wheels with fixing strap",
  },
  {
    value: "XO2",
    title: "Trolley",
  },
  {
    value: "XO3",
    title: "Oneway pallet ISO 0 - 1/2 EURO Pallet",
  },
  {
    value: "XO4",
    title: "Oneway pallet ISO 1 - 1/1 EURO Pallet",
  },
  {
    value: "XO5",
    title: "Oneway pallet ISO 2 - 2/1 EURO Pallet",
  },
  {
    value: "XO6",
    title: "Pallet with exceptional dimensions",
  },
  {
    value: "XO7",
    title: "Wooden pallet 40 cm x 80 cm",
  },
  {
    value: "XO8",
    title: "Plastic pallet SRS 60 cm x 80 cm",
  },
  {
    value: "XO9",
    title: "Plastic pallet SRS 80 cm x 120 cm",
  },
  {
    value: "XOA",
    title: "Pallet, CHEP 40 cm x 60 cm",
    secondary:
      "Commonwealth Handling Equipment Pool (CHEP) standard pallet of dimensions 40 centimeters x 60 centimeters.",
  },
  {
    value: "XOB",
    title: "Pallet, CHEP 80 cm x 120 cm",
    secondary:
      "Commonwealth Handling Equipment Pool (CHEP) standard pallet of dimensions 80 centimeters x 120 centimeters.",
  },
  {
    value: "XOC",
    title: "Pallet, CHEP 100 cm x 120 cm",
    secondary:
      "Commonwealth Handling Equipment Pool (CHEP) standard pallet of dimensions 100 centimeters x 120 centimeters.",
  },
  {
    value: "XOD",
    title: "Pallet, AS 4068-1993",
    secondary: "Australian standard pallet of dimensions 115.5 centimeters x 116.5 centimeters.",
  },
  {
    value: "XOE",
    title: "Pallet, ISO T11",
    secondary:
      "ISO standard pallet of dimensions 110 centimeters x 110 centimeters, prevalent in Asia - Pacific region.",
  },
  {
    value: "XOF",
    title: "Platform, unspecified weight or dimension",
    secondary: "A pallet equivalent shipping platform of unknown dimensions or unknown weight.",
  },
  {
    value: "XOG",
    title: "Pallet ISO 0 - 1/2 EURO Pallet",
  },
  {
    value: "XOH",
    title: "Pallet ISO 1 - 1/1 EURO Pallet",
  },
  {
    value: "XOI",
    title: "Pallet ISO 2 – 2/1 EURO Pallet",
  },
  {
    value: "XOK",
    title: "Block",
    secondary: "A solid piece of a hard substance, such as granite, having one or more flat sides.",
  },
  {
    value: "XOJ",
    title: "1/4 EURO Pallet",
  },
  {
    value: "XOL",
    title: "1/8 EURO Pallet",
  },
  {
    value: "XOM",
    title: "Synthetic pallet ISO 1",
  },
  {
    value: "XON",
    title: "Synthetic pallet ISO 2",
  },
  {
    value: "XOP",
    title: "Wholesaler pallet",
  },
  {
    value: "XOQ",
    title: "Pallet 80 X 100 cm",
  },
  {
    value: "XOR",
    title: "Pallet 60 X 100 cm",
  },
  {
    value: "XOS",
    title: "Oneway pallet",
  },
  {
    value: "XOV",
    title: "Returnable pallet",
  },
  {
    value: "XOW",
    title: "Large bag, pallet sized",
  },
  {
    value: "XOT",
    title: "Octabin",
    secondary:
      "A standard cardboard container of large dimensions for storing for example vegetables, granules of plastics or other dry products.",
  },
  {
    value: "XOU",
    title: "Container, outer",
    secondary:
      "A type of containment box that serves as the outer shipping container, not otherwise specified as transport equipment.",
  },
  {
    value: "XOX",
    title: "A wheeled pallet with raised rim (81 x 67 x 135)",
  },
  {
    value: "XOY",
    title: "A Wheeled pallet with raised rim (81 x 72 x 135)",
  },
  {
    value: "XOZ",
    title: "Wheeled pallet with raised rim ( 81 x 60 x 16)",
  },
  {
    value: "XP1",
    title: "CHEP pallet 60 cm x 80 cm",
  },
  {
    value: "XP2",
    title: "Pan",
    secondary: "A shallow, wide, open container, usually of metal.",
  },
  {
    value: "XP3",
    title: "LPR pallet 60 cm x 80 cm",
  },
  {
    value: "XP4",
    title: "LPR pallet 80 cm x 120 cm",
  },
  {
    value: "XPA",
    title: "Packet",
    secondary: "Small package.",
  },
  {
    value: "XPB",
    title: "Pallet, box Combined open-ended box and pallet",
  },
  {
    value: "XPC",
    title: "Parcel",
  },
  {
    value: "XPD",
    title: "Pallet, modular, collars 80cms * 100cms",
    secondary: "Standard sized pallet of dimensions 80 centimeters by 100 centimeters (cms).",
  },
  {
    value: "XPE",
    title: "Pallet, modular, collars 80cms * 120cms",
    secondary: "Standard sized pallet of dimensions 80 centimeters by 120 centimeters (cms).",
  },
  {
    value: "XPF",
    title: "Pen",
    secondary: "A small open top enclosure for retaining animals.",
  },
  {
    value: "XPG",
    title: "Plate",
  },
  {
    value: "XPH",
    title: "Pitcher",
  },
  {
    value: "XPI",
    title: "Pipe",
  },
  {
    value: "XPJ",
    title: "Punnet",
  },
  {
    value: "XPK",
    title: "Package",
    secondary: "Standard packaging unit.",
  },
  {
    value: "XPL",
    title: "Pail",
  },
  {
    value: "XPN",
    title: "Plank",
  },
  {
    value: "XPO",
    title: "Pouch",
  },
  {
    value: "XPP",
    title: "Piece",
    secondary: "A loose or unpacked article.",
  },
  {
    value: "XPR",
    title: "Receptacle, plastic",
    secondary: "Containment vessel made of plastic for retaining substances or articles.",
  },
  {
    value: "XPT",
    title: "Pot",
  },
  {
    value: "XPU",
    title: "Tray",
  },
  {
    value: "XPV",
    title: "Pipes, in bundle/bunch/truss",
  },
  {
    value: "XPX",
    title: "Pallet",
    secondary:
      "Platform or open-ended box, usually made of wood, on which goods are retained for ease of mechanical handling during transport and storage.",
  },
  {
    value: "XPY",
    title: "Plates, in bundle/bunch/truss",
  },
  {
    value: "XPZ",
    title: "Planks, in bundle/bunch/truss",
  },
  {
    value: "XQA",
    title: "Drum, steel, non-removable head",
  },
  {
    value: "XQB",
    title: "Drum, steel, removable head",
  },
  {
    value: "XQC",
    title: "Drum, aluminium, non-removable head",
  },
  {
    value: "XQD",
    title: "Drum, aluminium, removable head",
  },
  {
    value: "XQF",
    title: "Drum, plastic, non-removable head",
  },
  {
    value: "XQG",
    title: "Drum, plastic, removable head",
  },
  {
    value: "XQH",
    title: "Barrel, wooden, bung type",
  },
  {
    value: "XQJ",
    title: "Barrel, wooden, removable head",
  },
  {
    value: "XQK",
    title: "Jerrican, steel, non-removable head",
  },
  {
    value: "XQL",
    title: "Jerrican, steel, removable head",
  },
  {
    value: "XQM",
    title: "Jerrican, plastic, non-removable head",
  },
  {
    value: "XQN",
    title: "Jerrican, plastic, removable head",
  },
  {
    value: "XQP",
    title: "Box, wooden, natural wood, ordinary",
  },
  {
    value: "XQQ",
    title: "Box, wooden, natural wood, with sift proof walls",
  },
  {
    value: "XQR",
    title: "Box, plastic, expanded",
  },
  {
    value: "XQS",
    title: "Box, plastic, solid",
  },
  {
    value: "XRD",
    title: "Rod",
  },
  {
    value: "XRG",
    title: "Ring",
  },
  {
    value: "XRJ",
    title: "Rack, clothing hanger",
  },
  {
    value: "XRK",
    title: "Rack",
  },
  {
    value: "XRL",
    title: "Reel",
    secondary: "Cylindrical rotatory device with a rim at each end on which materials are wound.",
  },
  {
    value: "XRO",
    title: "Roll",
  },
  {
    value: "XRT",
    title: "Rednet",
    secondary: "Containment material made of red mesh netting for retaining articles (e.g. trees).",
  },
  {
    value: "XRZ",
    title: "Rods, in bundle/bunch/truss",
  },
  {
    value: "XSA",
    title: "Sack",
  },
  {
    value: "XSB",
    title: "Slab",
  },
  {
    value: "XSC",
    title: "Crate, shallow",
  },
  {
    value: "XSD",
    title: "Spindle",
  },
  {
    value: "XSE",
    title: "Sea-chest",
  },
  {
    value: "XSH",
    title: "Sachet",
  },
  {
    value: "XSI",
    title: "Skid",
    secondary: "A low movable platform or pallet to facilitate the handling and transport of goods.",
  },
  {
    value: "XSK",
    title: "Case, skeleton",
  },
  {
    value: "XSL",
    title: "Slipsheet",
    secondary:
      "Hard plastic sheeting primarily used as the base on which to stack goods to optimise the space within a container. May be used as an alternative to a palletized packaging.",
  },
  {
    value: "XSM",
    title: "Sheetmetal",
  },
  {
    value: "XSO",
    title: "Spool",
    secondary: "A packaging container used in the transport of such items as wire, cable, tape and yarn.",
  },
  {
    value: "XSP",
    title: "Sheet, plastic wrapping",
  },
  {
    value: "XSS",
    title: "Case, steel",
  },
  {
    value: "XST",
    title: "Sheet",
  },
  {
    value: "XSU",
    title: "Suitcase",
  },
  {
    value: "XSV",
    title: "Envelope, steel",
  },
  {
    value: "XSW",
    title: "Shrinkwrapped",
    secondary:
      "Goods retained in a transparent plastic film that has been wrapped around and then shrunk tightly on to the goods.",
  },
  {
    value: "XSX",
    title: "Set",
  },
  {
    value: "XSY",
    title: "Sleeve",
  },
  {
    value: "XSZ",
    title: "Sheets, in bundle/bunch/truss",
  },
  {
    value: "XT1",
    title: "Tablet",
    secondary: "A loose or unpacked article in the form of a bar, block or piece.",
  },
  {
    value: "XTB",
    title: "Tub",
  },
  {
    value: "XTC",
    title: "Tea-chest",
  },
  {
    value: "XTD",
    title: "Tube, collapsible",
  },
  {
    value: "XTE",
    title: "Tyre",
    secondary: "A ring made of rubber and/or metal surrounding a wheel.",
  },
  {
    value: "XTG",
    title: "Tank container, generic",
    secondary: "A specially constructed container for transporting liquids and gases in bulk.",
  },
  {
    value: "XTI",
    title: "Tierce",
  },
  {
    value: "XTK",
    title: "Tank, rectangular",
  },
  {
    value: "XTL",
    title: "Tub, with lid",
  },
  {
    value: "XTN",
    title: "Tin",
  },
  {
    value: "XTO",
    title: "Tun",
  },
  {
    value: "XTR",
    title: "Trunk",
  },
  {
    value: "XTS",
    title: "Truss",
  },
  {
    value: "XTT",
    title: "Bag, tote",
    secondary: "A capacious bag or basket.",
  },
  {
    value: "XTU",
    title: "Tube",
  },
  {
    value: "XTV",
    title: "Tube, with nozzle",
    secondary:
      "A tube made of plastic, metal or cardboard fitted with a nozzle, containing a liquid or semi-liquid product, e.g. silicon.",
  },
  {
    value: "XTW",
    title: "Pallet, triwall",
    secondary: "A lightweight pallet made from heavy duty corrugated board.",
  },
  {
    value: "XTY",
    title: "Tank, cylindrical",
  },
  {
    value: "XTZ",
    title: "Tubes, in bundle/bunch/truss",
  },
  {
    value: "XUC",
    title: "Uncaged",
  },
  {
    value: "XUN",
    title: "Unit",
    secondary:
      "A type of package composed of a single item or object, not otherwise specified as a unit of transport equipment.",
  },
  {
    value: "XVA",
    title: "Vat",
  },
  {
    value: "XVG",
    title: "Bulk, gas (at 1031 mbar and 15°C)",
  },
  {
    value: "XVI",
    title: "Vial",
  },
  {
    value: "XVK",
    title: "Vanpack",
    secondary: "A type of wooden crate.",
  },
  {
    value: "XVL",
    title: "Bulk, liquid",
  },
  {
    value: "XVO",
    title: "Bulk, solid, large particles (“nodules”)",
  },
  {
    value: "XVP",
    title: "Vacuum-packed",
  },
  {
    value: "XVQ",
    title: "Bulk, liquefied gas (at abnormal temperature/pressure)",
  },
  {
    value: "XVN",
    title: "Vehicle",
    secondary: "A self-propelled means of conveyance.",
  },
  {
    value: "XVR",
    title: "Bulk, solid, granular particles (“grains”)",
  },
  {
    value: "XVS",
    title: "Bulk, scrap metal",
    secondary: "Loose or unpacked scrap metal transported in bulk form.",
  },
  {
    value: "XVY",
    title: "Bulk, solid, fine particles (“powders”)",
  },
  {
    value: "XWA",
    title: "Intermediate bulk container",
    secondary:
      "A reusable container made of metal, plastic, textile, wood or composite materials used to facilitate transportation of bulk solids and liquids in manageable volumes.",
  },
  {
    value: "XWB",
    title: "Wickerbottle",
  },
  {
    value: "XWC",
    title: "Intermediate bulk container, steel",
  },
  {
    value: "XWD",
    title: "Intermediate bulk container, aluminium",
  },
  {
    value: "XWF",
    title: "Intermediate bulk container, metal",
  },
  {
    value: "XWG",
    title: "Intermediate bulk container, steel, pressurised > 10 kpa",
  },
  {
    value: "XWH",
    title: "Intermediate bulk container, aluminium, pressurised > 10 kpa",
  },
  {
    value: "XWJ",
    title: "Intermediate bulk container, metal, pressure 10 kpa",
  },
  {
    value: "XWK",
    title: "Intermediate bulk container, steel, liquid",
  },
  {
    value: "XWL",
    title: "Intermediate bulk container, aluminium, liquid",
  },
  {
    value: "XWM",
    title: "Intermediate bulk container, metal, liquid",
  },
  {
    value: "XWN",
    title: "Intermediate bulk container, woven plastic, without coat/liner",
  },
  {
    value: "XWP",
    title: "Intermediate bulk container, woven plastic, coated",
  },
  {
    value: "XWQ",
    title: "Intermediate bulk container, woven plastic, with liner",
  },
  {
    value: "XWR",
    title: "Intermediate bulk container, woven plastic, coated and liner",
  },
  {
    value: "XWS",
    title: "Intermediate bulk container, plastic film",
  },
  {
    value: "XWT",
    title: "Intermediate bulk container, textile with out coat/liner",
  },
  {
    value: "XWU",
    title: "Intermediate bulk container, natural wood, with inner liner",
  },
  {
    value: "XWV",
    title: "Intermediate bulk container, textile, coated",
  },
  {
    value: "XWW",
    title: "Intermediate bulk container, textile, with liner",
  },
  {
    value: "XWX",
    title: "Intermediate bulk container, textile, coated and liner",
  },
  {
    value: "XWY",
    title: "Intermediate bulk container, plywood, with inner liner",
  },
  {
    value: "XWZ",
    title: "Intermediate bulk container, reconstituted wood, with inner liner",
  },
  {
    value: "XXA",
    title: "Bag, woven plastic, without inner coat/liner",
  },
  {
    value: "XXB",
    title: "Bag, woven plastic, sift proof",
  },
  {
    value: "XXC",
    title: "Bag, woven plastic, water resistant",
  },
  {
    value: "XXD",
    title: "Bag, plastics film",
  },
  {
    value: "XXF",
    title: "Bag, textile, without inner coat/liner",
  },
  {
    value: "XXG",
    title: "Bag, textile, sift proof",
  },
  {
    value: "XXH",
    title: "Bag, textile, water resistant",
  },
  {
    value: "XXJ",
    title: "Bag, paper, multi-wall",
  },
  {
    value: "XXK",
    title: "Bag, paper, multi-wall, water resistant",
  },
  {
    value: "XYA",
    title: "Composite packaging, plastic receptacle in steel drum",
  },
  {
    value: "XYB",
    title: "Composite packaging, plastic receptacle in steel crate box",
  },
  {
    value: "XYC",
    title: "Composite packaging, plastic receptacle in aluminium drum",
  },
  {
    value: "XYD",
    title: "Composite packaging, plastic receptacle in aluminium crate",
  },
  {
    value: "XYF",
    title: "Composite packaging, plastic receptacle in wooden box",
  },
  {
    value: "XYG",
    title: "Composite packaging, plastic receptacle in plywood drum",
  },
  {
    value: "XYH",
    title: "Composite packaging, plastic receptacle in plywood box",
  },
  {
    value: "XYJ",
    title: "Composite packaging, plastic receptacle in fibre drum",
  },
  {
    value: "XYK",
    title: "Composite packaging, plastic receptacle in fibreboard box",
  },
  {
    value: "XYL",
    title: "Composite packaging, plastic receptacle in plastic drum",
  },
  {
    value: "XYM",
    title: "Composite packaging, plastic receptacle in solid plastic box",
  },
  {
    value: "XYN",
    title: "Composite packaging, glass receptacle in steel drum",
  },
  {
    value: "XYP",
    title: "Composite packaging, glass receptacle in steel crate box",
  },
  {
    value: "XYQ",
    title: "Composite packaging, glass receptacle in aluminium drum",
  },
  {
    value: "XYR",
    title: "Composite packaging, glass receptacle in aluminium crate",
  },
  {
    value: "XYS",
    title: "Composite packaging, glass receptacle in wooden box",
  },
  {
    value: "XYT",
    title: "Composite packaging, glass receptacle in plywood drum",
  },
  {
    value: "XYV",
    title: "Composite packaging, glass receptacle in wickerwork hamper",
  },
  {
    value: "XYW",
    title: "Composite packaging, glass receptacle in fibre drum",
  },
  {
    value: "XYX",
    title: "Composite packaging, glass receptacle in fibreboard box",
  },
  {
    value: "XYY",
    title: "Composite packaging, glass receptacle in expandable plastic pack",
  },
  {
    value: "XYZ",
    title: "Composite packaging, glass receptacle in solid plastic pack",
  },
  {
    value: "XZA",
    title: "Intermediate bulk container, paper, multi-wall",
  },
  {
    value: "XZB",
    title: "Bag, large",
  },
  {
    value: "XZC",
    title: "Intermediate bulk container, paper, multi-wall, water resistant",
  },
  {
    value: "XZD",
    title: "Intermediate bulk container, rigid plastic, with structural equipment, solids",
  },
  {
    value: "XZF",
    title: "Intermediate bulk container, rigid plastic, freestanding, solids",
  },
  {
    value: "XZG",
    title: "Intermediate bulk container, rigid plastic, with structural equipment, pressurised",
  },
  {
    value: "XZH",
    title: "Intermediate bulk container, rigid plastic, freestanding, pressurised",
  },
  {
    value: "XZJ",
    title: "Intermediate bulk container, rigid plastic, with structural equipment, liquids",
  },
  {
    value: "XZK",
    title: "Intermediate bulk container, rigid plastic, freestanding, liquids",
  },
  {
    value: "XZL",
    title: "Intermediate bulk container, composite, rigid plastic, solids",
  },
  {
    value: "XZM",
    title: "Intermediate bulk container, composite, flexible plastic, solids",
  },
  {
    value: "XZN",
    title: "Intermediate bulk container, composite, rigid plastic, pressurised",
  },
  {
    value: "XZP",
    title: "Intermediate bulk container, composite, flexible plastic, pressurised",
  },
  {
    value: "XZQ",
    title: "Intermediate bulk container, composite, rigid plastic, liquids",
  },
  {
    value: "XZR",
    title: "Intermediate bulk container, composite, flexible plastic, liquids",
  },
  {
    value: "XZS",
    title: "Intermediate bulk container, composite",
  },
  {
    value: "XZT",
    title: "Intermediate bulk container, fibreboard",
  },
  {
    value: "XZU",
    title: "Intermediate bulk container, flexible",
  },
  {
    value: "XZV",
    title: "Intermediate bulk container, metal, other than steel",
  },
  {
    value: "XZW",
    title: "Intermediate bulk container, natural wood",
  },
  {
    value: "XZX",
    title: "Intermediate bulk container, plywood",
  },
  {
    value: "XZY",
    title: "Intermediate bulk container, reconstituted wood",
  },
  {
    value: "XZZ",
    title: "Mutually defined",
  },
]
